var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvmcImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430.54 250.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040156;}.cls-2{fill:#e87e4a;}.cls-3{fill:#d64a37;}.cls-4{fill:#fff;}.cls-5{fill:#e7efc8;}.cls-6{fill:#172d38;}.cls-7{fill:#dfefe4;}.cls-8{fill:#ce982b;}.cls-9{fill:#2d5270;}.cls-10{opacity:.5;}.cls-11{fill:#ffffa1;}.cls-11,.cls-12,.cls-13{opacity:.1;}.cls-14{fill:#aec170;}.cls-15{fill:silver;}.cls-16{fill:#f0f3f4;}.cls-17{fill:#593f2b;}.cls-18{fill:#8eb95a;}.cls-19{fill:#f4abab;}.cls-20{fill:#ffe58d;}.cls-21{opacity:.06;}.cls-22{fill:#d2a865;}.cls-23{fill:#e1e6b4;}.cls-24{fill:#5c86d1;}.cls-25{fill:#888887;}.cls-26{fill:#c7dcad;}.cls-27{fill:#5dbdd1;}.cls-28{opacity:.2;}.cls-29{fill:#ffd000;}.cls-30{fill:#695976;}.cls-31{fill:#010131;}.cls-32{opacity:.05;}.cls-33{fill:#fec851;}.cls-34{fill:#e4e8ba;}.cls-35{fill:#7d9a99;}.cls-36{fill:#ffebaa;}.cls-37{opacity:.07;}.cls-38{fill:#9fb555;}.cls-39{fill:#4bb375;}.cls-40{fill:#a3a8aa;}.cls-41{fill:#c9d5db;}.cls-42{fill:#f3c705;}.cls-43{fill:#bcd46c;}.cls-44{fill:#d6b386;}.cls-45{fill:#d3e39f;}.cls-46{fill:#ff7367;}.cls-47{fill:#6d6e71;}.cls-48{fill:#b45f22;}.cls-49{fill:#819ba9;}.cls-50{fill:#5b8ed4;}.cls-51{fill:#7995a4;}.cls-52{fill:#c09256;}.cls-53{opacity:.3;}.cls-54{fill:#dadada;}.cls-55{fill:#856451;}.cls-56{fill:#f8be8c;}.cls-57{fill:#b0ce8b;}.cls-58{fill:#845549;}.cls-59{fill:#8cc04c;}.cls-60{fill:#d9b57c;}.cls-61{fill:#97ab51;}.cls-62{fill:#73882c;}.cls-63{fill:#9cc0e9;}.cls-64{fill:#fede97;}.cls-65{fill:#cdd7dd;}.cls-66{fill:#e3f3f4;}.cls-67{fill:#d9e0e3;}.cls-68{fill:#364242;}.cls-69{fill:#808285;}.cls-70{fill:none;stroke:#b0aeae;stroke-miterlimit:10;stroke-width:4px;}.cls-71{fill:#c8dfdf;}.cls-72{fill:#92a745;}.cls-73{fill:#5b6b23;}.cls-74{fill:#9dac6b;opacity:.6;}.cls-75{fill:#6a7f29;}.cls-76{fill:#0462c4;}.cls-77{fill:#777b7d;}.cls-78{fill:#d5dee2;}.cls-79{fill:#cf966a;}.cls-80{fill:#2d5970;}.cls-81{fill:#d1d3d4;}.cls-13{fill:#000100;}.cls-82{fill:#a7cdcc;}.cls-83{fill:#fbfeff;}.cls-84{fill:#ac8c51;}.cls-85{fill:#a6abad;}.cls-86{fill:#f9ae06;}.cls-87{fill:#bfd7a1;}.cls-88{fill:#e6e7e8;}.cls-89{fill:#f7f8f9;}.cls-90{fill:#869c41;}.cls-91{fill:#302a2a;}.cls-92{fill:#638f4c;}.cls-93{fill:#ce9b25;}.cls-94{fill:#231f20;}.cls-95{fill:#8da244;}.cls-96{fill:#b9d364;}.cls-97{fill:#e09d9d;}.cls-98{fill:#c47939;}.cls-99{fill:#f6ac6c;}.cls-100{fill:#58595b;}.cls-101{fill:#414042;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m402.44,214.92c38.87-52.36,7.31-133.43-52.93-163.55-23.53-11.77-25.98-3.03-90.07-20.89C192.78,11.9,180.6-1.9,151.72.21c-49.22,3.6-43.08,21.33-91,59.08-30.19,23.78-37.95,33-43.64,41.79-4.75,7.33-19.54,32.06-16.71,59.08,5.09,48.7,64.71,79.21,84.5,89.34,90.07-.36,162.54-7.68,273.01,0,14.15-7.53,31.52-17,44.57-34.58Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 18.11,
    y1: 248.3,
    x2: 430.54,
    y2: 248.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "328.03 149.63 327.42 180.3 340.73 180.07 334.08 151.23 328.03 149.63"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m310.69,237.47l-3.77,3.57c-4.17,1.19-4.77,5.03-4.77,5.03h18.04c.7-4.59-1.32-8.64-1.32-8.64l-8.17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m358.5,241.28l-3.77-3.57-8.17-.04s-2.03,4.06-1.32,8.64h18.04s-.6-3.84-4.77-5.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "351.82 137.48 334.41 134.72 334.45 134.14 333.23 134.53 330.77 134.14 330.85 135.29 312.93 141.03 312.42 182.15 309.87 237.52 319.74 238.44 326.43 193.87 332.61 157.77 338.79 193.87 345.47 238.44 354.64 237.52 352.8 182.15 351.82 137.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m334.41,134.72l.04-.58-1.22.39-2.46-.39.08,1.15-17.92,5.74-.51,41.12-2.19,47.53c.48-4.82,1.09-9.63,1.38-14.43.54-9.21.71-18.45,1.57-27.64.66-7.05,2.42-32.09,3.25-35.11,2.55-9.22,12.38-9.95,21.67-9.45,13.78.75,11.88,12.57,12.87,20.47.4,3.21,1.06,6.33,1.41,9.49,0,.02,0,.04.01.06.1.52.17,1.04.25,1.56l-.82-37.14-17.41-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m351.68,75.33c-25.5-8.04-42.7,1.84-42.7,1.84l4.51,33.31-.56,30.55h39.1c-.23-2.3.16-27.57.16-27.57l-.51-38.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m324.12,72.69c-11.27.93-15.14,4.48-15.14,4.48l4.51,33.31-3.97,69.29,17.9.54,1.53-76.96s-3.99-30.72-4.83-30.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m351.68,75.33c-4.88-1.54-8.33-2.73-12.54-3.15-1.94-.19-4.41,26.8-5.52,31.17l3.6,76.96,21.37-1.43c-.23-2.3-6.4-65.4-6.4-65.4l-.51-38.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m345.3,100.78c-9.08,3.02-25.29,2.53-29.53-.93-.96-.79-1.34-2.1-1.95-5.59l-.34,16.22-3.97,69.29c.37-.18,5.53-56.37,7.2-57.21,2.03-1.01,6.37-2.33,8.52-2.8,10.39-2.32,16.6-3.61,26.94-6.55l-4.2-20.47c-2.15,2.51-.35,7.28-2.68,8.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m314.75,108.41l-5.72-31.24s-2.53,2.3-2.53,5.97-.68,31.12.01,32.03c.69.92.78,5.47,9.84,4.95,5.51-.31,27.92-5.51,27.92-5.51l-.81-5.97-28.72-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m314.75,108.41l-1.24-6.77c-.51,2.33-2.3,4.32-5.38,4.32-.71,0-1.35-.11-1.92-.3-.01,3.96.02,7.28.16,8.73,2.12,1,10.34-1.75,14.2-1.57,2.05.09,20.55,3.29,25.51,2.81l-2.61-6.99-28.72-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m319.2,103.17l-3.79-2.6-6.72-1.93s-.52,1.17.95,1.93,2.15,1.42,2.15,1.42c0,0,.26.5-.86.67-1.12.17-4.57,1.09-4.57,1.09l-2.24,2.93s-.17.67.26,1.09c0,0-.09,2.18.34,2.6,0,0,.09,1.93.95,1.84l.6.17s-.43,1.93.6,1.84c1.03-.08,2.41-1.51,2.41-1.51l6.55-.75s2.15-.92,3.02-1.84l5.08-.08-.69-6.2-4.05-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m323.53,109.19c-3.02.21-6.12.13-9.02,1.09-3.67,1.22-6.59,1.44-9.7-1.22-.15-.13-.29-.27-.42-.41.02.66.1,1.48.34,1.72,0,0,.09,1.93.95,1.84l.6.17s-.43,1.93.6,1.84c1.03-.08,2.41-1.51,2.41-1.51l6.55-.75s2.15-.92,3.02-1.84l5.08-.08-.1-.88c-.1.01-.21.03-.31.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m351.64,75.33l-4.9,14.99,1.16,13.67-25.28-.86v8.17s23.73,6.14,29.07,6.14,6.03-9.13,6.03-9.82-1.85-22.63-2.36-26.59c-.52-3.96-3.71-5.68-3.71-5.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m336.66,62.49l-10.85,2.76-.71,6.64c-.34,3.57,2.46,6.66,6.05,6.66s6.25-2.92,6.07-6.4l-.55-9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m325.8,65.25l-.36,3.34c.64.45,1.56,3.01,2.14,3.59,5.09,5.07,8.43-1.63,9.38-4.27l-.31-5.42-10.85,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m331.21,45.35c-5.36,0-9.24,4.17-9.24,9.3,0,.61.07,1.22.18,1.82l.03.41s.39,6.59,1.62,8.54c1.32,2.09,3.27,3.9,3.66,4.24.7.84,1.87,1.36,3.75,1.36,1.98,0,3.13-.47,3.8-1.24v.03s2.14-2.07,3.61-4.39c.84-1.33,1.34-6.14,1.61-8.4.08-2.6.41-1.68.41-2.85,0-5.14-4.06-8.82-9.43-8.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m320.93,57.04c-.26.86.69,3.53.78,4.05.09.52.57,2.32,1.43,1.97.86-.34-.66-5.94-.66-5.94,0,0-1.29-.95-1.55-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m340.16,57.04s-1.64,5.77-.78,6.12,1.21-1.55,1.29-2.07c.09-.52,1.03-3.19.78-4.05-.26-.86-1.29,0-1.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m337.06,43.78c-1.27-.43-5.21-1.45-7.96-1.21-2.75.24-6.96,2.94-7.55,5.63-.72,3.25.49,8.41.57,8.93.09.52,1.37,1.97,1.37,1.97,0,0-.16-6.06,1.39-8.39,1.31-1.97,11.98-.77,13.1-.08,1.12.69,1.39,8.55,1.39,8.55.78-.84,1.54-4.34,1.58-5.47.13-3.33-.51-5.64-.8-6.11-.44-.69-.04-2.78-3.1-3.82Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "342.27 99.92 338.09 103.51 349.53 104.07 347.44 99.58 342.27 99.92"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m327.54,68.74c0,1.7,1.37,3.08,3.07,3.08h1.92c1.74,0,3.15-1.66,3.15-3.4v-1.85h-8.14v2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m331.3,67.87c1.45,0,2.62-1.16,2.62-2.59h-5.25c0,1.43,1.18,2.59,2.62,2.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m333.35,64.19h-2.22c0,1.56,1.35,2.83,3.02,2.83h2.22c0-1.56-1.35-2.83-3.02-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "m326.23,67.02h2.22c1.67,0,3.02-1.27,3.02-2.83h-2.22c-1.67,0-3.02,1.27-3.02,2.83Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m325.18,70.97l-2.57,1.86c-.08,3.91,3.62,6.89,3.62,6.89l2.62-2.55c-2.88-2.58-3.67-6.19-3.67-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m328.22,77.79c.69.35,1.39.55,1.39.55l-.76-1.18-.63.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m333.46,77.17l2.62,2.55s3.76-3.12,3.69-7.03l-2.64-1.71s-.79,3.62-3.67,6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "m332.7,78.35s.7-.21,1.39-.55l-.63-.63-.76,1.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "339 91.02 339.13 91.54 346.78 92.43 346.66 91.91 339 91.02"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m346.48,93.14h-7.18c-.19,0-.35.15-.35.33v3.92c0,.18.16.33.35.33h7.18c.19,0,.35-.15.35-.33v-3.92c0-.18-.16-.33-.35-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m343.49,91.27c-.02-.06-.06-.1-.11-.13-.02-.01-.03-.02-.05-.03-.01,0-.02-.02-.04-.02h-.73c-.16,0-.29.15-.29.33v.72c0,.15.09.27.21.31v.68h.85v-.68c.12-.04.21-.16.21-.31v-.77s-.01-.03-.02-.05c0-.02-.01-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 338.95,
    y: 96.17,
    width: 7.88,
    height: 0.92
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 339.81,
    y: 94.26,
    width: 3.29,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 339.81,
    y: 94.93,
    width: 3.29,
    height: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 344.17,
    y: 93.86,
    width: 1.78,
    height: 1.83
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m324.02,71.58l-3.55,1.49-.47,7.08,3.41.76-2.45,2.41c1.97,3.35,8,20.03,8,20.03,0,0,0-4.7-.73-10.3-.39-2.99-4.2-21.46-4.2-21.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m341.72,72.56l-3.55-1.49s-3.43,18.98-3.82,21.97c-.73,5.61-.73,10.3-.73,10.3,0,0,6.02-16.68,8-20.03l-2.45-2.41,3.41-.76-.85-7.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m323.81,85.37l-.49.15s.74,2.28.94,5.32c.19,2.79-.05,6.84-2.24,10.25-.13.21-.33.33-.6.4-1.43.32-4.16-1.31-4.18-1.32l-.28.42c.12.07,2.93,1.75,4.58,1.39.41-.09.72-.3.93-.62,2.26-3.52,2.5-7.68,2.31-10.55-.21-3.1-.96-5.4-.97-5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m317.3,99.91l-.83-.48c-.25-.14-.57-.07-.72.16-.15.24-.08.54.17.69l.83.48c.25.15.57.07.72-.16.15-.24.08-.54-.17-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m317.79,101.49c-.27-.06-.47-.19-.6-.4-2.19-3.41-2.42-7.46-2.24-10.25.2-3.04.94-5.3.94-5.32l-.49-.15s-.76,2.33-.97,5.43c-.19,2.87.05,7.02,2.31,10.55.2.32.52.53.93.62,1.64.37,4.46-1.32,4.58-1.39l-.28-.42s-2.75,1.64-4.18,1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m322.74,99.43l-.83.48c-.25.14-.32.45-.17.69.15.24.47.31.72.16l.83-.48c.25-.15.32-.45.17-.69-.15-.24-.48-.31-.72-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m319.54,82.41c-2.66,0-4.82,1.72-4.82,4.6h1.05c0-2.19,1.69-3.59,3.77-3.59s3.77,1.4,3.77,3.59h1.05c0-2.88-2.16-4.6-4.82-4.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m319.76,76.75c-.87,2.83-.73,5.77-.72,5.88l.74-.05s-.14-2.93.7-5.64c.88-2.84,2.46-4.84,4.69-6.01v-.02c.03-.28.06-.56.12-.84-2.64,1.22-4.54,3.49-5.53,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m337.07,69.87l.06.77c2.09,1.2,3.5,3.46,4.22,6.76.72,3.35.41,6.56.4,6.59l.89.08c.01-.14.33-3.35-.41-6.83-.93-4.32-2.28-5.67-5.16-7.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "m342.2,84.03c-1.42,0-2.56,1.09-2.56,2.43s1.15,2.43,2.56,2.43,2.56-1.09,2.56-2.43-1.15-2.43-2.56-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "m342.2,84.84c-1,0-1.82.73-1.82,1.63s.81,1.63,1.82,1.63,1.82-.73,1.82-1.63-.81-1.63-1.82-1.63Zm0,2.93c-.81,0-1.47-.58-1.47-1.3s.66-1.3,1.47-1.3,1.47.58,1.47,1.3-.66,1.3-1.47,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m342.2,83.73c-1.59,0-2.88,1.23-2.88,2.73s1.29,2.73,2.88,2.73,2.88-1.23,2.88-2.73-1.29-2.73-2.88-2.73Zm0,4.86c-1.24,0-2.25-.95-2.25-2.13s1.01-2.13,2.25-2.13,2.25.95,2.25,2.13-1.01,2.13-2.25,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m339.75,87.8c.49.8,1.4,1.34,2.45,1.34,1.56,0,2.82-1.2,2.82-2.68,0-.49-.14-.94-.38-1.34-1.88,2.88-4.68,2.61-4.89,2.67Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m383.7,230.61c-.34-1.8-1.03-9.94-1.03-9.94h-7.45s.77,4.46.86,5.06c.09.6.17,3.26.6,4.03.43.77.43,6.6.43,6.6l2.74,5.83h4.63l1.97-3.51-1.03-1.97s-1.37-4.28-1.71-6.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m385.42,236.7s1.2,2.57-.34,3.34-4.2.94-5.4.26-2.57-3.94-2.57-3.94c0,0-.17,1.66,0,2.57,0,0,.77,4.28,1.03,5.31.26,1.03,1.2,1.63,2.06,1.8s5.74.51,6.51,0c.77-.51.94-3,.86-4.03-.09-1.03-1.29-4.03-2.14-5.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m416.69,239.47c-.54-.54-2.7-9-2.7-9l-1.07-10.98-6.67,2.34v6.48s-2.41,2.49-2.34,4.32c.09,2.25,1.47,5.22,1.65,8.46.18,3.24.69,5.22.69,5.22h1.11l.69-6.66c1.79,2.6,1.78,2.52,2.88,4.5.9,1.62,1.99,2.07,1.99,2.07h7.8s1.55-1.89,1.01-2.79c-.54-.9-4.5-3.42-5.04-3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m418.49,240.8c-.1.02-.19.04-.3.05-.58.03-1.14,0-1.68-.11-6.45.09-8.72-5.15-11.1-11.44-.69.89-1.55,2.23-1.5,3.33.09,2.25,1.41,5.22,1.65,8.46.24,3.27.46,5.22.46,5.22h1.34l.69-6.66c1.79,2.6,1.78,2.52,2.88,4.5.9,1.62,1.99,2.07,1.99,2.07h8.44s.9-1.89.36-2.79c-.33-.55-1.92-1.69-3.24-2.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m386.17,46.61l-4.87.15c-4.49.14-8.02,3.9-7.87,8.4l-1.14,22.91,23.08-1.14-.8-22.44c-.14-4.5-3.9-8.03-8.39-7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m405.14,150.09l-3.48-24.08c-10.56,1.02-21.16.85-31.77.66-.81,2.53-1.87,7.07-2.01,13.78-.05,2.58,3.72,36.22,3.72,36.22,0,0-.26,8.85-.37,9.95-.39,4.04,1,18.67,4.07,39.97l7.72-.58s.36-37.91.36-40.49c0-1.82,2.18-23.47,3.46-36.09,1.51,4.09,11.78,31.98,13.18,35.84.63,1.73.93,12.88,1.63,17.53,1.37,9.14,4.41,23.91,4.41,23.91l8.13-.35s-2.39-37.04-3.13-41.09-5.92-35.17-5.92-35.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m369.89,126.66c-.81,2.53-1.87,7.07-2.01,13.78-.05,2.58,3.72,36.22,3.72,36.22,0,0-.26,8.85-.37,9.95-.39,4.04,1,18.67,4.07,39.97l7.72-.58s0-.01,0-.03c-2.71-4.42-4.2-9.6-5.09-14.92-1.93-11.53-2.96-23.12-3.29-34.81-.15-5.23-.03-10.47-.2-15.7-.12-3.52-.48-7.02-.39-10.54.1-3.66.48-7.58,2.34-10.82,1.84-3.2,5.28-4.91,8.71-5.86,5.48-1.53,11.56-1.8,17.42-1.33l-.86-5.97c-10.56,1.02-21.16.85-31.77.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m402.15,175.06c-1.19-3.54-14.4-31.17-15.4-30.8-.12.04-.29,9.13.11,5.16,1.51,4.09,11.78,31.98,13.18,35.84.63,1.73.93,12.88,1.63,17.53,1.37,9.14,4.41,23.91,4.41,23.91l8.13-.35s-5.76-9.92-9.6-39.06c-.55-4.17-1.1-8.22-2.45-12.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m403.4,79.51c-.93-2.9-6.15-3.83-6.15-3.83l2.57,24.51,1.35,5.94-12.35,3.49-.18,6.16c9.56-.71,17.52-2.05,19.38-2.98,1.86-.93,2.22-1.88,1.68-6.15-2.23-17.39-5.58-24.9-6.29-27.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m401.33,94.47c-.34-1.82-2.05-7.6-2.05-7.6l.72-10.22c-16.77-6.71-32.82.08-32.82.08,0,0,3.73,25.27,3.93,29.55.48,10.49-2.42,24.54-2.42,24.54,0,0,2.79,3.42,12.55,5.28,3.47.66,7.01.68,9.56-1.75l2.39-2.27,1.96,1.6c1.21.99,2.88,1.19,4.29.51l3.37-1.62-2.42-30.8s1.93-2.02.93-7.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m376.98,74.22c2.64,5.77,10.21,17.38,13.83,22.85.87-6.6-.15-17.3.86-22.75-5.84-1-10.45-.79-14.69-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m378.44,113.72c-6.62-2.32-7.54-10.14-.86-7.79,5.38,1.89,16.38-1.2,21.93-2.19.34-.06.69-.09,1.03-.1l-.15-1.88c-.68.36-1.43,1.05-2.34,1.1-2.81.16-5.61.19-8.42.25-2.41.05-5.72.6-8.09.01-5.19-1.3-4.48-10.01-7.33-14.09-.79-1.13-4.32,1.04-5.33-.46,1.01,7.2,2.12,15.42,2.22,17.7.48,10.49-2.42,24.54-2.42,24.54,0,0,1.03.91,1.4,1.18.4.28,1.67,1.01,1.67,1.01-.41-2.19,1.46-6.8,3.31-8.18,3.41-4.36,10.42-6.44,15.36-7.74,3.75-.99,7.73-1.82,11.08-.99l-.13-1.61c-7.25,1.19-16.05,1.65-22.96-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m377.83,105.54l-4.85-22.18s-.56-7.45-5.4-6.71c0,0-4.29.93-4.1,5.4.19,4.47,1.3,18.64,8.39,30.94,0,0,2.42,1.86,6.9,1.68,4.47-.19,17.64-5.61,17.64-5.61,0,0,.54-2.92-1.51-4.79l-17.06,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m395.32,104.72s.51.3.82,1.26c.13.42.29,1.51.29,1.51l6.95-1.79-2.5-2.47-5.55,1.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m388.57,65.62l-8.05.25-1.19,8.36c.08,2.51,2.71,6,5.22,5.92,5.23-.17,4.39-2.8,4.34-4.35l-.32-10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m380.52,65.88l-.63,4.41c1.63,1.57,2.86,2.41,5.11,2.78,1.99.33,3.3.15,3.77-1.1l-.2-6.35-8.05.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m376.98,55.36l.29,9.22c.13,4.22,3.7,7.55,9.53,7.23,3.77-.2,5.86-4.99,5.73-9.21l-.3-7.73-15.25.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m380.52,54.48l-4.86.61.46,11.97,2.44,4.04,1.86,2.79s-1.68-3.93-1.51-9.53c.16-5.23,1.6-9.88,1.6-9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m377.29,53.94l.09,2.84,2.37.82s.06-2.34,2.55-2.42l-.04-1.4-4.97.16Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "385.61 115.15 388.63 115.44 388.71 113.08 381.55 114.5 385.61 115.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m402.46,100.58c.29-.74,1.79-.31-.24-7.79-.27-1.01-2.94-5.92-2.94-5.92l1.2,3.21s.48,2.75,1.04,5.72c.56,2.97-1.13,5.96-1.13,5.96l.12,1.55.35-.09,2.5,2.47s-1.2-4.37-.91-5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m393.48,74.66l-3.53-1.9c-.06,2.57.27,4.63.27,9.01,0,6.94.59,15.3.59,15.3,2.86-9.2,3.48-18.51,3.48-18.51l-1.76-1.1.94-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m379.11,71.82l-3.4,2.7.44,3.27,2.16.44-1.03,2.61c2.92,3.69,13.54,16.23,13.54,16.23,0,0-6.42-14.13-7.75-16.23-1.53-2.41-3.95-9.02-3.95-9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m388.77,71.82s.74,6.26-1.89,8.03l2.63,2.97s2.37-1.91,2.17-8.83l-2.91-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m379.8,70.99l-2.81,2.52c3.15,5.85,7.78,9.57,7.78,9.57l2.16-3.23c-3.76-1.2-7.12-8.86-7.12-8.86Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m205.7,242.47l-5.16-3.4h-6.92s-1.7,3.4-1.11,7.23h17.76s-.29-3.4-4.57-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m193.62,239.07s-1.7,3.4-1.11,7.23h8.21c-1.8-2.18-3.15-4.62-4.11-7.23h-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m228.81,242.47l-8.02-3.4h-7.69s-1.7,3.4-1.11,7.23h21.39s-.3-3.4-4.57-3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m215.55,239.07h-2.45s-1.7,3.4-1.11,7.23h14.13c-3.97-1.44-7.71-4-10.57-7.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m211.64,155.09l1.39,39.18.06,44.79,4.05.12c.26-12.11.67-24.22.04-36.31-.39-7.64-4.16-47.96-5.55-47.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m196.98,158.73c-1.63-4.12-2.6-8.57-3.15-13.07-.21-.02-.42-.04-.63-.06l-.32,8.62,1.07,40.06-.32,44.79,3.5.17c.6-2.81-1.48-58.51-.13-80.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "195.51 94.59 194.42 99.56 195.04 120.41 193.69 133.37 193.51 137.31 195.87 137.25 197.32 120.29 195.87 99.8 195.51 94.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m235.2,142.2v-.82s-.02,0-.03.01l-.89-25.28-.76-29.41s-.03-6.15-6.39-7.36l-17.28-7.25s0,.04,0,.06c0,.04,0,.07-.01.11l-16.89,6.34c-4.32,1.12-5.87,4.33-6.29,5.45h-.01s-1.01,13.21-1.01,13.21c2.1.21,4.2.42,6.31.59,2.38.19,3.21,2.68,2.49,4.32l.59,18.24-1.33,12.73h-.03l-.48,11.36c11.51,0,23.31.01,34.81.15l-.55-11.45h-.01s-.88-12.36-.88-12.36l3.42,21.82-1.58,5.9-.59,6.33c1.55.09,2.19-1.91,2.4-3.25.21-1.33,1.21-.9,1.21-.9,0,0,.23,3.8.4,6.41.06.93-.56,3.36-.53,3.77.13,1.55,1.57,1.2,1.57,1.2l2.89-4.34,1.41-5.95-1.97-9.45v-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m191.88,102.62c-2.24-.26-4.48-.57-6.71-.88l-1.52,13.38-.86,18.75-.58,7.19-2.44,9.25,1.1,6.07,2.82,4s1.43.43,1.64-1.13c.07-.5-.64-1.86-.5-3.07.3-2.57.77-6.68.77-6.68,0,0,1.03-.38,1.17.97.14,1.36.68,3.41,2.25,3.4l-.26-6.42-1.25-5.86h-.02s4.21-23.71,4.21-23.71l1.78-12.51.62-3.62c-.47.6-1.22.97-2.25.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m227.14,79.34l-17.28-7.25s0,.04,0,.06c0,.04,0,.07-.01.11l-16.89,6.34c-4.32,1.12-5.87,4.33-6.29,5.45h-.01s-1.17,15.34-1.17,15.34c2.28.03,4.55.06,6.83.07,2.67,0,3.4,3.02,2.19,4.67l.16,4.8c.44.77.57,1.72.12,2.72-.01.03-.02.06-.03.08l.28,8.68-1.33,12.73h-.03l-.48,11.36c11.51,0,23.31.01,34.81.15l-.55-11.45h-.01s-.88-12.36-.88-12.36l3.42,21.82-1.58,5.9-.59,6.33c1.55.09,2.19-1.91,2.4-3.25.18-1.17.98-.98,1.17-.92.25-6.53.75-13.07-.44-19.55-1.43-7.75-4.14-16.65.96-23.67.57-.78,1.34-1.16,2.12-1.23l-.51-19.57s-.03-6.15-6.39-7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m184.92,103.9l-1.28,11.22-.86,18.75-.58,7.19-2.44,9.25,1.1,6.07,2.36,3.34c-.19-4.32-1.44-8.36-.68-12.75.9-5.16,2.3-10.24,2.81-15.46.79-8.11.5-16.32,4.21-23.8.84-1.69,2.51-1.7,3.72-.87l.21-1.46.27-1.55c-.43.27-.95.42-1.59.4-2.42-.1-4.84-.22-7.25-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m227.71,106.2c1.74-.02,6.58-.39,8.25-1.02l-2.43-18.49s-.03-6.15-6.39-7.36l-17.28-7.25s0,.04,0,.06c0,.04,0,.07-.01.11l-16.89,6.34c-4.32,1.12-5.87,4.33-6.29,5.45h-.01s-2.7,21.62-2.7,21.62c2.76.5,6.57,1,9.33,1.53.11.02.2.05.29.09l.9-4.13.56,17.25-1.33,12.73h-.03l-.48,11.36c11.51,0,23.31.01,34.81.15l-.55-11.45h-.01s-.57-8.03-.57-8.03c-.17-.32-.22-.71-.15-1.09.01-.09.04-.18.06-.27l-.12-1.65c-.15-.21.04-5.05.35-7.17.3-2.12.69-8.79.69-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m226.89,125.17c-.17-.32-.22-.71-.15-1.09.01-.09.04-.18.06-.27l-.12-1.65c-.14-.21.04-5.05.35-7.17.3-2.12.69-8.79.69-8.79.06-2.94-.89-16.33-.89-16.33h-28.9c-.55,3.46-1.51,10.08-2.18,13.4-.35,1.77-.71,3.53-1.08,5.28l.38,11.85-1.33,12.73h-.03l-.48,11.36h.03l-.37,9.72,1.07,40.06-.32,44.79,7.33.22,5.53-45.02,3.48-39.26,1.68.08,1.39,39.18.06,44.79,8.29.25,4.18-43.59,2.45-39.88v-11.21l-.56-11.45-.57-8.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m199.5,184.18c-.85-9.14-2.67-18.18-3.28-27.33-.6-9.02-.16-18.12-2.16-27l-.34,3.28h-.03l-.48,11.36h.03l-.37,9.72,1.07,40.06-.32,44.79,6.23.19c.14-9.1-.24-18.2-.18-27.3.06-9.28.69-18.52-.17-27.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m198.37,99.97c-.09-3.27-.22-6.55-.32-9.82,0-.1.01-.18.02-.27h-.15c-.55,3.46-1.51,10.07-2.18,13.39-.35,1.77-.71,3.53-1.08,5.28l.38,11.85-.77,7.39c1.05-1.99,4.44-2.38,5.22.21.86-.4,1.73-.77,2.61-1.13-4.74-7.81-5.76-17.94-3.73-26.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m216.57,220.49c.26-10.71.1-21.42-.45-32.12-.38-7.24-.92-14.49-1.38-21.72-.13-1.96-.39-12.27-3.44-12.06-.34.02-.64-.02-.91-.09,0,.18-.01.36-.02.54l1.28.06,1.39,39.18.06,44.79,5.32.16c-2.92-5.62-2-12.44-1.84-18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m227.12,101.26s.01.04.02.07c0-.05,0-.07-.02-.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m213.04,46.54l-11.28,6.01v5.15c0,2.89,2.7,7.03,3.8,9.41.95,2.06,4.34,5.02,6.35,5.02,4.89,0,8.86-3.97,8.86-8.87v-10.71l-2.13-3.31-5.6-2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m205.56,76.9c0,2.81,8.48,5.97,10.56,0v-12.02h-10.56v12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m216.12,45.44c-3.41-1.38-9.86-1.79-13.32,4.41-1.21,2.17-1.32,3.87-1.04,8.38.37,5.81,2.66,8.04,3.8,9.94v-1.06l-.34-3.27s-1.85.16-2.27-4.51c-.16-1.79.46-1.74,1.02-1.74.75,0,1.21,1.31,1.21,1.31h1.35l.06-2.16c-.02-.51.6-3.4,2.99-4.33,5.17-2,11.06.72,11.06.72,0,0,1.25-.89,1.25-2.15,0-3.5-3.03-4.44-5.78-5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m208.33,70.48c3.71,3.87,7.79,1.57,7.79,1.57v-1.01c-3.49,2.01-7.79-.57-7.79-.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m220.31,76.47s2.32,6.39,2.32,16.56h4.47s-.39-10.14-2.99-14.97l-3.79-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m195.16,77.77c3.64,6.14,2.91,16.82,2.91,16.82l4.46-1.56c-.72-10.9-3.88-16.57-3.88-16.57l-3.49,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m202.97,122.74c-6.62-1.3-7.93-2.01-7.93-2.01l-.39,3.69s9.58,6.68,32.87,1.82l-.59-3.76s-17.34,1.56-23.97.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m202.97,122.42c-6.62-1.3-7.93-2.01-7.93-2.01l-.39,3.69s9.58,6.68,32.87,1.82l-.59-3.76s-17.34,1.56-23.97.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m212.23,125.77l-17.57-1.67s6.76,3.74,17.57,1.67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "224.18 125.21 221.41 125.7 227.33 125.73 227.53 125.73 227.37 124.64 224.18 125.21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "203.41 128.1 203.17 128.19 206.89 138.74 207.24 139.12 207.35 139.08 207.38 138.57 203.66 128.01 203.41 128.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m203.73,127.03l-1.31.46c-.3.1-.45.43-.35.72.1.3.43.45.72.35l1.31-.46c.3-.1.45-.43.35-.72-.1-.3-.43-.45-.72-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 201.95,
    y: 127.55,
    width: 2.64,
    height: 0.49,
    transform: "translate(-30.92 74.82) rotate(-19.41)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m203.58,124.05c-.21-.06-.38-.22-.46-.43l-1.4-3.97c-.07-.19-.05-.39.04-.56-.04-.06-.08-.11-.12-.15-.5-.53-1.16-.45-1.56-.31h-.04c-.41.16-.97.5-1.02,1.23,0,.06,0,.12,0,.19.17.07.32.22.38.41l1.4,3.97c.08.22.04.45-.09.63.42.6.89,1.16,1.14,1.48.48.59.38,1.07.38,1.07l1.76-.62s-.38-.31-.38-1.07c0-.41.01-1.14-.04-1.87Zm-1.34.61l-.16.06c-.36.13-.76-.06-.89-.42l-1.4-3.97c-.13-.36.06-.76.42-.89l.16-.06c.36-.13.76.06.89.42l1.4,3.97c.13.36-.06.76-.42.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m199.4,120.46c-.07-.19-.21-.33-.38-.41.04.84.57,2.61.86,3.5.15.45.48.99.84,1.5.12-.18.16-.41.09-.63l-1.4-3.97Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 200.45,
    y: 119.25,
    width: 1.55,
    height: 5.6,
    rx: 0.69,
    ry: 0.69,
    transform: "translate(-29.13 73.85) rotate(-19.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m201.76,119.09c-.09.17-.11.37-.04.56l1.4,3.97c.08.22.25.37.46.43-.04-.63-.12-1.26-.29-1.7-.33-.88-1.03-2.59-1.53-3.27Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "205.98 120.36 205.76 120.83 205.33 132.01 205.59 132.02 205.85 132.03 206.28 120.85 206.1 120.37 205.98 120.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m206.33,131.82l-1.38-.05c-.31-.01-.58.23-.59.55-.01.31.23.58.55.59l1.38.05c.31.01.58-.23.59-.54.01-.31-.23-.58-.54-.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 205.37,
    y: 131.04,
    width: 0.49,
    height: 2.64,
    transform: "translate(65.52 332.78) rotate(-87.82)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m206.98,135.84c-.17-.71-.4-1.4-.52-1.8-.23-.73.04-1.13.04-1.13l-1.86-.07s.24.42-.04,1.13c-.15.38-.43,1.05-.65,1.75.17.13.28.34.27.57l-.16,4.21c0,.2-.1.38-.25.5.02.07.04.13.06.19.27.68.91.85,1.34.86h.04c.43.02,1.08-.1,1.4-.76.03-.05.05-.11.07-.18-.13-.13-.21-.32-.21-.52l.16-4.21c0-.23.13-.43.31-.55Zm-.89,4.74c-.01.38-.34.68-.72.67h-.17c-.38-.02-.68-.34-.67-.73l.16-4.21c.01-.38.34-.68.72-.67h.17c.38.02.68.34.67.73l-.16,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m206.67,136.39l-.16,4.21c0,.2.07.39.21.52.28-.8.43-2.64.49-3.57.03-.47-.08-1.1-.23-1.71-.18.12-.3.32-.31.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 202.6,
    y: 137.68,
    width: 5.6,
    height: 1.55,
    rx: 0.69,
    ry: 0.69,
    transform: "translate(59.09 338.33) rotate(-87.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "m203.59,137.41c-.01.94,0,2.78.22,3.6.14-.12.24-.3.25-.5l.16-4.21c0-.23-.1-.44-.27-.57-.19.6-.35,1.21-.36,1.68Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m210.4,136.76c.03-1.77.27-6.43.06-8.7-.21-2.27.04-8.75.04-8.75l-2.36-.06s-.05,6.49-.37,8.74c-.32,2.25-.3,6.92-.35,8.69-.06,1.77-.47,6.19-.47,6.19l.69.47,2.23.05.71-.43s-.2-4.43-.17-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m208.73,131.53c-.16-1.99-.07-3.97,0-5.96.07-2.1.14-4.19.37-6.28l-.96-.02s-.05,6.49-.37,8.74c-.32,2.25-.3,6.92-.35,8.69-.06,1.77-.47,6.19-.47,6.19l.69.47,1.75.04c-.07-3.21-.34-6.42-.43-9.63-.09-.74-.17-1.49-.23-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m210.41,136.77c.03-1.78.27-6.47.06-8.75l-2.7-.06c-.32,2.27-.3,6.96-.36,8.75-.06,1.78-.47,6.22-.47,6.22l.69.47,2.24.05.71-.44s-.2-4.46-.17-6.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m207.41,136.7c-.06,1.78-.47,6.22-.47,6.22l.69.47h.5c.09-.79.21-9.16.24-10.61l.1-4.5c0-.1.02-.21.04-.3l-.75-.02c-.32,2.27-.3,6.96-.36,8.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m215.62,114.43l-1.88-.04c-.17,0-.31.12-.31.28l-.06,2.41c0,.16.13.29.3.29l1.88.04c.17,0,.31-.12.31-.28l.06-2.41c0-.16-.13-.29-.3-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m213.41,115.82l-.03,1.26c0,.16.13.29.3.29l1.88.04c.17,0,.31-.12.31-.28l.02-.89s-.04,0-.05,0c-.78.02-1.65-.11-2.42-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m211.17,114.64s-.24-.29-.84-.42l-2.9-.07s-4,.13-4.34,4.09h.36s.53-1.88,3.26-2.19c0,0,1.1-.26.91,2.29v.57s.06.63.88.65l1.72.04s.82-.21.84-.9l.04-1.78s1.1-.54,2.27.13l.06-2.41s-1.01.76-2.27-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m212.5,115.95s-.06,0-.07,0c-.21.07-1.11.44-1.26.49-2.62.83-3.53-.78-3.84-.92-.41-.05-2.87-.03-3.07,0-.6.6-1.07,1.47-1.17,2.72h.36s.53-1.88,3.26-2.19c0,0,1.1-.26.91,2.29v.57s.06.63.88.65l1.72.04s.82-.21.84-.9l.04-1.78s1.1-.54,2.27.13l.02-1.05c-.29.04-.6.02-.9-.07Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m195.2,125.13s-1.9,12.48-1.89,16.93c0,2.11,16.93,5.37,17.55,3.51.62-1.86,1.37-19.47,1.37-19.47-10.81,2.07-17.02-.97-17.02-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m194.66,124.1s-1.71,12.87-1.71,17.32c0,2.11,16.75,4.98,17.37,3.12.62-1.86,1.91-18.77,1.91-18.77-10.81,2.07-17.57-1.67-17.57-1.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 223.77,
    y: 130.52,
    width: 0.91,
    height: 1.31,
    transform: "translate(-5.21 9.33) rotate(-2.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 225.31,
    y: 130.46,
    width: 0.91,
    height: 1.31,
    transform: "translate(-5.19 9.38) rotate(-2.35)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m223.23,122.74c-.3-2.16-.13-4.86-.09-5.2.04-.34.09-.96-.42-1.14-.51-.18-.73.48-.73.48-.58,1.71-.5,3.98-.43,5.66.1,2.51,1.82,8.26,1.82,8.26.11.44.19.39.19.39l.55-.02.59-.02c.2.03.05-.47.05-.47-1.5-6.07-1.53-7.93-1.53-7.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m223.23,122.74c-.3-2.16-.13-4.86-.09-5.2.03-.25.06-.64-.11-.9-.17.61-.41,4.04-.4,4.58.03,1.02.09,2.04.22,3.05.14.86.31,1.72.49,2.58.17.82,1.01,3.96,1.07,4.32h.29c.2.02.05-.48.05-.48-1.5-6.07-1.53-7.93-1.53-7.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m226.75,116.68s-.28-.63-.77-.42c-.49.22-.4.83-.33,1.17.07.34.47,3.02.34,5.19,0,0,.13,1.86-.87,8.03,0,0-.1.51.09.46l.59-.03.56-.02s.08.05.15-.4c0,0,1.24-5.88,1.13-8.38-.07-1.68-.18-3.96-.89-5.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m226.75,116.68s-.26-.6-.72-.43c.18.3,1.45,1.93,1.16,7.45.02.33-.75,5.63-1.04,6.95-.03.15-.09.31-.16.45l.37-.02s.08.05.15-.4c0,0,1.24-5.88,1.13-8.38-.07-1.68-.18-3.96-.89-5.61Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m225.2,138.6s.04-.07.02-.11h0s-.04-.04-.07-.04c-.01,0-.03,0-.04.01-.02-.03-.04-.06-.05-.09.04-.02.06-.06.04-.1,0,0,0-.02,0-.02-.01-.03-.04-.05-.07-.05,0,0-.02,0-.03,0,0,0,0,0,0,0-.01-.03-.02-.07-.03-.11,0,0,0,0,0,0,.04,0,.07-.05.06-.09,0,0,0-.02,0-.02,0-.04-.04-.07-.08-.07,0,0,0,0,0,0,0,0,0,0-.01,0,0-.02,0-.04,0-.06,0-.02,0-.03,0-.05,0,0,0,0,.01,0,.04,0,.08-.03.08-.07,0,0,0-.02,0-.02,0-.04-.03-.08-.07-.08,0,0,0,0,0,0,0-.04.01-.07.02-.11,0,0,0,0,0,0,.04.01.08-.01.09-.05,0,0,0-.02,0-.02.01-.04,0-.08-.05-.1.01-.04.03-.07.04-.1.04.02.08,0,.1-.03h0s0-.09-.03-.11c.03-.05.05-.07.05-.07l-.1-2.35-1.03-.37-.41.1.15,1.21,1.2,4.17h.29s-.05-1.16-.05-1.16c0,0-.02-.02-.04-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "225.46 131.37 225.21 131.65 225.24 132.42 226.2 133.17 226.47 133 226.42 131.77 225.46 131.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m224.55,131.41l-.92.48.05,1.23.07.04c.07-.21.2-.41.36-.57.22-.21.46-.31.73-.36l-.02-.56-.27-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m223.72,131.84l-.1.05.05,1.23.07.04c.03-.09.07-.18.12-.26-.07-.2-.11-.4-.12-.61,0-.15-.01-.31-.02-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m225.32,135.04s-.07,0-.1,0l.08,1.99s.02.03.06.07c-.03.03-.03.07-.01.1h0s.06.05.1.04c.02.03.03.06.05.09,0,0,0,0,0,0-.03.02-.05.06-.03.1,0,0,0,.02,0,.02.01.04.05.06.09.05.01.03.02.07.03.1-.04.01-.06.05-.05.09,0,0,0,.02,0,.02,0,.04.04.07.08.07,0,.04,0,.07,0,.11-.04,0-.07.03-.07.07,0,0,0,.02,0,.02,0,.04.02.07.06.08,0,.04-.01.07-.02.11,0,0-.01,0-.02,0-.03,0-.06.02-.07.05,0,0,0,.02,0,.02-.01.04,0,.08.04.09-.01.03-.03.07-.04.1-.01,0-.02,0-.03,0-.03,0-.05.01-.06.04h0s-.01.09.02.11c-.02.03-.04.05-.04.05l.05,1.15h.29s.85-4.27.85-4.27l.05-1.22-.17-.03c-.21.42-.62.75-1.12.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m225.22,135.04s0,0,0,0l.08,1.99s.02.03.06.07c-.03.03-.03.07-.01.1h0s.06.05.1.04c.02.03.03.06.05.09,0,0,0,0,0,0-.03.02-.05.06-.03.1,0,0,0,.02,0,.02.01.04.05.06.09.05.01.03.02.07.03.1-.04.01-.06.05-.05.09,0,0,0,.02,0,.02,0,.04.04.07.08.07,0,.04,0,.07,0,.11-.04,0-.07.03-.07.07,0,0,0,.02,0,.02,0,.04.02.07.06.08,0,.04-.01.07-.02.11,0,0-.01,0-.02,0-.03,0-.06.02-.07.05,0,0,0,.02,0,.02-.01.04,0,.08.04.09-.01.03-.03.07-.04.1-.01,0-.02,0-.03,0-.03,0-.05.01-.06.04h0s-.01.09.02.11c-.02.03-.04.05-.04.05l.05,1.15h.29s.52-2.62.52-2.62c-.02-.07-.04-.14-.07-.22-.27-.66-.57-1.31-.94-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "m225.08,132.29c-.08,0-.15.01-.23.03-.47.1-.84.45-.99.89-.05.15-.07.31-.06.47.03.74.65,1.31,1.39,1.28,0,0,.01,0,.02,0,.48-.03.89-.31,1.1-.71.11-.2.17-.44.16-.68-.03-.74-.65-1.31-1.39-1.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "m225.09,132.61c-.57.02-1.02.5-1,1.06.02.56.51,1,1.08.97.57-.02,1.02-.5,1-1.06-.02-.56-.51-1-1.08-.98Zm.07,1.68c-.38.02-.69-.27-.71-.63-.01-.36.28-.67.65-.69.38-.02.69.27.71.63.01.36-.28.67-.65.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m226.62,126.45l-7.02-.04,1.35,18.68s1.8.37,4.01.12c1.94-.21,2.92-1.03,2.92-1.03l-1.07-17.71-.19-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m227.33,125.73l-7.02-.04,1.35,18.68s1.8.37,4.01.12c1.94-.21,2.92-1.03,2.92-1.03l-1.07-17.71-.19-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m225.64,128.51c0-2.3-1.68-4.29-3.87-4.45-.7-.05-1.37.09-1.97.38-.05-.04-.12-.07-.23-.08l-1.37-.09c-.34-.02-.6.24-.59.59l.06,1.33c0,.17.06.27.14.31-.27.59-.43,1.25-.43,1.96s.15,1.35.41,1.93v2.23c0,.68.54,1.19,1.19,1.14l3.53-.25s-.01.09-.01.15l1.96-.14c.57-.04,1.03-.59,1.03-1.23v-1.39l-.02-.1h-.13s0-.59,0-.59c.21-.53.32-1.1.32-1.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m220.15,123.94l-1.37-.09c-.34-.02-.6.24-.59.59l.06,1.33c.01.35.22.43.46.2l1.61-1.59c.23-.22.15-.42-.17-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m222.35,123.64c-2.35-.17-4.39,1.79-4.39,4.4s2.04,4.6,4.39,4.45c2.2-.13,3.87-2.1,3.87-4.4s-1.68-4.29-3.87-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m218.37,132.2c0,.68.54,1.19,1.19,1.14l5.37-.38c.54-.04.98-.56.98-1.16v-3.92l-7.54-.07v4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m225.56,130.39s-.49,0-.49.47-.11,1.24-1.24,1.31c0,0-.76.06-.76,1.07l1.96-.14c.57-.04,1.03-.59,1.03-1.23v-1.39l-.02-.1h-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m222.35,125.03c-1.6-.08-2.95,1.27-2.95,3.02s1.35,3.12,2.95,3.06c1.52-.06,2.71-1.41,2.71-3.02s-1.19-2.97-2.71-3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "m219.57,131.51c-.29.01-.53.27-.53.57s.24.53.53.51c.29-.02.52-.27.52-.57s-.23-.53-.52-.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m202.22,94.1v12.85c0,1.49,1.22,2.69,2.71,2.67l15.5-.22c1.5-.02,2.68-1.27,2.63-2.76l-.43-12.55h-20.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m168.57,142.16l-14.64.13,2.68,44.51s-.38,7.63-1.05,13.11c-1.34,10.95,1.18,39.98,1.18,39.98l6.8.25,4.9-48.82s1.09-29.92.83-34.95c-.23-4.6-.51-12.86-.71-14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m168.57,142.16l-14.64.13,2.68,44.51s-.38,7.63-1.05,13.11c-1.01,8.26.17,26.81.82,35.42.16-2.72.35-5.45.47-8.18.32-7.45.08-14.93.85-22.36.7-6.84,2.35-12.88,3.47-19.66.77-4.65,3.24-7.08,7.58-8.69.07-.02.13-.03.19-.05.25-8.29.47-17.44.34-20.03-.23-4.6-.51-12.86-.71-14.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m139.23,153.35c0,5.53.5,29.4.5,30.93,0,3.52-1.03,11.78-1.55,16.63-.31,2.85-1.59,37.72-1.59,37.72l6.8,1.51,8.47-51,3.43-34.03,1.43-12.82h-15.29c-.71,2.05-2.21,6.85-2.21,11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m139.23,153.35c0,5.53.5,29.4.5,30.93,0,3.52-1.03,11.78-1.55,16.63-.16,1.52-1.21,28.15-1.59,37.72.81-5.78,2.58-27.61,3.62-33.34,1.25-6.91.44-13.81,2.83-20.45,1.65-4.57,4.96-6.73,9.41-8.21.24-.08.47-.11.68-.11l2.16-21.41,1.43-12.82h-15.29c-.71,2.05-2.21,6.85-2.21,11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m149.12,242.61l-5.6-3.73-7.32-.32s-1.94,3.59-1.43,7.74h19.15s-.21-3.09-4.81-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m149.12,242.61l-.12-.08c-2.74-.07-4.16.67-5.1,3.32-.06.16-.13.31-.21.46h10.24s-.21-3.09-4.81-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m134.7,244.66c0,.53.01,1.08.08,1.64h19.15s-.06-.79-.7-1.64h-18.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m172.81,242.71l-9.01-3.96-7.3-.13s-2.46,3.52-1.95,7.68h23.07s-.21-2.98-4.81-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m172.81,242.71l-.59-.26c-.12.02-.24.06-.36.07-1.15.15-1.64.69-2.01,1.59.12-.29-.29,1.24-.25,1.01-.06.39-.08.78-.07,1.18h8.1s-.21-2.98-4.81-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m154.51,244.41c-.04.61-.04,1.24.04,1.89h23.07s-.07-.95-.96-1.89h-22.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m166.47,122.99h-24.3s-6.05,15.18-6.33,23.34c-.28,8.15-.39,29.21-.39,29.21h36.24l-.34-22.32c-.35-18.55-4.87-30.23-4.87-30.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m142.18,122.99s-6.05,15.18-6.33,23.34c-.14,4-.23,11.12-.3,17.33,1.51-4.69,3.65-9.2,6.64-13.11,6.56-8.57,18.35-8.81,28.15-10.37-1.44-10.24-3.86-17.18-3.86-17.18h-24.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m177.75,91.73s-.08-.32-.29-.8l-.3-.64c-.71-1.33-2.17-3.24-4.95-4.14l-7.54-2.91c-.11.6-.31,1.18-.59,1.72,0,0,0,0,0,.01-.03.05-.05.11-.08.16-.95,1.89-2.96,3.29-5.98,3.09-4.25-.28-6.12-3.43-5.82-6.37l-9.52,2.31c-3.76.62-5.55,3.22-6.15,4.34,0,0,4.99,6.88,6.4,11.99,0,0-.21,13.6-1.16,18.52-.57,2.93-4.79,19.23-4.79,19.23l33.95,2.23s-1.16-14.09-1.32-16.5c-.25-3.87,2.68-17.3,2.81-19.27l.02-.36s-.03-1.41-.18-3.29c3.23-1.44,4.19-1.47,6.1-2.05l-.59-7.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m170.31,113.77c-.69-.05.63-13.99.33-13.33-1.68,3.64,1.34,13.43-4.4,13.15-6.48-.31-18.34,2.67-20.16-3.82-2.54-9.04-3.79-16-9.19-21.9-.16.23-.28.45-.38.62,0,0,4.99,6.88,6.4,11.99,0,0-.21,13.6-1.16,18.52-.3,1.57-1.68,7.29-2.85,11.6,2.1-1.09,4.48-2.55,6.37-3.1,7.81-2.27,16.39-2.04,24.47-1.57-.08-.87-.13-1.57-.16-1.97-.12-1.91.53-6.17,1.24-10.21-.16.02-.33.03-.51.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m150.86,71.17c-.2,4.4,5.65,8.24,8.55,8.37,4.92.22,8.54-4.72,8.74-9.12l1.13-11.79-20.97,3.92,2.55,8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m151.92,83.26c-.06,2.62,5.55,5.1,5.55,5.1,2.93.06,5.03-2.25,5.08-4.88l.94-10.63-10.63-.23-.94,10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m155.97,77.79c3.45,3.36,6.93,1.66,6.93,1.66l.07-.75c-3.31,1.42-7-.91-7-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m159.55,52.63s-11.14-1.19-11.77,10.45c-.17,3.17,2.32,11.23,5.36,13.15l-1.25-6.01s-1.96.16-1.75-4.41c.08-1.67.82-1.68,1.41-1.66.79.04.76,1.15.76,1.15l.94.04.06-1.23c.07-1.55,1.54-2.74,3.28-2.65h3.24c-.94-1.47-.28-8.84-.28-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m161.54,52.84l-2.21-.15-2.82,8.73s6.45,1.05,8.91-1.43c0,0,3.39,4.41,3.11,7.36,0,0,1.55-1.59,1.93-5.49,0,0,.9-8.07-8.92-9.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m150.57,59.56s-1.16-4.13-5.67-.94c-3.31,2.34,0,15.32,0,15.32,0,0,3.42-1.52,4.61-4.62,0,0-3.14-8.42,1.06-9.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m148.91,82.58l6.27,9.26,3.47-3.42c0-.12-6.58-8.43-6.58-8.43l-3.16,2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "m158.28,88.39l2.99,3.84,5.29-8.1-3.81-2.82s-4.45,6.96-4.48,7.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m144.18,114.88s-.6-17.67-1.09-20.56c-.49-2.89-1.94-7.74-5.06-7.81,0,0-3.05,2.93-2.95,7.69.1,4.76-1.4,14.96-.64,18,.75,3.04.5,12.04,4.55,12.44,4.05.4,26.88-2.21,26.88-2.21l-1.16-5.03-20.53-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m144.18,114.88s0-.15-.01-.42c-.3.03-.63,0-.98-.15-2.9-1.14-5.91-1.95-8.88-2.88.03.29.07.55.13.77.46,1.85.54,5.89,1.45,8.87,7.39.43,14.76.75,22.04,2.22,4.47-.46,7.94-.86,7.94-.86l-1.16-5.03-20.53-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m151.39,115.03l-5.71-.99-4.56-3.09-4.25-.55-3.08.34s-.59.71-.16,1.35c.43.64.18.35.18.35,0,0-.94.89.16,1.71,0,0-.49,1.26.09,1.77,0,0-.17.53-.07,1.08l.76.87s0,1.15.37,1.66c.37.5.47,1.19,2.3,1.17,1.84-.02,7.4-.94,7.4-.94l5.93.73s2.21-4.61.63-5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m170.36,102.62l.68,13.09-23.52-1.34-1.05,5.6s19.21,5.44,28.7,6.02c3.29.2,4.52-1.73,4.69-5.27.87-17.38-2.11-28.98-2.11-28.98-6.16-3.53-7.39,10.88-7.39,10.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m179.28,113.02c.22-.19.26-.87.26-.87l-1.54-1.46-3.63-.65.5-.44s1.68.31,2.63.31c.95,0,1.09-1.08,1.09-1.08l-4.83-.93-3.95,2.19-4.38,5.31c4.32.37,6.32.56,7.55.5s4.73-.88,5.14-.85,1.11-.4,1.21-.8c.09-.4-1.09-1.02-1.09-1.02l-1.16-.96s1.98.95,2.19.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m159.77,64.66c-2.68-.18-3.61.28-3.13,2.22.48,1.88,1.17,2.93,3.31,2.66.94-.12,2.78-.83,2.8-3.31,0-.8-.36-1.39-2.99-1.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m166.92,65.02c-2.57-.08-2.96.46-2.99,1.26-.1,2.46,1.67,3.3,2.57,3.48,2.02.42,2.72-.55,3.25-2.33.54-1.81-.3-2.35-2.83-2.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m170.51,65.47h.01s-1.16-.49-2.62-.6h.03c-.21-.01-.43-.03-.67-.04-.11,0-.22,0-.33-.01-1.02-.03-1.75.03-2.26.2-.07.02-.16.05-.26.09-.3.11-.76.26-1.02.26-.26-.02-.76-.22-1.06-.36-.11-.05-.2-.09-.28-.12-.5-.22-1.25-.35-2.29-.42-.12,0-.23-.01-.34-.02-.23-.01-.45-.02-.65-.02h.02c-1.56-.05-2.83.33-2.83.33-.08,0-.15.06-.15.15v.46c.01.08.08.16.17.16h.07s.21.08.24.4c0,.08.02.14.03.18,0,.24.05.51.13.82.43,1.68,1.05,2.79,2.73,2.85.25,0,.52,0,.81-.04,1.25-.16,2.69-1.03,2.93-2.96v.03s.01-.09.01-.13c0-.03,0-.06,0-.09.06-.55.31-.6.42-.59h0s0,0,.02,0c.02,0,.03,0,.03,0h0c.09,0,.29.07.34.53,0,.08,0,.16,0,.23,0,.02,0,.05,0,.08v-.02c.15,1.94,1.52,2.9,2.72,3.14.28.06.53.09.77.1,1.58.05,2.22-.97,2.69-2.55.09-.31.15-.58.16-.82,0-.03.02-.07.02-.12.04-.3.24-.36.24-.36h.06c.08,0,.14-.06.15-.14l.03-.44c0-.06-.03-.12-.08-.14Zm-10.59,3.87c-.27.03-.52.05-.75.04-1.44-.05-1.95-.96-2.34-2.54-.18-.71-.15-1.19.09-1.49.33-.42,1.1-.57,2.51-.5.11,0,.22.01.34.02,2.6.18,2.81.72,2.8,1.36-.03,2.65-2.2,3.07-2.64,3.12Zm9.65-1.96c-.44,1.49-.96,2.34-2.32,2.29-.22,0-.45-.04-.71-.09-.42-.09-2.53-.65-2.42-3.29.03-.63.25-1.15,2.79-1.08.11,0,.22,0,.32.01,1.33.07,2.05.29,2.33.72.21.31.21.77,0,1.44Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "152.75 65.77 155.99 65.52 156.03 64.87 152.66 65.34 152.75 65.77"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m93.1,241.28l-4.32-2.32-7.62-1.29s-2.03,4.06-1.32,8.64h18.04s-.6-3.84-4.77-5.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m80.06,244.62c-.13,0-.25-.01-.37-.02.01.55.06,1.13.15,1.7h18.04s-.12-.75-.61-1.69h-17.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m126.33,241.72l-11.26-4.04h-7.41s-2.02,4.04-1.31,8.6h25.42s-.35-4.04-5.43-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m106.2,244.62c.01.54.06,1.1.14,1.66h25.42s-.07-.76-.56-1.66h-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m95.52,143.7c-3.68-.41-7.36-.92-11.05-1.14-.3-.02-.6-.03-.9-.03-.03,2.23-.06,5.22-.06,9.14,0,13.35.07,37.41.07,37.41l-2.87,49.85,8.08.03,7.58-43.31,5.84-35.79,4,35.79,1.12,43.03,9.46-.38,1.49-46.71.26-47.32c-.38.08-.79.12-1.23.12-7.31.04-14.5.12-21.77-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m113.1,206.48c-.06-8.12-.46-15.85-2.4-23.76-1.81-7.43-4.34-14.65-7.78-21.48-.05-.11-.09-.21-.14-.31-.11-.17-.21-.34-.3-.51-.06.05-.14.1-.2.16l3.92,35.07,1.12,43.03,7.82-.31c-.45-2.38-.87-4.75-1.11-7.06-.84-8.2-.87-16.58-.93-24.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m120.2,92.18c-2.78-7.11-3.68-6.98-5.93-8.06-19.52-9.41-30.81.17-36.25,2.7-1.1.51-1.92,4.44-1.77,5.65,1.77,14.65,5.62,22.49,6.42,29.14,1.03,8.58.85,24.4.85,24.4,11.93,6.72,35.04,0,35.04,0,0,0-.57-10.56-1.56-29.24-.33-6.19,5.58-18.54,3.21-24.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.81,
    y: 117.13,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.99 221.5) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.96,
    y: 116.97,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.52 211.49) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.66,
    y: 126.98,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.99 231.03) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.97,
    y: 107.28,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.98 211.96) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.89,
    y: 112.21,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.98 216.73) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.73,
    y: 131.75,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.53 225.79) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.89,
    y: 121.9,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.52 216.26) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.58,
    y: 131.91,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.99 235.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.81,
    y: 126.82,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.53 221.03) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 104.05,
    y: 102.36,
    width: 2.46,
    height: 2.46,
    transform: "translate(.02 207.2) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.74,
    y: 122.06,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.99 226.26) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.35,
    y: 97.19,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.28 187.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.28,
    y: 102.12,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.28 192.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.2,
    y: 107.04,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.28 196.96) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.57,
    y: 136.75,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.76 235.56) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.65,
    y: 136.67,
    width: 2.46,
    height: 2.46,
    transform: "translate(-44.53 230.56) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.43,
    y: 92.27,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.28 182.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 99.28,
    y: 92.43,
    width: 2.46,
    height: 2.46,
    transform: "translate(5.26 192.66) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 104.21,
    y: 92.51,
    width: 2.46,
    height: 2.46,
    transform: "translate(10.02 197.66) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 94.36,
    y: 92.35,
    width: 2.46,
    height: 2.46,
    transform: "translate(.49 187.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 104.13,
    y: 97.43,
    width: 2.46,
    height: 2.46,
    transform: "translate(5.02 202.43) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.84,91.29c.12.29.23.58.36.89-.12-.31-.24-.61-.36-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.46,86.45c.04.06.08.12.12.18-.04-.06-.08-.12-.12-.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.5,
    y: 136.83,
    width: 2.46,
    height: 2.46,
    transform: "translate(-35 240.57) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.73,
    y: 126.9,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.76 226.03) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.67,88.6c.12.25.25.52.38.81-.13-.29-.26-.56-.38-.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 79.58,
    y: 92.11,
    width: 2.46,
    height: 2.46,
    transform: "translate(-13.81 172.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.28,87.83c.11.22.23.45.35.69-.12-.25-.24-.48-.35-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.65,86.73c.04.07.09.14.14.22-.05-.07-.09-.15-.14-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.84,87.04c.06.11.13.22.2.34-.07-.12-.13-.23-.2-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.05,87.4c.06.11.13.23.19.35-.06-.12-.13-.24-.19-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.81,
    y: 121.98,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.76 221.26) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.65,
    y: 131.83,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.76 230.79) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 94.28,
    y: 97.27,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.51 192.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 94.2,
    y: 102.2,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.51 197.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 94.04,
    y: 112.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.52 206.72) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 94.12,
    y: 107.12,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.52 201.96) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 99.21,
    y: 97.35,
    width: 2.46,
    height: 2.46,
    transform: "translate(.26 197.43) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 99.05,
    y: 107.2,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.75 206.96) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.97,
    y: 112.13,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.75 211.73) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 99.13,
    y: 102.28,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.75 202.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.89,
    y: 117.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.75 216.49) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.43,90.3c.11.25.21.51.33.79-.11-.27-.22-.54-.33-.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.27,
    y: 106.97,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.05 191.96) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.35,
    y: 102.04,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.05 187.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.19,
    y: 111.89,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.06 196.72) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "108.33 142.85 110.79 142.89 110.83 140.42 108.36 141.82 108.33 142.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 88.64,
    y: 140.09,
    width: 2.46,
    height: 2.46,
    transform: "translate(-52.87 228.92) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "103.4 142.77 105.86 142.81 105.9 141.78 103.44 141.74 103.4 142.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 109.13,
    y: 92.58,
    width: 2.46,
    height: 2.46,
    transform: "translate(14.79 202.66) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 109.21,
    y: 87.66,
    width: 2.46,
    height: 2.46,
    transform: "translate(19.79 197.9) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.51,
    y: 87.34,
    width: 2.46,
    height: 2.46,
    transform: "translate(.73 177.89) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.59,
    y: 87.26,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.04 172.88) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 109.06,
    y: 97.51,
    width: 2.46,
    height: 2.46,
    transform: "translate(9.79 207.43) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 79.66,
    y: 87.19,
    width: 2.46,
    height: 2.46,
    transform: "translate(-8.81 167.88) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.59,
    y: 82.42,
    width: 2.46,
    height: 2.46,
    transform: "translate(5.73 173.12) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 79.5,
    y: 97.04,
    width: 2.46,
    height: 2.46,
    transform: "translate(-18.81 177.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.98,
    y: 97.59,
    width: 2.46,
    height: 2.46,
    transform: "translate(14.56 212.44) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 94.52,
    y: 82.5,
    width: 2.46,
    height: 2.46,
    transform: "translate(10.5 178.12) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 99.44,
    y: 82.58,
    width: 2.46,
    height: 2.46,
    transform: "translate(15.26 183.12) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 114.14,
    y: 87.74,
    width: 2.46,
    height: 2.46,
    transform: "translate(24.56 202.9) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 114.06,
    y: 92.66,
    width: 2.46,
    height: 2.46,
    transform: "translate(19.56 207.67) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 104.37,
    y: 82.66,
    width: 2.46,
    height: 2.46,
    transform: "translate(20.03 188.12) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 104.29,
    y: 87.58,
    width: 2.46,
    height: 2.46,
    transform: "translate(15.02 192.89) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 88.96,
    y: 121.82,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.29 211.26) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.04,
    y: 116.89,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.29 206.49) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 89.12,
    y: 111.97,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.29 201.72) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 88.88,
    y: 126.75,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.29 216.02) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 88.8,
    y: 131.67,
    width: 2.46,
    height: 2.46,
    transform: "translate(-44.3 220.79) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.43,
    y: 97.11,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.05 182.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 94.44,
    y: 87.42,
    width: 2.46,
    height: 2.46,
    transform: "translate(5.49 182.89) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 88.72,
    y: 136.6,
    width: 2.46,
    height: 2.46,
    transform: "translate(-49.3 225.56) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.98,
    y: 102.44,
    width: 2.46,
    height: 2.46,
    transform: "translate(4.79 212.2) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.51,
    y: 92.19,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.04 177.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 99.36,
    y: 87.5,
    width: 2.46,
    height: 2.46,
    transform: "translate(10.26 187.89) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.66,
    y: 122.14,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.23 231.26) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.74,
    y: 117.21,
    width: 2.46,
    height: 2.46,
    transform: "translate(-10.22 226.5) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.82,
    y: 112.29,
    width: 2.46,
    height: 2.46,
    transform: "translate(-5.22 221.73) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.9,
    y: 107.36,
    width: 2.46,
    height: 2.46,
    transform: "translate(-.21 216.97) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "98.47 142.69 100.94 142.73 100.98 141.7 98.51 140.23 98.47 142.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.57,
    y: 140.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(-48.1 233.91) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.58,
    y: 127.06,
    width: 2.46,
    height: 2.46,
    transform: "translate(-20.23 236.03) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.42,
    y: 136.91,
    width: 2.46,
    height: 2.46,
    transform: "translate(-30.23 245.56) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 108.5,
    y: 131.99,
    width: 2.46,
    height: 2.46,
    transform: "translate(-25.23 240.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.47,144.41c-.02-.39-.04-.85-.07-1.37.03.53.05.98.07,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m91.52,148.55c-.15-.02-.29-.04-.44-.06.14.02.29.04.44.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m92.94,148.73c-.18-.02-.35-.04-.53-.06.17.02.35.04.53.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,145.76s0-.07,0-.11c0,.04,0,.08,0,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.27,86.19c.04.05.08.11.12.17-.04-.06-.08-.11-.12-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,145.9c0,.06,0,.1,0,.1,0,0,0-.04,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m89.99,148.29c-.07-.01-.15-.03-.23-.04.07.02.15.03.23.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m95.77,148.95c-.72-.03-1.43-.08-2.13-.14.71.06,1.42.11,2.13.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m100.61,148.92c-.74.03-1.49.06-2.24.07.75,0,1.5-.03,2.24-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m103.13,148.76c-.71.06-1.42.11-2.14.15.72-.04,1.43-.09,2.14-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m97.58,148.99c-.45,0-.9-.01-1.34-.03.45.01.9.02,1.34.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.66,121.6c-.05-.4-.11-.81-.18-1.22.07.41.13.82.18,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m105.68,148.5c-.71.08-1.43.16-2.16.22.73-.07,1.45-.14,2.16-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.81,123.05c-.01-.11-.02-.21-.03-.31.01.1.02.21.03.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.02,125.62c0-.11-.01-.22-.02-.33,0,.11.02.22.02.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.13,118.63c-.06-.26-.12-.53-.18-.8.06.27.12.53.18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,144.26c0-.15,0-.3,0-.46,0,.16,0,.31,0,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,144.6c0-.08,0-.15,0-.24,0,.08,0,.16,0,.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.5,138.95c0-.06,0,.24,0,.54,0-.3,0-.6,0-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.5,139.5c0,.3,0,.6,0,.54,0,.06,0-.24,0-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,145.48s0-.09,0-.14c0,.05,0,.1,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,141.38c0-.06,0-.12,0-.18,0,.06,0,.12,0,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.68,111.18s0,.04-.01.07c0-.02,0-.04.01-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.55,127.47c.04.74.08,1.47.11,2.17-.04-.71-.07-1.43-.11-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.05,117.92c.02.43.05.85.07,1.27-.02-.42-.04-.84-.07-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.29,122.5c.03.63.07,1.25.1,1.86-.03-.61-.06-1.23-.1-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.21,113.59c0,.06-.02.12-.03.18,0-.06.02-.12.03-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.41,124.93c.03.66.07,1.31.1,1.95-.03-.64-.07-1.29-.1-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.16,120.1c.04.67.07,1.33.1,1.98-.03-.65-.07-1.31-.1-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m81.47,115.96c-.08-.29-.16-.58-.24-.88.08.3.16.59.24.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m120.29,100.14c-.14.79-.31,1.6-.5,2.42.18-.82.35-1.63.5-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m120.73,96.55c-.02.36-.04.72-.08,1.09.04-.37.06-.73.08-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.17,105.15c-.13.5-.26,1.01-.38,1.51.13-.5.26-1,.38-1.51Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 79.43,
    y: 101.96,
    width: 2.46,
    height: 2.46,
    transform: "translate(-23.82 182.18) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m111.88,147.54c-.27.05-.56.1-.85.16.29-.05.57-.1.85-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m106.93,148.35c-.17.02-.35.04-.53.07.18-.02.35-.04.53-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.02,147.32c-.23.05-.46.09-.7.14.24-.05.47-.09.7-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m108.19,148.17c-.14.02-.29.04-.44.06.15-.02.29-.04.44-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m109.61,147.95c-.08.01-.15.03-.23.04.08-.01.15-.03.23-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.63,146.25c-.1.03-.21.05-.32.08.11-.03.22-.06.32-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.06,146.14c-.07.02-.15.04-.24.06.09-.02.17-.04.24-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.08,146.39c-.12.03-.26.07-.4.1.14-.03.27-.07.4-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m116.4,146.56c-.16.04-.33.08-.51.12.17-.04.35-.08.51-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m88.5,147.95c-.55-.14-1.08-.3-1.6-.47.52.17,1.06.33,1.6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m98.21,80.06c.21,0,.42,0,.63.01-.21,0-.42-.01-.63-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m99.6,80.1c.14,0,.28.02.41.03-.14,0-.28-.02-.41-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m96.51,80.11c.16,0,.32-.02.49-.03-.16,0-.32.02-.49.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m100.94,80.2c.17.02.34.04.51.05-.17-.02-.34-.04-.51-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m103.81,80.6c.15.03.3.05.45.08-.15-.03-.3-.05-.45-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m102.35,80.36c.16.02.33.05.49.07-.17-.03-.33-.05-.49-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m92.57,80.61c.22-.04.44-.09.67-.13-.23.04-.45.08-.67.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m95.19,80.22c.18-.02.35-.04.52-.05-.18.01-.35.04-.52.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m90.85,80.99c.39-.1.79-.2,1.2-.28-.41.09-.81.18-1.2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m93.79,80.39c.23-.03.46-.07.69-.1-.23.03-.46.07-.69.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m116.86,85.7c.06.06.12.13.18.2-.06-.07-.12-.13-.18-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m116.68,85.52s.08.08.13.13c-.04-.04-.08-.09-.13-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m89.69,81.32c.33-.1.67-.2,1.02-.29-.35.09-.69.19-1.02.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.05,85.92c.05.06.11.13.16.19-.05-.07-.11-.13-.16-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m116.45,85.31c.06.05.12.1.18.16-.06-.06-.12-.11-.18-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m109.91,82.28c.34.12.67.24,1.02.38-.34-.13-.68-.26-1.02-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m112.23,83.2c.14.06.28.12.41.18-.14-.06-.28-.12-.41-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m107.14,81.38c.15.04.29.09.44.13-.15-.04-.29-.09-.44-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m108.71,81.86c.14.05.27.09.41.14-.14-.05-.28-.09-.41-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m80.31,111.8c-.02-.06-.04-.13-.05-.19.02.06.04.13.05.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m105.67,80.99c.07.02.14.04.21.06-.07-.02-.14-.04-.21-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.74,96.01c-.06-.39-.12-.78-.18-1.18.06.4.12.79.18,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.46,100.21c-.02-.11-.04-.22-.06-.33.02.11.04.22.06.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.27,91.47c.02-.15.04-.32.06-.48-.02.17-.05.33-.06.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.93,102.48c-.02-.11-.05-.21-.07-.32.02.11.05.21.07.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.23,91.98c0-.14.01-.29.03-.46-.02.17-.02.32-.03.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m79.89,110.29c-.04-.15-.09-.31-.13-.47.04.16.09.31.13.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.35,90.84c.03-.19.06-.38.1-.58-.04.2-.07.39-.1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.35,104.38s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m79.34,108.28c-.01-.05-.03-.1-.04-.15.01.05.03.1.04.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m88.51,81.7c.28-.1.57-.19.85-.28-.29.09-.57.18-.85.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.89,106.55c-.03-.12-.06-.25-.09-.37.03.12.06.25.09.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.52,83.86c.32-.16.65-.33.98-.49-.34.16-.66.33-.98.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.27,84.52c.34-.18.69-.37,1.05-.56-.36.19-.71.37-1.05.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m80.76,85.35c.33-.18.67-.38,1.02-.57-.36.2-.7.39-1.02.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.37,82.12c.24-.09.48-.18.73-.27-.25.09-.49.18-.73.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.74,86.46c.06-.03.13-.07.19-.1-.06.03-.13.07-.19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.23,87.8c.05-.1.1-.2.15-.29-.05.09-.1.19-.15.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.47,90.21c.04-.18.08-.36.12-.54-.05.18-.09.36-.12.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.42,87.44c.07-.11.14-.21.21-.29-.07.09-.14.18-.21.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.75,87.02s.04-.05.06-.07c-.02.02-.04.04-.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m120.75,95.29c0,.34,0,.69,0,1.04.01-.36.02-.7,0-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.18,147.28c.92-.19,1.76-.37,2.47-.54l.02-1.31-2.46-.04-.03,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.52,145.47h-.38s-.01.65-.01.65c.26-.07.42-.12.42-.12,0,0-.01-.28-.04-.8,0,.09,0,.2.01.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.24,119.13c.06.28.11.56.16.83-.04-.24-.09-.48-.14-.73,0-.03-.02-.07-.02-.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.67,
    y: 117.29,
    width: 2.46,
    height: 2.46,
    transform: "translate(-5.45 231.5) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "113.33 139.43 115.79 138.04 115.83 137.01 113.37 136.97 113.33 139.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 83.72,
    y: 140.01,
    width: 2.46,
    height: 2.46,
    transform: "translate(-57.64 223.91) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 83.96,
    y: 126.67,
    width: 2.46,
    height: 2.46,
    transform: "translate(-44.06 211.02) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.9,
    y: 102.51,
    width: 2.46,
    height: 2.46,
    transform: "translate(9.55 217.2) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.27,
    y: 140.48,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.03 253.93) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.18,84.74v-.18c-.11.06-.22.12-.32.18h.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.78,132.05c-.04-.77-.08-1.56-.12-2.38.04.82.08,1.61.12,2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.78,132.12s0-.05,0-.07c.01.25.03.5.04.74-.01-.22-.02-.44-.03-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m81.67,116.7c-.02-.08-.04-.16-.06-.24.07.28.14.55.21.82-.04-.17-.08-.35-.13-.52,0-.02,0-.04-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.91,134.58c.04.86.08,1.68.12,2.47.03.57.06.51.08.62-.08-1.15-.17-2.29-.27-4.23.02.39.04.77.06,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.16,138.08c-.01-.26-.03-.36-.04-.42.04.59.08,1.19.11,1.9-.02-.47-.05-.96-.07-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.28,140.54h-.06s-.04,2.46-.04,2.46h.22c-.04-.89-.1-1.97-.16-3.23.01.26.03.52.04.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m84.67,83.28l-.02,1.5,2.46.04.04-2.46h-.38c-.73.29-1.43.61-2.1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.01,92.72l-.04,2.46,1.78.03c-.03-.89-.14-1.72-.36-2.47l-1.38-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.9,124.08s0,.08,0,.11c0,0,0-.02,0-.03,0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.05,97.95l.02-.97h-.18c.05.32.1.65.16.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.07,126.46c0,.1.01.19.02.29,0-.04,0-.08,0-.11,0-.06,0-.12-.01-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.39,133.93c0,.07,0,.15,0,.22,0-.04,0-.08,0-.12,0-.03,0-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 83.8,
    y: 136.52,
    width: 2.46,
    height: 2.46,
    transform: "translate(-54.06 220.56) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.21,129.02s0,.09,0,.13c0-.02,0-.03,0-.05,0-.03,0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.18,89.59l.03-1.74c-.24.49-.44,1.11-.6,1.73h.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.31,131.53s0,.08,0,.12c0-.03,0-.05,0-.08,0-.01,0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.48,138.87c0,.1,0,.19,0,.28,0-.07,0-.13,0-.2,0-.03,0-.06,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,144.91h0s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.51,139.99s0,.01,0,.02c0-.04,0-.08,0-.11,0,.03,0,.06,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.64,146.07c.77.43,1.59.8,2.45,1.12l.04-2.24-2.46-.04-.02,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.66,121.6c0,.08.02.16.03.25,0-.05-.01-.1-.02-.15,0-.03,0-.06-.01-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m108.25,147.77l2.17.03c.1-.02.2-.03.29-.05l.04-2.41-2.46-.04-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 83.88,
    y: 131.59,
    width: 2.46,
    height: 2.46,
    transform: "translate(-49.06 215.79) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.44,136.4c0,.06,0,.12,0,.18,0-.03,0-.06,0-.1,0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.05,114.87s0-.02,0-.02c0,0,0,.01,0,.02,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m114.22,84.1l-.02,1.16,2.22.04c-.64-.52-1.3-.76-2.16-1.18-.02,0-.03-.01-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.41,112.49c.02-.08.03-.16.05-.24,0,.05-.02.1-.03.15,0,.03,0,.06-.02.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.51,
    y: 127.14,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.46 241.04) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m79.34,108.31c.09.35.19.69.28,1.03l2.17.03.04-2.46-2.46-.04-.02,1.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.11,
    y: 116.82,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.06 201.49) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.93,110.07c.02-.07.03-.14.05-.21,0,.03-.02.06-.02.1,0,.04-.02.08-.03.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.59,
    y: 122.21,
    width: 2.46,
    height: 2.46,
    transform: "translate(-10.45 236.27) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 93.49,
    y: 145.09,
    width: 2.46,
    height: 2.46,
    transform: "translate(-53.1 238.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.43,
    y: 132.07,
    width: 2.46,
    height: 2.46,
    transform: "translate(-20.46 245.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.74,
    y: 112.36,
    width: 2.46,
    height: 2.46,
    transform: "translate(-.45 226.74) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 88.56,
    y: 145.01,
    width: 2.46,
    height: 2.46,
    transform: "translate(-57.87 233.68) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.04,90.26h.37c-.12-.29-.24-.56-.36-.82v.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m81.09,114.55c-.03-.09-.05-.18-.07-.27h.7s.04-2.45.04-2.45l-1.44-.02c.27.96.53,1.87.78,2.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.03,
    y: 121.74,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.06 206.26) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.57,107.52c.03-.13.07-.27.1-.4-.03.13-.06.25-.1.38,0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.81,105.04h.39c.21-.81.41-1.63.59-2.45l-.94-.02-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m116.98,115.95c0-.07,0-.14,0-.21,0,.07,0,.14,0,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.89,100.11l1.41.02c.15-.84.27-1.66.35-2.46l-1.72-.03-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.24,92.47c.08.7.18,1.37.27,2.04h.59s.04-2.45.04-2.45h-.91c0,.15,0,.3.01.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m109.31,82.71l-.04,2.46,2.46.04.04-2.21c-.22-.09-.43-.18-.64-.26l-1.81-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 113.82,
    y: 107.44,
    width: 2.46,
    height: 2.46,
    transform: "translate(4.55 221.97) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.42,
    y: 145.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(-48.34 243.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 103.34,
    y: 145.25,
    width: 2.46,
    height: 2.46,
    transform: "translate(-43.57 248.7) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 77.12,
    y: 92.07,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.19 170.15) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m77.05,97.95c.09.51.18,1.01.27,1.5l2.17.03.04-2.46-2.46-.04-.02.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m79.3,108.13c.01.05.03.1.04.15,0,0,0,.02,0,.03l.02-1.44h-.4c.11.42.22.85.33,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m77.63,87.15c-.07.09-.14.18-.21.29-.01.02-.03.05-.04.07-.05.09-.1.19-.15.29,0,.01-.01.03-.02.04l-.03,1.74,2.46.04.04-2.46-2.04-.03s0,0-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m77.86,102.15c.02.11.05.21.07.32.14.65.28,1.28.43,1.89,0,0,0,.01,0,.02,0,0,0,0,0,0l1.05.02.04-2.46-1.64-.03c.02.08.03.16.05.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m83.52,83.86c-.07.03-.14.07-.2.1-.36.19-.71.37-1.05.56-.03.01-.05.03-.08.04v.18s2.46.04,2.46.04l.02-1.5c-.06.03-.11.06-.17.08-.34.16-.66.33-.98.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m83.32,131.64c.03.76.05,1.53.07,2.29,0,.03,0,.07,0,.1h.47s.04-2.46.04-2.46h-.58s0,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m83.09,126.75c.04.74.08,1.5.12,2.27,0,.03,0,.05,0,.08h.72s.04-2.45.04-2.45h-.89s0,.06,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m83.51,140.01c0,.42,0,.81,0,1.2,0,.06,0,.12,0,.18,0,.37,0,.73,0,1.07h.18s.04-2.46.04-2.46h-.23s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 81.73,
    y: 111.85,
    width: 2.46,
    height: 2.46,
    transform: "translate(-31.44 194.22) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 81.81,
    y: 106.93,
    width: 2.46,
    height: 2.46,
    transform: "translate(-26.43 189.45) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m81.81,117.28c.05.19.09.37.14.56.06.27.12.53.18.8.04.16.08.33.11.49,0,.03.02.07.02.1l1.83.03.04-2.46-2.45-.04c.05.18.09.35.13.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 81.97,
    y: 97.08,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.43 179.91) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 82.13,
    y: 87.22,
    width: 2.46,
    height: 2.46,
    transform: "translate(-6.43 170.38) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 82.05,
    y: 92.15,
    width: 2.46,
    height: 2.46,
    transform: "translate(-11.43 175.15) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m83.45,136.59c.01.78.03,1.55.04,2.29,0,.03,0,.06,0,.08h.29s.04-2.46.04-2.46h-.37s0,.06,0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m82.69,121.85c.03.29.06.58.09.89.01.1.02.21.03.31.03.33.06.68.09,1.03,0,.03,0,.06,0,.09l1.1.02.04-2.46-1.39-.02s.01.1.02.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 81.89,
    y: 102,
    width: 2.46,
    height: 2.46,
    transform: "translate(-21.43 184.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m83.51,144.93c0,.15,0,.28,0,.4,0,.05,0,.09,0,.14,0,.06,0,.12,0,.17,0,.04,0,.08,0,.11,0,.06,0,.1,0,.14,0,.06,0,.1,0,.1.04.02.09.05.14.07l.02-1.16h-.15s0,0,0,.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 87.05,
    y: 87.3,
    width: 2.46,
    height: 2.46,
    transform: "translate(-1.66 175.39) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.5,
    y: 121.78,
    width: 2.46,
    height: 2.46,
    transform: "translate(-36.67 208.76) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.81,
    y: 102.08,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.67 189.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 87.13,
    y: 82.38,
    width: 2.46,
    height: 2.46,
    transform: "translate(3.34 170.62) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.73,
    y: 107,
    width: 2.46,
    height: 2.46,
    transform: "translate(-21.67 194.45) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.66,
    y: 111.93,
    width: 2.46,
    height: 2.46,
    transform: "translate(-26.67 199.23) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.97,
    y: 92.23,
    width: 2.46,
    height: 2.46,
    transform: "translate(-6.66 180.15) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m86.09,147.19c.22.08.45.16.67.24l1.78.03.04-2.46-2.46-.04-.04,2.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.58,
    y: 116.86,
    width: 2.46,
    height: 2.46,
    transform: "translate(-31.67 203.99) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.26,
    y: 136.56,
    width: 2.46,
    height: 2.46,
    transform: "translate(-51.68 223.05) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.89,
    y: 97.15,
    width: 2.46,
    height: 2.46,
    transform: "translate(-11.66 184.92) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.34,
    y: 131.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(-46.68 218.29) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.18,
    y: 140.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(-55.25 226.41) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.42,
    y: 126.71,
    width: 2.46,
    height: 2.46,
    transform: "translate(-41.68 213.52) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.42,
    y: 121.86,
    width: 2.46,
    height: 2.46,
    transform: "translate(-31.91 213.76) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.5,
    y: 116.93,
    width: 2.46,
    height: 2.46,
    transform: "translate(-26.9 208.99) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.98,
    y: 87.38,
    width: 2.46,
    height: 2.46,
    transform: "translate(3.11 180.39) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.11,
    y: 140.13,
    width: 2.46,
    height: 2.46,
    transform: "translate(-50.48 231.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.82,
    y: 97.23,
    width: 2.46,
    height: 2.46,
    transform: "translate(-6.9 189.92) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.58,
    y: 112.01,
    width: 2.46,
    height: 2.46,
    transform: "translate(-21.9 204.22) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.34,
    y: 126.78,
    width: 2.46,
    height: 2.46,
    transform: "translate(-36.91 218.53) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.26,
    y: 131.71,
    width: 2.46,
    height: 2.46,
    transform: "translate(-41.91 223.29) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.9,
    y: 92.31,
    width: 2.46,
    height: 2.46,
    transform: "translate(-1.89 185.16) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.19,
    y: 136.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(-46.91 228.06) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 92.05,
    y: 82.46,
    width: 2.46,
    height: 2.46,
    transform: "translate(8.11 175.62) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.66,
    y: 107.08,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.9 199.46) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.74,
    y: 102.16,
    width: 2.46,
    height: 2.46,
    transform: "translate(-11.9 194.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 91.03,
    y: 145.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(-55.49 236.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.11,
    y: 136.71,
    width: 2.46,
    height: 2.46,
    transform: "translate(-42.15 233.06) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.9,
    y: 87.46,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.88 185.39) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.43,
    y: 117.01,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.13 214) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.58,
    y: 107.16,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.13 204.46) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.51,
    y: 112.09,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.14 209.23) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.66,
    y: 102.24,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.13 199.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.82,
    y: 92.39,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.88 190.16) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.74,
    y: 97.31,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.13 194.93) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.19,
    y: 131.79,
    width: 2.46,
    height: 2.46,
    transform: "translate(-37.14 228.3) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.27,
    y: 126.86,
    width: 2.46,
    height: 2.46,
    transform: "translate(-32.14 223.53) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.35,
    y: 121.94,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.14 218.76) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.03,
    y: 140.21,
    width: 2.46,
    height: 2.46,
    transform: "translate(-45.72 236.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 96.98,
    y: 82.54,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.88 180.62) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m98.21,80.06c-.09,0-.17,0-.26,0l1.23.02c-.11,0-.23,0-.34,0-.21,0-.42-.01-.63-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 95.95,
    y: 145.13,
    width: 2.46,
    height: 2.46,
    transform: "translate(-50.72 241.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.27,
    y: 122.02,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.38 223.76) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.35,
    y: 117.09,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.37 218.99) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.51,
    y: 107.24,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.37 209.46) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.43,
    y: 112.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.37 214.23) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 100.88,
    y: 145.21,
    width: 2.46,
    height: 2.46,
    transform: "translate(-45.96 246.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.19,
    y: 126.94,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.38 228.53) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.75,
    y: 92.47,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.64 195.16) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.83,
    y: 87.54,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.64 190.39) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.59,
    y: 102.32,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.36 204.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.11,
    y: 131.87,
    width: 2.46,
    height: 2.46,
    transform: "translate(-32.37 233.3) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.04,
    y: 136.79,
    width: 2.46,
    height: 2.46,
    transform: "translate(-37.38 238.07) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "100.94 142.73 103.4 142.77 103.44 141.74 100.98 141.7 100.94 142.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.67,
    y: 97.39,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.64 199.93) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 101.91,
    y: 82.62,
    width: 2.46,
    height: 2.46,
    transform: "translate(17.65 185.63) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.04,
    y: 131.95,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.61 238.3) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.28,
    y: 117.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.6 224) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.12,
    y: 127.02,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.61 233.53) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 105.96,
    y: 136.87,
    width: 2.46,
    height: 2.46,
    transform: "translate(-32.61 243.07) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.67,
    y: 92.55,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.41 200.17) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.2,
    y: 122.1,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.61 228.77) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.44,
    y: 107.32,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.6 214.46) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.59,
    y: 97.47,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.41 204.93) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.36,
    y: 112.25,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.6 219.23) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.51,
    y: 102.4,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.4 209.7) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.83,
    y: 82.69,
    width: 2.46,
    height: 2.46,
    transform: "translate(22.41 190.63) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "105.86 142.81 108.33 142.85 108.36 141.82 105.9 141.78 105.86 142.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 105.8,
    y: 145.29,
    width: 2.46,
    height: 2.46,
    transform: "translate(-41.19 251.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 106.75,
    y: 87.62,
    width: 2.46,
    height: 2.46,
    transform: "translate(17.41 195.4) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.36,
    y: 107.4,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.17 219.46) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.12,
    y: 122.18,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.83 233.77) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.2,
    y: 117.25,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.84 229) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.44,
    y: 102.47,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.17 214.7) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.6,
    y: 92.62,
    width: 2.46,
    height: 2.46,
    transform: "translate(17.17 205.16) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m112.23,83.2c-.15-.07-.31-.12-.46-.19l-.04,2.21,2.46.04.02-1.16c-.53-.26-1.05-.49-1.57-.72-.14-.06-.28-.12-.41-.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.28,
    y: 112.33,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.83 224.23) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m110.71,147.76c.11-.02.21-.04.32-.06.29-.05.57-.1.85-.16.15-.03.3-.06.44-.09.24-.05.47-.09.7-.14.05-.01.11-.02.16-.03l.03-1.89-2.46-.04-.04,2.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 110.89,
    y: 136.95,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.85 248.07) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 110.97,
    y: 132.03,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.84 243.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 110.81,
    y: 140.44,
    width: 2.46,
    height: 2.46,
    transform: "translate(-31.42 251.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.04,
    y: 127.1,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.84 238.54) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.68,
    y: 87.7,
    width: 2.46,
    height: 2.46,
    transform: "translate(22.18 200.4) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 111.52,
    y: 97.55,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.17 209.93) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m118.67,88.6s-.02-.05-.04-.07c-.12-.25-.24-.48-.35-.69,0-.02-.02-.03-.02-.05l-1.64-.03-.04,2.46,2.46.04v-.82s0-.02,0-.03c-.13-.29-.26-.56-.38-.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 116.44,
    y: 97.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(16.94 214.93) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m116.19,114.85h.86s0,0,0,0c.03-.34.08-.7.14-1.07,0-.06.02-.12.03-.18.06-.36.12-.73.19-1.1,0-.03,0-.06.02-.09l-1.19-.02-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m116.27,109.92l1.7.03s.02-.06.02-.1c.18-.76.38-1.54.58-2.33,0,0,0-.02,0-.03l-2.27-.04-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 115.73,
    y: 140.52,
    width: 2.46,
    height: 2.46,
    transform: "translate(-26.64 256.44) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 116.52,
    y: 92.7,
    width: 2.46,
    height: 2.46,
    transform: "translate(21.94 210.17) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 116.36,
    y: 102.55,
    width: 2.46,
    height: 2.46,
    transform: "translate(11.93 219.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m117.82,132.79c-.01-.22-.02-.44-.03-.67l-1.87-.03-.04,2.46,2.04.03c-.02-.38-.04-.76-.06-1.15-.01-.21-.02-.43-.03-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m117.05,117.92c-.01-.2-.02-.4-.03-.6h-.87s-.04,2.45-.04,2.45l1.04.02c-.01-.2-.02-.4-.03-.6-.02-.42-.04-.84-.07-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m115.65,146.74c.08-.02.16-.04.24-.06.17-.04.35-.08.51-.12.1-.02.19-.05.28-.07.14-.03.27-.07.4-.1.08-.02.16-.04.23-.06.11-.03.22-.06.32-.08.07-.02.13-.04.2-.05.09-.02.17-.04.24-.06.02,0,.04-.01.06-.02v-.65s-2.45-.04-2.45-.04l-.02,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m115.83,137.01l-.04,1.03,2.36.04c-.04-.77-.08-.16-.12-1.03l-2.2-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m117.55,127.47c0-.1,0-.19-.01-.29l-1.54-.02-.04,2.46,1.71.03s0,0,0,0c-.04-.7-.07-1.43-.11-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m117.29,122.5c0-.08,0-.17-.01-.25l-1.21-.02-.04,2.46,1.37.02c0-.12-.01-.24-.02-.35-.03-.61-.06-1.23-.1-1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m109.91,82.28c-.2-.07-.39-.15-.59-.21v.64s1.8.03,1.8.03c-.06-.03-.13-.06-.2-.08-.34-.13-.68-.26-1.02-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m87.15,82.36v-.16c-.13.05-.26.1-.38.15h.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m105.67,80.99c-.42-.1-.84-.19-1.25-.27l-.03,1.92,2.46.04.02-1.37c-.33-.09-.66-.18-.99-.26-.07-.02-.14-.04-.21-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m100.94,80.2c-.31-.03-.62-.05-.92-.07-.14,0-.28-.02-.41-.03-.03,0-.07,0-.1,0l-.04,2.46,2.46.04.04-2.28c-.17-.02-.34-.04-.51-.06-.17-.02-.34-.04-.51-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m90.85,80.99s-.09.03-.14.04c-.35.09-.69.19-1.02.29-.02,0-.04.01-.06.02l-.02,1.06,2.46.04.03-1.74s-.04,0-.06.01c-.41.09-.81.18-1.2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m96.51,80.11c-.27.01-.53.03-.79.05-.18.01-.35.04-.52.05-.21.02-.41.04-.62.07l-.04,2.19,2.46.04.04-2.43s-.03,0-.05,0c-.16,0-.32.02-.49.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m88.51,81.7c-.14.05-.28.1-.42.15-.25.09-.49.18-.73.27-.07.03-.14.06-.22.08v.16s2.46.04,2.46.04l.02-1.06c-.09.03-.18.06-.26.08-.29.09-.57.18-.85.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m93.79,80.39c-.18.03-.37.05-.55.08-.23.04-.45.08-.67.13-.16.03-.31.06-.47.09l-.03,1.74,2.46.04.04-2.19s-.06,0-.09,0c-.23.03-.46.07-.69.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m97.95,80.07c-.31,0-.61,0-.91.02l-.04,2.43,2.46.04.04-2.46c-.11,0-.21,0-.32,0l-1.23-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m103.81,80.6c-.33-.06-.65-.12-.97-.17-.17-.03-.33-.05-.49-.07-.13-.02-.26-.03-.38-.05l-.04,2.28,2.46.04.03-1.92c-.05-.01-.11-.02-.16-.03-.15-.03-.3-.05-.45-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m108.71,81.86c-.38-.13-.76-.24-1.13-.35-.15-.04-.29-.09-.44-.13-.09-.03-.18-.05-.27-.07l-.02,1.37,2.46.04v-.64c-.06-.02-.12-.05-.19-.07-.14-.05-.28-.09-.41-.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 94.48,
    y: 84.96,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.99 180.51) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.63,
    y: 84.8,
    width: 2.46,
    height: 2.46,
    transform: "translate(-1.54 170.5) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89.55,
    y: 84.88,
    width: 2.46,
    height: 2.46,
    transform: "translate(3.22 175.5) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m116.45,85.31s-.02-.01-.03-.02l-2.22-.04-.04,2.46,2.46.04.04-2.26s-.02-.02-.03-.03c-.06-.06-.12-.11-.18-.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 104.33,
    y: 85.12,
    width: 2.46,
    height: 2.46,
    transform: "translate(17.53 190.51) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 99.4,
    y: 85.04,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.76 185.51) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 109.25,
    y: 85.2,
    width: 2.46,
    height: 2.46,
    transform: "translate(22.3 195.51) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m81.79,84.78c-.35.2-.7.39-1.02.57-.37.21-.72.41-1.06.59l-.02,1.22,2.46.04.04-2.46h-.32s-.05.02-.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m78.74,86.46c-.25.13-.5.25-.73.36-.07.03-.13.08-.2.13-.02.02-.04.04-.06.07-.04.04-.07.07-.11.12l2.04.03.02-1.22c-.27.15-.52.29-.77.42-.06.03-.13.07-.19.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 82.16,
    y: 84.76,
    width: 2.46,
    height: 2.46,
    transform: "translate(-3.92 168) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 87.09,
    y: 84.84,
    width: 2.46,
    height: 2.46,
    transform: "translate(.84 173) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 92.02,
    y: 84.92,
    width: 2.46,
    height: 2.46,
    transform: "translate(5.61 178.01) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.94,
    y: 85,
    width: 2.46,
    height: 2.46,
    transform: "translate(10.37 183) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.87,
    y: 85.08,
    width: 2.46,
    height: 2.46,
    transform: "translate(15.14 188.01) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.79,
    y: 85.16,
    width: 2.46,
    height: 2.46,
    transform: "translate(19.91 193.01) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.72,
    y: 85.24,
    width: 2.46,
    height: 2.46,
    transform: "translate(24.68 198.01) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m118.05,87.4s0-.01-.01-.02c-.07-.12-.13-.23-.2-.34-.02-.03-.04-.06-.06-.09-.05-.07-.09-.15-.14-.22-.02-.04-.04-.07-.07-.1-.04-.06-.08-.12-.12-.18-.02-.03-.04-.06-.07-.1-.04-.06-.08-.11-.12-.17-.02-.03-.04-.05-.06-.08-.05-.07-.11-.13-.16-.19,0,0-.01-.02-.02-.02-.06-.07-.12-.13-.18-.2-.02-.02-.03-.03-.05-.05-.04-.04-.08-.09-.13-.13,0,0-.02-.01-.02-.02l-.04,2.26,1.64.03s-.01-.02-.02-.03c-.06-.12-.13-.24-.19-.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 94.4,
    y: 89.89,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.99 185.27) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 99.32,
    y: 89.96,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.76 190.28) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.55,
    y: 89.73,
    width: 2.46,
    height: 2.46,
    transform: "translate(-6.54 175.27) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 114.1,
    y: 90.2,
    width: 2.46,
    height: 2.46,
    transform: "translate(22.06 205.28) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 109.17,
    y: 90.12,
    width: 2.46,
    height: 2.46,
    transform: "translate(17.29 200.28) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89.47,
    y: 89.81,
    width: 2.46,
    height: 2.46,
    transform: "translate(-1.78 180.27) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 79.62,
    y: 89.65,
    width: 2.46,
    height: 2.46,
    transform: "translate(-11.31 170.26) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 104.25,
    y: 90.04,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.52 195.27) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m119.84,91.29c-.03-.07-.05-.13-.08-.2-.11-.27-.22-.54-.33-.79,0-.01-.01-.02-.02-.04h-.37s-.04,2.46-.04,2.46l1.38.02c-.06-.19-.12-.38-.19-.56-.12-.31-.24-.61-.36-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m76.59,89.67c-.04.18-.09.36-.12.54,0,.02,0,.04-.01.06-.04.2-.07.39-.1.58,0,.05-.01.09-.02.14-.02.17-.05.33-.06.48,0,.02,0,.04,0,.06-.02.17-.02.32-.03.46,0,.02,0,.04,0,.05h.91s.04-2.45.04-2.45h-.57s-.01.05-.02.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 77.16,
    y: 89.61,
    width: 2.46,
    height: 2.46,
    transform: "translate(-13.69 167.76) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 82.09,
    y: 89.69,
    width: 2.46,
    height: 2.46,
    transform: "translate(-8.92 172.77) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 87.01,
    y: 89.77,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.16 177.77) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.94,
    y: 89.85,
    width: 2.46,
    height: 2.46,
    transform: "translate(.61 182.77) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.86,
    y: 89.92,
    width: 2.46,
    height: 2.46,
    transform: "translate(5.38 187.77) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.79,
    y: 90,
    width: 2.46,
    height: 2.46,
    transform: "translate(10.14 192.78) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.71,
    y: 90.08,
    width: 2.46,
    height: 2.46,
    transform: "translate(14.91 197.78) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.64,
    y: 90.16,
    width: 2.46,
    height: 2.46,
    transform: "translate(19.67 202.78) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 116.56,
    y: 90.24,
    width: 2.46,
    height: 2.46,
    transform: "translate(24.44 207.78) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.47,
    y: 94.65,
    width: 2.46,
    height: 2.46,
    transform: "translate(-11.55 180.03) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 94.32,
    y: 94.81,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.01 190.04) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 79.54,
    y: 94.57,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.31 175.03) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 109.1,
    y: 95.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.29 205.05) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 114.02,
    y: 95.13,
    width: 2.46,
    height: 2.46,
    transform: "translate(17.06 210.05) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 99.24,
    y: 94.89,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.76 195.04) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m118.97,95.19l-.04,2.46,1.72.03s0-.02,0-.03c.04-.37.06-.73.08-1.09,0-.07,0-.15.01-.22.01-.36.02-.7,0-1.04,0-.03,0-.05,0-.08l-1.78-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m76.56,94.83c.06.4.12.79.18,1.18.05.32.1.65.15.96h.18s.04-2.46.04-2.46h-.59c.02.1.03.21.04.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89.39,
    y: 94.73,
    width: 2.46,
    height: 2.46,
    transform: "translate(-6.78 185.03) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 104.17,
    y: 94.97,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.52 200.04) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 77.08,
    y: 94.53,
    width: 2.46,
    height: 2.46,
    transform: "translate(-18.7 172.53) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 82.01,
    y: 94.61,
    width: 2.46,
    height: 2.46,
    transform: "translate(-13.93 177.53) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.93,
    y: 94.69,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.16 182.54) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.86,
    y: 94.77,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.39 187.54) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.78,
    y: 94.85,
    width: 2.46,
    height: 2.46,
    transform: "translate(.38 192.54) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.71,
    y: 94.93,
    width: 2.46,
    height: 2.46,
    transform: "translate(5.14 197.54) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.63,
    y: 95.01,
    width: 2.46,
    height: 2.46,
    transform: "translate(9.91 202.55) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.56,
    y: 95.09,
    width: 2.46,
    height: 2.46,
    transform: "translate(14.67 207.55) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 116.48,
    y: 95.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(19.44 212.55) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.94,
    y: 100.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(12.05 214.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 99.17,
    y: 99.81,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.25 199.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 94.24,
    y: 99.74,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.02 194.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.39,
    y: 99.58,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.55 184.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 109.02,
    y: 99.97,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.29 209.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m118.85,102.57l.94.02s0-.02,0-.03c.19-.82.35-1.63.5-2.42,0,0,0,0,0,0l-1.41-.02-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 104.09,
    y: 99.89,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.52 204.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 79.47,
    y: 99.5,
    width: 2.46,
    height: 2.46,
    transform: "translate(-21.32 179.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89.32,
    y: 99.66,
    width: 2.46,
    height: 2.46,
    transform: "translate(-11.78 189.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m77.4,99.87c.02.11.04.22.06.33.11.58.23,1.15.35,1.71l1.64.03.04-2.46-2.17-.03c.03.14.05.29.08.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 81.93,
    y: 99.54,
    width: 2.46,
    height: 2.46,
    transform: "translate(-18.93 182.3) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.85,
    y: 99.62,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.16 187.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.78,
    y: 99.7,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.4 192.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.7,
    y: 99.78,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.63 197.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.63,
    y: 99.85,
    width: 2.46,
    height: 2.46,
    transform: "translate(.14 202.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.55,
    y: 99.93,
    width: 2.46,
    height: 2.46,
    transform: "translate(4.91 207.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.48,
    y: 100.01,
    width: 2.46,
    height: 2.46,
    transform: "translate(9.68 212.32) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 116.4,
    y: 100.09,
    width: 2.46,
    height: 2.46,
    transform: "translate(14.44 217.32) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.86,
    y: 104.98,
    width: 2.46,
    height: 2.46,
    transform: "translate(7.05 219.58) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89.24,
    y: 104.58,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.78 194.57) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 104.01,
    y: 104.82,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.48 209.58) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 94.16,
    y: 104.66,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.02 199.57) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 99.09,
    y: 104.74,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.25 204.58) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 79.39,
    y: 104.42,
    width: 2.46,
    height: 2.46,
    transform: "translate(-26.32 184.57) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m118.78,106.69s0-.02,0-.03c.13-.5.26-1,.38-1.51,0-.04.02-.07.03-.11h-.39s-.03,1.64-.03,1.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.31,
    y: 104.5,
    width: 2.46,
    height: 2.46,
    transform: "translate(-21.55 189.57) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.94,
    y: 104.9,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.29 214.58) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m78.79,106.18c.03.12.06.25.09.37.03.11.05.21.08.31h.4s.04-2.46.04-2.46l-1.05-.02c.14.61.29,1.21.44,1.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 81.85,
    y: 104.46,
    width: 2.46,
    height: 2.46,
    transform: "translate(-23.93 187.07) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.77,
    y: 104.54,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.17 192.07) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.7,
    y: 104.62,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.4 197.07) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.62,
    y: 104.7,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.63 202.08) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.55,
    y: 104.78,
    width: 2.46,
    height: 2.46,
    transform: "translate(-4.86 207.08) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.47,
    y: 104.86,
    width: 2.46,
    height: 2.46,
    transform: "translate(-.1 212.08) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.4,
    y: 104.94,
    width: 2.46,
    height: 2.46,
    transform: "translate(4.67 217.08) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m116.31,107.46l2.27.04c.03-.12.06-.25.1-.38.04-.14.07-.29.11-.43l.03-1.65-2.46-.04-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89.16,
    y: 109.51,
    width: 2.46,
    height: 2.46,
    transform: "translate(-21.78 199.34) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.86,
    y: 109.82,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.72 219.35) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.23,
    y: 109.43,
    width: 2.46,
    height: 2.46,
    transform: "translate(-26.55 194.33) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.93,
    y: 109.74,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.49 214.34) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 94.08,
    y: 109.59,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.02 204.34) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.78,
    y: 109.9,
    width: 2.46,
    height: 2.46,
    transform: "translate(2.05 224.35) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 99.01,
    y: 109.66,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.25 209.34) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m79.76,109.82c.04.16.09.31.13.47.12.45.25.88.37,1.31.02.06.04.13.05.19,0,0,0,0,0,.01l1.44.02.04-2.46-2.17-.03c.04.16.09.33.13.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 81.77,
    y: 109.39,
    width: 2.46,
    height: 2.46,
    transform: "translate(-28.94 191.84) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.69,
    y: 109.47,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.17 196.84) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.62,
    y: 109.55,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.4 201.84) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.55,
    y: 109.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.63 206.84) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.47,
    y: 109.7,
    width: 2.46,
    height: 2.46,
    transform: "translate(-9.86 211.85) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.4,
    y: 109.78,
    width: 2.46,
    height: 2.46,
    transform: "translate(-5.1 216.85) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.32,
    y: 109.86,
    width: 2.46,
    height: 2.46,
    transform: "translate(-.33 221.85) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m116.23,112.38l1.19.02s.02-.1.03-.15c.07-.33.14-.67.21-1.01,0-.02,0-.04.01-.07.08-.37.17-.74.26-1.12,0-.04.02-.08.03-.12l-1.7-.03-.04,2.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.7,
    y: 114.83,
    width: 2.46,
    height: 2.46,
    transform: "translate(-2.95 229.12) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.15,
    y: 114.35,
    width: 2.46,
    height: 2.46,
    transform: "translate(-31.55 199.1) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89.08,
    y: 114.43,
    width: 2.46,
    height: 2.46,
    transform: "translate(-26.79 204.1) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.85,
    y: 114.67,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.49 219.11) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 98.93,
    y: 114.59,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.26 214.11) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 94,
    y: 114.51,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.02 209.11) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m81.09,114.55c.05.18.1.36.15.53.08.3.16.59.24.88.04.17.09.34.13.5.02.08.04.16.06.24l.04-2.41h-.7c.03.08.05.17.07.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.78,
    y: 114.75,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.72 224.12) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m81.67,116.7s0,.04.01.05l2.45.04.04-2.46-2.46-.04-.04,2.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.62,
    y: 114.39,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.17 201.61) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.54,
    y: 114.47,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.4 206.61) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.47,
    y: 114.55,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.64 211.61) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.39,
    y: 114.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.87 216.61) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.32,
    y: 114.71,
    width: 2.46,
    height: 2.46,
    transform: "translate(-10.11 221.61) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.24,
    y: 114.79,
    width: 2.46,
    height: 2.46,
    transform: "translate(-5.33 226.62) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m116.15,117.31h.87c0-.17-.02-.36-.03-.54-.01-.26-.01-.54,0-.82,0-.07,0-.14,0-.21.01-.28.03-.57.06-.87,0,0,0,0,0,0h-.86s-.04,2.45-.04,2.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.63,
    y: 119.75,
    width: 2.46,
    height: 2.46,
    transform: "translate(-7.95 233.89) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.78,
    y: 119.59,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.49 223.88) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.7,
    y: 119.67,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.72 228.88) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 93.92,
    y: 119.44,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.02 213.88) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 89,
    y: 119.36,
    width: 2.46,
    height: 2.46,
    transform: "translate(-31.79 208.87) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.07,
    y: 119.28,
    width: 2.46,
    height: 2.46,
    transform: "translate(-36.56 203.87) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 98.85,
    y: 119.52,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.25 218.88) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m82.4,119.96c.03.14.06.28.08.42.07.41.13.82.18,1.22,0,.03,0,.06.01.09l1.39.02.04-2.46-1.83-.03c.05.25.09.49.14.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.54,
    y: 119.32,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.18 206.37) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.46,
    y: 119.4,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.41 211.38) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.39,
    y: 119.48,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.64 216.38) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.31,
    y: 119.55,
    width: 2.46,
    height: 2.46,
    transform: "translate(-19.87 221.38) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.24,
    y: 119.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.1 226.38) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.16,
    y: 119.71,
    width: 2.46,
    height: 2.46,
    transform: "translate(-10.34 231.38) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m117.16,120.1c0-.1-.01-.21-.02-.31l-1.04-.02-.04,2.46,1.21.02c0-.06,0-.12,0-.17-.03-.65-.07-1.31-.1-1.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.55,
    y: 124.68,
    width: 2.46,
    height: 2.46,
    transform: "translate(-12.96 238.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.62,
    y: 124.6,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.72 233.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84,
    y: 124.2,
    width: 2.46,
    height: 2.46,
    transform: "translate(-41.56 208.64) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 98.77,
    y: 124.44,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.26 223.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 88.92,
    y: 124.28,
    width: 2.46,
    height: 2.46,
    transform: "translate(-36.79 213.64) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 93.85,
    y: 124.36,
    width: 2.46,
    height: 2.46,
    transform: "translate(-32.02 218.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.7,
    y: 124.52,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.49 228.65) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m82.91,124.19c.03.36.06.73.08,1.1,0,.11.01.22.02.33.02.28.04.55.05.84,0,.06,0,.12.01.17h.89s.04-2.45.04-2.45l-1.1-.02s0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.46,
    y: 124.24,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.18 211.14) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.38,
    y: 124.32,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.41 216.14) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.31,
    y: 124.4,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.64 221.14) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.23,
    y: 124.48,
    width: 2.46,
    height: 2.46,
    transform: "translate(-24.88 226.14) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.16,
    y: 124.56,
    width: 2.46,
    height: 2.46,
    transform: "translate(-20.11 231.15) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111.08,
    y: 124.64,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.34 236.15) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m117.41,124.93c0-.07,0-.14-.01-.21l-1.37-.02-.04,2.46,1.54.02c0-.1-.01-.2-.02-.3-.03-.64-.07-1.29-.1-1.95Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 93.77,
    y: 129.29,
    width: 2.46,
    height: 2.46,
    transform: "translate(-37.02 223.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.62,
    y: 129.44,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.49 233.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 83.92,
    y: 129.13,
    width: 2.46,
    height: 2.46,
    transform: "translate(-46.56 213.41) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.47,
    y: 129.6,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.96 243.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 88.84,
    y: 129.21,
    width: 2.46,
    height: 2.46,
    transform: "translate(-41.79 218.41) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.54,
    y: 129.52,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.73 238.42) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 98.69,
    y: 129.37,
    width: 2.46,
    height: 2.46,
    transform: "translate(-32.26 228.41) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m83.22,129.15c.04.78.07,1.58.1,2.38,0,.01,0,.02,0,.04h.58s.04-2.45.04-2.45h-.72s0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.38,
    y: 129.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(-44.18 215.9) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.3,
    y: 129.25,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.41 220.91) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.23,
    y: 129.33,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.65 225.91) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.15,
    y: 129.41,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.88 230.91) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106.08,
    y: 129.48,
    width: 2.46,
    height: 2.46,
    transform: "translate(-25.11 235.92) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 111,
    y: 129.56,
    width: 2.46,
    height: 2.46,
    transform: "translate(-20.34 240.92) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m117.66,129.65l-1.71-.03-.04,2.46,1.87.03c-.04-.79-.08-1.61-.13-2.45,0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 98.61,
    y: 134.29,
    width: 2.46,
    height: 2.46,
    transform: "translate(-37.26 233.18) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.54,
    y: 134.37,
    width: 2.46,
    height: 2.46,
    transform: "translate(-32.49 238.18) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 88.76,
    y: 134.13,
    width: 2.46,
    height: 2.46,
    transform: "translate(-46.8 223.18) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 83.84,
    y: 134.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(-51.56 218.18) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.46,
    y: 134.45,
    width: 2.46,
    height: 2.46,
    transform: "translate(-27.73 243.18) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.39,
    y: 134.53,
    width: 2.46,
    height: 2.46,
    transform: "translate(-22.96 248.19) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 93.69,
    y: 134.21,
    width: 2.46,
    height: 2.46,
    transform: "translate(-42.03 228.18) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m83.39,134.15c.02.76.04,1.51.05,2.25,0,.03,0,.06,0,.09h.37s.04-2.46.04-2.46h-.47s0,.07,0,.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.3,
    y: 134.09,
    width: 2.46,
    height: 2.46,
    transform: "translate(-49.18 220.67) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.22,
    y: 134.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(-44.42 225.67) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 96.15,
    y: 134.25,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.65 230.68) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101.08,
    y: 134.33,
    width: 2.46,
    height: 2.46,
    transform: "translate(-34.88 235.68) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 106,
    y: 134.41,
    width: 2.46,
    height: 2.46,
    transform: "translate(-30.11 240.68) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 110.93,
    y: 134.49,
    width: 2.46,
    height: 2.46,
    transform: "translate(-25.34 245.69) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m115.87,134.55l-.04,2.46,2.2.04c-.04-.78-.08-1.6-.12-2.47l-2.04-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.46,
    y: 139.3,
    width: 2.46,
    height: 2.46,
    transform: "translate(-37.5 242.95) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "98.51 140.23 100.98 141.7 101.02 139.24 98.55 139.2 98.51 140.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "88.66 140.07 91.13 140.11 91.17 139.08 88.7 139.04 88.66 140.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m118.23,139.59l-.02.96h.06c-.01-.25-.02-.51-.04-.77,0-.06,0-.12,0-.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "93.59 140.15 96.05 140.19 96.09 139.16 93.63 139.12 93.59 140.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "108.36 141.82 110.83 140.42 110.87 139.39 108.4 139.35 108.36 141.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "113.29 140.46 115.75 140.5 115.79 138.04 113.33 139.43 113.29 140.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "83.74 139.99 86.2 140.03 86.24 139 83.78 138.96 83.74 139.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m83.49,139.16c0,.3,0,.59,0,.88,0,.12,0-1.19,0-1.08h-.02c0,.07,0,.13,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m83.51,139.9s0,.06,0,.09h.23s.04-1.03.04-1.03h-.28c0,.32,0,.63,0,.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "86.2 140.03 88.66 140.07 88.7 139.04 86.24 139 86.2 140.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "91.13 140.11 93.59 140.15 93.63 139.12 91.17 139.08 91.13 140.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "96.05 140.19 98.51 140.23 98.55 139.2 96.09 139.16 96.05 140.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 101,
    y: 139.26,
    width: 2.46,
    height: 2.46,
    transform: "translate(-39.88 240.44) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 105.92,
    y: 139.33,
    width: 2.46,
    height: 2.46,
    transform: "translate(-35.11 245.46) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "110.83 140.42 113.29 140.46 113.33 139.43 110.87 139.39 110.83 140.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m118.16,138.08l-2.36-.04-.04,2.46,2.46.04.02-.96s0-.02,0-.03c-.02-.47-.05-.96-.07-1.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 83.68,
    y: 142.47,
    width: 2.46,
    height: 2.46,
    transform: "translate(-60.14 226.3) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 88.6,
    y: 142.55,
    width: 2.46,
    height: 2.46,
    transform: "translate(-55.37 231.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 108.31,
    y: 142.87,
    width: 2.46,
    height: 2.46,
    transform: "translate(-36.3 251.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 93.53,
    y: 142.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(-50.61 236.3) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 98.45,
    y: 142.71,
    width: 2.46,
    height: 2.46,
    transform: "translate(-45.83 241.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m118.47,144.41c-.02-.39-.04-.84-.07-1.37,0-.01,0-.02,0-.03h-.22s-.04,2.46-.04,2.46h.38c0-.07,0-.17-.01-.27-.01-.22-.02-.48-.04-.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 103.38,
    y: 142.79,
    width: 2.46,
    height: 2.46,
    transform: "translate(-41.07 246.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 113.23,
    y: 142.95,
    width: 2.46,
    height: 2.46,
    transform: "translate(-31.53 256.31) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m83.52,143.8c0,.16,0,.31,0,.46,0,.03,0,.07,0,.1,0,.08,0,.16,0,.24,0,.11,0,.21,0,.31h0s.15,0,.15,0l.04-2.46h-.18c0,.49,0,.94,0,1.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.14,
    y: 142.51,
    width: 2.46,
    height: 2.46,
    transform: "translate(-57.76 228.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 91.07,
    y: 142.59,
    width: 2.46,
    height: 2.46,
    transform: "translate(-52.99 233.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 95.99,
    y: 142.67,
    width: 2.46,
    height: 2.46,
    transform: "translate(-48.22 238.8) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 100.92,
    y: 142.75,
    width: 2.46,
    height: 2.46,
    transform: "translate(-43.45 243.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 105.84,
    y: 142.83,
    width: 2.46,
    height: 2.46,
    transform: "translate(-38.68 248.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 110.77,
    y: 142.91,
    width: 2.46,
    height: 2.46,
    transform: "translate(-33.92 253.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 115.69,
    y: 142.99,
    width: 2.46,
    height: 2.46,
    transform: "translate(-29.15 258.81) rotate(-89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m103.3,148.74c.07,0,.15-.01.22-.02.73-.07,1.45-.14,2.16-.22.03,0,.06,0,.09-.01v-.76s-2.45-.04-2.45-.04l-.02,1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m88.54,147.96c.41.1.81.2,1.23.29.07.02.15.03.23.04.33.07.66.13,1,.18l.02-.97-2.46-.04v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m108.24,148.16c.39-.06.77-.12,1.14-.18.08-.01.15-.03.23-.04.27-.05.55-.09.81-.14l-2.17-.03v.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m93.45,148.78c.06,0,.12.01.19.02.71.06,1.42.11,2.13.14.05,0,.09,0,.14,0l.02-1.37-2.46-.04-.02,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m98.37,148.99h0c.75,0,1.5-.03,2.24-.07.08,0,.15,0,.23-.01l.02-1.26-2.46-.04-.02,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m86.89,147.48c.52.17,1.06.33,1.6.47.01,0,.03,0,.04,0v-.5s-1.78-.03-1.78-.03c.04.02.09.03.13.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m90.99,148.47s.06.01.1.02c.14.02.29.04.44.06.29.04.59.09.89.12.17.02.35.04.53.06.17.02.34.03.51.05l.02-1.25-2.46-.04-.02.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m95.91,148.95c.11,0,.22,0,.33.01.45.01.9.02,1.35.03.26,0,.53,0,.79,0l.02-1.38-2.46-.04-.02,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m100.84,148.91c.05,0,.1,0,.15,0,.72-.04,1.43-.09,2.14-.15.06,0,.12-.01.17-.02l.02-1.05-2.46-.04-.02,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m105.77,148.49c.21-.03.42-.05.64-.08.18-.02.35-.04.53-.07.28-.04.55-.08.82-.11.15-.02.3-.04.44-.06.02,0,.03,0,.05,0v-.39s-2.46-.04-2.46-.04v.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m113.36,95.54l-23.08,2.03c1.93,10.21-8.28,18.56-7.62,24.03,1.03,8.58.85,26.59.85,26.59,11.93,6.72,34.99,0,34.99,0,0,0,.47-10.49-1.52-31.43-.77-8.14-1.71-14.68-3.62-21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m114.45,107.13c-3.34-1.31-3.75-1.45-7.55-1.35-5.34.14-10.74.61-15.28,1.1-.73.08-1.87-5.18-2.72-7.19-.04.34-.1.69-.2,1.05-.41,1.46-4.4,18.12-6.3,19.05.1.61.2,1.22.27,1.8.06.54.23,2.36.29,3,.7,9.05.56,21.4.56,21.4,0,0,.01-.01.02-.03-.01,1.63-.02,3.51-.02,5.69,0,13.35.07,37.41.07,37.41l-2.87,49.85,6.46.02c-.32-2.19-.41-4.41-.43-6.46-.11-8.12.36-16.34.54-24.47.27-11.67,3.15-66.19,1.68-82.99,3.95-1.98,7.34-5.31,9.46-5.69,6.52-1.15,17.12,1.13,18.76.86-.1-.89-.07-2.54-.18-3.44-.27-2.12-2.17-9.42-2.54-9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m112.27,106.09l-22.85,4.87s-1.99-20.72-3.56-22.36c-2.86-2.97-6.92-2.89-8.48-1.28-1.42,1.46-1.26,4.59-1.33,5.72-.71,10.51,4.59,31.98,8.61,31.87.72-.02,25.85-12.97,27.32-13.34,0,0,.59.12,2.65-.18,1.17-.17,5.22-1.02,5.22-1.02-1.43-3.43-7.57-4.28-7.57-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m77.37,87.32c-1.42,1.46-1.26,4.59-1.33,5.72-.7,10.39,3.97,30.84,7.98,31.14-1.18-1.09-.91-4.95-.41-6.83.82-3.1,3.35-6.54,5.97-8.37.03-.02.07-.04.1-.06-.43-3.43-2.43-18.86-3.83-20.31-2.86-2.97-6.92-2.89-8.48-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.37,87.32c-1.42,1.46-1.26,4.59-1.33,5.72-.44,6.53.38,13.64,2.17,20.14,3.04-1.4,7.79-3.16,12.07-4.6-.7-4.57-3.16-18.67-4.43-19.98-2.86-2.97-6.92-2.89-8.48-1.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 80.23,
    y: 107.17,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.85 16.08) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 85.08,
    y: 106.3,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.62 16.92) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m84.6,87.55c.07.05.14.09.21.15-.07-.05-.14-.1-.21-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m84.04,87.19c.07.04.14.08.21.13-.07-.04-.14-.09-.21-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m86.03,88.87c.05.08.1.18.14.29-.05-.11-.1-.21-.14-.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 78.49,
    y: 97.47,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.16 15.61) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m85.16,87.98c.06.05.12.09.17.14-.06-.05-.12-.1-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m85.85,88.61s.09.12.14.2c-.05-.08-.1-.15-.14-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m81.62,86.32s.07,0,.11.02c-.04,0-.07-.01-.11-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m88.43,98.4h.05c-.15-.78-.3-1.53-.46-2.27l.41,2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m80.52,86.22c.22,0,.45.01.67.04-.23-.02-.45-.04-.67-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 77.62,
    y: 92.63,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.32 15.39) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m89.73,105.67l.43,2.42h.04c-.11-.68-.24-1.51-.4-2.44h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.86,86.65c.07.02.14.05.21.08-.07-.03-.14-.06-.21-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m88.86,100.82l.43,2.42.09-.02c-.14-.78-.29-1.6-.44-2.42h-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.29,86.47c.05.01.11.03.16.05-.05-.02-.11-.03-.16-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.08,92.04c.02.08.04.16.06.24-.02-.08-.04-.16-.06-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m89.4,103.34c.07.38.13.76.2,1.13-.06-.37-.13-.74-.2-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m88.49,98.46c.15.77.3,1.54.44,2.31-.14-.76-.29-1.54-.44-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.46,93.58c.08.34.16.69.24,1.04-.08-.35-.16-.7-.24-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m89.61,104.51c.06.37.12.72.18,1.07-.06-.34-.12-.7-.18-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 84.21,
    y: 101.45,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.78 16.69) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m90.2,108.09c.03.18.05.34.08.5-.02-.15-.05-.32-.08-.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 79.36,
    y: 102.32,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.01 15.85) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m86.22,89.25c.06.14.12.29.18.47-.06-.17-.12-.33-.18-.47Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 82.47,
    y: 91.76,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.1 16.23) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m86.64,90.46c.06.21.13.44.2.68-.07-.24-.13-.46-.2-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m86.44,89.83c.05.15.11.31.16.49-.05-.17-.11-.33-.16-.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 83.34,
    y: 96.6,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.93 16.46) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m79.69,86.28c.24-.03.5-.05.76-.06-.26,0-.51.02-.76.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m86.92,91.44c.02.08.04.16.07.25-.02-.09-.04-.16-.07-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.27,92.79s.02.08.03.12c-.01-.04-.02-.08-.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.75,94.85c.08.35.15.71.23,1.07-.08-.36-.15-.72-.23-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m75.93,95.58c0-.53.04-1.04.07-1.56-.03.52-.06,1.04-.07,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.48,112.69l-.38.07c.04.14.07.29.11.43.36-.17.75-.34,1.16-.51-.28.12-.56.24-.82.36l-.06-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m79.54,112.6c.36-.15.73-.31,1.12-.47-.25.1-.49.2-.73.3-.13.06-.26.11-.39.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m80.81,112.06c.43-.18.87-.35,1.33-.53-.44.17-.87.34-1.28.51-.02,0-.03.01-.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.06,92.6c0-.16,0-.33.02-.52,0,.19-.01.36-.02.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.08,91.98c0-.19.02-.39.03-.59-.01.21-.02.41-.03.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.11,91.28c.01-.21.03-.42.05-.64-.02.22-.04.43-.05.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.01,107.95c.15.81.32,1.61.5,2.41l.54-.1-.43-2.42-.6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.76,106.53c-.05-.31-.11-.62-.16-.93.05.31.1.62.16.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m87.61,109.51c.19-.07.38-.13.56-.2-.09.03-.18.06-.27.09-.1.03-.19.07-.29.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m82.53,111.38c.29-.11.59-.23.89-.34-.07.03-.15.06-.22.08-.23.09-.45.17-.67.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m90.19,108.62s.06-.02.09-.03c0,0-.02,0-.02,0-.02,0-.05.02-.07.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.82,111.65c-.09-.37-.19-.73-.27-1.1.08.37.18.73.27,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m75.94,98.08c-.01-.39,0-.77,0-1.16,0,.39,0,.77,0,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.28,103.08c.09.82.2,1.63.32,2.45l.58-.1-.43-2.42-.46.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m85.49,110.27c.1-.04.2-.07.3-.11-.08.03-.16.06-.24.08-.02,0-.04.02-.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m83.26,86.81l-1.86.33.43,2.42,2.42-.43-.36-2.01c-.21-.12-.43-.22-.64-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m77.68,87.05s.08-.05.12-.08c-.04.03-.08.05-.12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.5,88.91c.04-.12.08-.23.12-.34-.04.11-.08.23-.12.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.91,87.95c.13-.23.29-.44.46-.62-.18.18-.33.39-.46.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.91,87.95c-.1.17-.18.36-.26.55l.35,1.93,2.42-.43-.43-2.42-2.08.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.34,89.5c.04-.16.08-.32.12-.47-.05.16-.09.31-.12.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.84,86.47c.22-.07.46-.13.71-.17-.25.04-.48.1-.71.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.43,86.62c.06-.03.12-.05.18-.07-.06.02-.12.05-.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m78.03,86.82s.1-.05.16-.08c-.05.03-.11.05-.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.18,90.5c.01-.11.03-.23.05-.35-.02.12-.03.23-.05.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.06,100.61l.24-.04-.34-1.87c.02.64.05,1.27.09,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m76.25,89.99c.02-.13.05-.26.07-.39-.03.13-.05.26-.07.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m75.94,98.13c0,.19.02.38.03.57l.34,1.87,2.42-.43-.43-2.42-2.35.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m76.62,88.57c-.04.11-.08.23-.12.34-.01.04-.03.08-.04.12-.05.16-.09.31-.12.47,0,.03-.01.07-.02.1-.03.13-.05.26-.07.39,0,.05-.02.11-.02.16-.02.12-.03.23-.05.35,0,.03,0,.06-.01.09l.82-.15-.35-1.93s-.02.04-.03.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 77.81,
    y: 107.61,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.96 15.65) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m76.04,93.11c-.02.3-.02.6-.04.9-.03.52-.06,1.04-.07,1.56,0,.02,0,.04,0,.05l1.93-.35-.43-2.42-1.39.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 76.94,
    y: 102.76,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.12 15.42) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m78.54,113.04c.26-.12.54-.24.82-.36.06-.02.12-.05.18-.08.13-.06.26-.11.39-.17l-1.45.26.06.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 79.18,
    y: 87.34,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.37 15.58) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 80.05,
    y: 92.19,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.21 15.8) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 81.79,
    y: 101.89,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.89 16.27) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 82.66,
    y: 106.74,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.74 16.5) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 80.92,
    y: 97.04,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.05 16.04) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m87.27,92.79c-.04-.17-.08-.34-.12-.5-.02-.08-.04-.16-.06-.24-.03-.12-.06-.24-.09-.35-.02-.09-.04-.16-.07-.25-.02-.09-.05-.18-.07-.26l-2.15.39.43,2.42,2.32-.42c-.05-.22-.1-.44-.16-.66-.01-.04-.02-.08-.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m85.85,88.61c-.17-.17-.34-.33-.51-.49-.06-.05-.12-.1-.17-.14-.12-.1-.24-.2-.36-.29-.07-.05-.14-.1-.21-.15-.11-.08-.23-.16-.35-.23-.07-.04-.14-.09-.21-.13-.04-.02-.09-.05-.13-.07l.36,2.01,1.74-.31s0-.01-.01-.02c-.05-.08-.1-.15-.14-.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 86.64,
    y: 101.02,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.67 17.11) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m87.99,95.97l-2.42.43.43,2.42,2.42-.43-.41-2.27s-.02-.1-.03-.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 87.5,
    y: 105.87,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.51 17.34) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m78.62,86.55c-.06.02-.12.05-.18.07-.08.04-.16.08-.24.12-.05.03-.11.05-.16.08-.08.05-.16.1-.24.16-.04.03-.08.05-.12.08-.11.08-.21.17-.31.27-.18.18-.33.39-.46.62,0,0,0,0,0,0l2.08-.37-.2-1.09c-.06.02-.11.04-.17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m82.86,86.65c-.14-.05-.27-.09-.41-.13-.05-.02-.11-.03-.16-.05-.19-.05-.37-.09-.56-.13-.04,0-.07-.01-.11-.02-.13-.02-.25-.04-.38-.05l.16.88,1.86-.33c-.07-.03-.13-.06-.2-.09-.07-.03-.14-.06-.21-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m81.19,86.26c-.23-.02-.45-.04-.67-.04-.02,0-.04,0-.07,0-.26,0-.51.02-.76.06-.05,0-.1.01-.14.02-.25.04-.48.1-.71.17-.02,0-.04.01-.06.02l.2,1.09,2.42-.43-.16-.88s-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 82.04,
    y: 89.33,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.68 16.12) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 77.19,
    y: 90.2,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.91 15.28) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m76.17,90.59s0,.03,0,.05c-.02.22-.04.44-.05.64,0,.04,0,.07,0,.11-.01.21-.02.41-.03.59,0,.04,0,.07,0,.1,0,.19-.01.36-.02.52,0,.17-.01.32-.02.44,0,.02,0,.05,0,.07l1.39-.25-.43-2.42-.82.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 79.61,
    y: 89.77,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.79 15.7) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m86.64,90.46c-.02-.05-.03-.1-.05-.15-.05-.17-.11-.33-.16-.49-.01-.04-.03-.08-.04-.12-.06-.17-.12-.33-.18-.47-.01-.03-.03-.06-.04-.08-.05-.11-.1-.21-.14-.29,0-.02-.02-.04-.03-.05l-1.74.31.43,2.42,2.15-.39s0-.02,0-.03c-.07-.24-.13-.46-.2-.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 78.06,
    y: 95.05,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.75 15.5) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 82.91,
    y: 94.18,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.52 16.34) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m75.93,95.63c0,.43,0,.86,0,1.29,0,.39,0,.77,0,1.16,0,.02,0,.03,0,.05l2.35-.42-.43-2.42-1.93.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 80.48,
    y: 94.62,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.63 15.93) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m87.75,94.85c-.02-.08-.03-.15-.05-.23-.08-.35-.16-.7-.24-1.04,0,0,0,0,0-.01l-2.32.42.43,2.42,2.42-.43s0-.04-.01-.06c-.08-.36-.15-.72-.23-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 78.93,
    y: 99.9,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.59 15.73) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m88.49,98.46s0-.05-.01-.07h-.05s.43,2.43.43,2.43h.08s0-.04,0-.05c-.14-.76-.29-1.54-.44-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m76.06,100.61c.06.82.13,1.64.22,2.46l.46-.08-.43-2.42-.24.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 83.78,
    y: 99.03,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.36 16.57) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 76.5,
    y: 100.33,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.7 15.31) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 81.35,
    y: 99.46,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.47 16.16) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 86.2,
    y: 98.59,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.24 16.99) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m76.6,105.52s0,.05.01.08c.05.31.11.62.16.93.08.47.15.95.24,1.42l.6-.11-.43-2.42-.58.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 84.65,
    y: 103.88,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.2 16.8) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 79.8,
    y: 104.75,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.43 15.96) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m89.61,104.51s0-.02,0-.03c-.06-.37-.13-.75-.2-1.13,0-.04-.01-.08-.02-.12l-.09.02.43,2.42h.07s0-.07-.01-.09c-.06-.34-.12-.7-.18-1.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 77.37,
    y: 105.18,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.55 15.54) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 82.22,
    y: 104.31,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.32 16.38) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 87.07,
    y: 103.44,
    width: 2.46,
    height: 2.46,
    transform: "translate(-17.08 17.22) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m85.32,108.96l.23,1.28c.08-.03.16-.06.24-.08.61-.22,1.21-.44,1.82-.65.1-.03.19-.07.29-.1l-.16-.88-2.42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m80.47,109.83l.4,2.21c.41-.17.84-.34,1.28-.51.13-.05.26-.1.39-.15.22-.09.44-.17.67-.26l-.31-1.72-2.42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m90.2,108.09h-.04s.09.51.09.51c0,0,.02,0,.02,0-.02-.15-.05-.32-.08-.5,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m77.51,110.36c.01.06.02.12.04.18.08.37.18.73.27,1.1.09.37.18.75.28,1.11l.38-.07-.43-2.42-.54.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m78.04,110.27l.43,2.42,1.45-.26c.24-.1.48-.2.73-.3.05-.02.1-.04.16-.07.02,0,.03-.01.05-.02l-.4-2.21-2.42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m82.89,109.4l.31,1.72c.07-.03.15-.06.22-.08.67-.26,1.36-.51,2.06-.77.02,0,.04-.02.06-.02l-.23-1.28-2.42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m87.74,108.53l.16.88c.09-.03.18-.06.27-.09.68-.24,1.35-.47,2.02-.69.02,0,.05-.02.07-.02l-.09-.5-2.42.43Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m78.23,86.72c-.33.17-.63.37-.86.61-1.42,1.46-1.26,4.59-1.33,5.72-.44,6.53.38,13.64,2.17,20.14.97-.45,2.14-.94,3.39-1.44-5.21-6.49-5.24-17.44-3.36-25.04Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m106.03,57.61l-19.22,1.49.05,6.57c1.83,9.73,8.65,12.42,13.59,12.04,4.95-.38,6.69-5.13,6.42-9.26l-.84-10.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m102.29,70.44l-10.68.83.8,9.76c.23,2.95,4.63,5.17,7.58,4.95l2.06,3.27-.16-3.96c1.35-.96,1.37-2.86,1.2-5.08l-.8-9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m93.99,51.51s-8.57-.49-7.95,7.53l.54,7.01s.99,7.68,5.45,9.59l-1.32-5.83s-2.37,1.01-3.52-4.06c-.4-1.77.12-2.16.69-2.2.76-.06,1.13,1.36,1.13,1.36l.99-.24.27-2.64s-.32-2.83,2.62-3.06l13.14-1.37s2.68-3.31.87-7.86l-12.91,1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m92.77,75.51c6.37,6.45,10.14,2.54,10.14,2.54l-.12-.96c-3.62,1.71-10.02-1.58-10.02-1.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m118.91,90.8c-1.57,4.71-3.24,14.53-3.24,14.53l2.56,4.69-10.73,2.42-11.11,4.72s25.26,3,28.83,2.44c2-.31,4.87-1.19,3.16-7.47-1-3.67-9.46-21.33-9.46-21.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m123.71,106.01l-9.39,5.73-14.55,5.72s1.2.08,4.41.35c.3-.35.7-.65,1.22-.84.81-.3,4.84-2.19,8.31-3.74,1.59-.71,6.74-.06,7.72-.43.53-.2,1.52-.61,2-1.78-.04-.16.3-4.85.27-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.81,96.41l2.21,10.85c2.29-.35,6.47-.85,10.06-1.88-2.42-6.53-8.55-18.82-8.55-18.82-5.32,0-3.72,9.85-3.72,9.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m125.71,104.38c.13.34.26.68.38.99-.12-.32-.25-.65-.38-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m122.46,96.86c.34.73.67,1.47,1,2.2-.33-.73-.66-1.47-1-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.65,91.76c.03-.29.06-.58.1-.87-.04.29-.08.58-.1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.78,90.77c.04-.21.07-.43.12-.63-.05.21-.09.42-.12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m124.55,101.56c.14.33.28.65.41.97-.13-.32-.27-.64-.41-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m125.01,102.65c.14.34.27.67.4.99-.13-.32-.26-.65-.4-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m123.44,106.03c-.79.17-1.59.32-2.36.45.77-.13,1.56-.28,2.36-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.61,94.12c0-.22-.01-.45-.02-.68,0,.24,0,.47.02.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 116.76,
    y: 95.11,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.15 22.33) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 115.89,
    y: 90.26,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.31 22.1) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 117.63,
    y: 99.96,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.99 22.56) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.6,92.72c0-.29.02-.58.05-.87-.02.29-.04.59-.05.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m120.83,93.36c.16.34.32.68.49,1.03-.16-.35-.33-.69-.49-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.9,90.12c.05-.21.11-.41.17-.61-.06.2-.12.4-.17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.84,87.18c.04.09.1.2.15.3-.05-.11-.1-.21-.15-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.08,87.66c.03.07.07.14.1.21-.04-.07-.07-.14-.1-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.58,86.64s.03.06.05.1c-.02-.04-.03-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m114.67,88.16c.14-.22.29-.42.46-.6-.17.18-.32.38-.46.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.54,86.56s.01.02.02.04c-.01-.03-.02-.04-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.7,86.89c.04.07.07.15.12.24-.05-.09-.09-.17-.12-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.74,91.07c.16.34.33.7.51,1.06-.18-.37-.34-.72-.51-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.81,89.15c-.19-.39-.36-.74-.52-1.06.15.31.33.67.52,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m120.32,92.29c.14.3.28.6.43.9-.15-.31-.29-.61-.43-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m114.37,88.72c.08-.17.16-.32.25-.47-.09.15-.17.31-.25.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.88,89.29c.08.16.16.33.24.5-.08-.17-.16-.34-.24-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m119.19,89.93c.15.31.31.64.47.98-.16-.34-.32-.66-.47-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.74,107.01c-.16.02-.32.05-.47.07.15-.02.31-.04.47-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m121.84,96.9l.59-.11c-.33-.72-.66-1.44-.99-2.14l.4,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m116.88,107.13c-.08.01-.16.02-.24.03.08-.01.16-.02.24-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m114.12,89.37c.07-.2.14-.39.22-.57-.08.18-.15.37-.22.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.59,93.38l.11-.02-.1-.59c0,.21,0,.41,0,.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m115.16,87.53l.1.54,2.42-.43-.19-1.08c-1.01.01-1.76.38-2.33.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m117.98,106.97c.18-.03.37-.05.57-.08-.19.03-.38.06-.57.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "114.19 98.27 114.27 98.67 114.19 98.27 114.19 98.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "115.67 105.51 115.67 105.51 115.27 103.55 115.67 105.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "115.44 103.05 115 100.63 114.69 100.69 114.27 98.67 115.27 103.55 115.18 103.1 115.44 103.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m115.87,105.48l-.2.04.36,1.74c.1-.02.21-.03.32-.05-.05,0-.11.02-.15.02l-.31-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m114.14,95.78l-.4.07c.04.35.07.56.07.56l.38,1.86.38-.07-.43-2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m125.46,103.76l-2.31.41.33,1.85c.81-.17,1.61-.37,2.4-.59l-.21-1.15c-.07-.17-.14-.35-.21-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m122.28,99.32l.43,2.42,1.78-.32c-.32-.76-.66-1.53-1.01-2.32l-1.2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m118.3,105.04l.33,1.83c.76-.11,1.58-.24,2.43-.39l-.34-1.88-2.42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.69,95.34c-.01-.16-.03-.33-.04-.52.01.19.03.36.04.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.74,95.83c-.01-.12-.03-.26-.04-.41.01.15.03.29.04.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.64,94.75c-.01-.2-.03-.41-.03-.63,0,.22.02.43.03.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m115.13,87.56c-.17.18-.32.38-.46.6,0,0,0,.01-.01.02l.6-.11-.1-.54s-.02.02-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m115.87,105.48l.31,1.75s.1-.02.15-.02c.1-.01.2-.03.3-.04.08-.01.16-.02.24-.03.13-.02.26-.04.4-.06.15-.02.31-.04.47-.07.08-.01.16-.02.24-.03.18-.03.37-.05.57-.08.03,0,.05,0,.08-.01l-.33-1.83-2.42.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 115.2,
    y: 100.39,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.11 22.14) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m113.77,90.84s0,.03,0,.05c-.04.29-.08.58-.1.87,0,.03,0,.06,0,.09-.02.29-.04.59-.05.87,0,.02,0,.03,0,.05l.1.59,2.42-.43-.43-2.42-1.92.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 114.33,
    y: 95.54,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.26 21.91) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m119.74,91.07c-.03-.05-.05-.11-.08-.16-.16-.34-.32-.67-.47-.98,0-.02-.02-.04-.03-.06l-1.05.19.43,2.42,1.72-.31s-.01-.03-.02-.04c-.18-.37-.34-.72-.51-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m120.72,104.61l.34,1.88s.02,0,.03,0c.77-.13,1.56-.28,2.36-.45.01,0,.02,0,.03,0l-.33-1.85-2.42.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m121.36,94.48l-2.38.43.43,2.42,2.42-.43-.4-2.24c-.03-.06-.05-.12-.08-.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 120.05,
    y: 99.52,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.88 22.99) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m117.84,87.18s-.02-.03-.02-.05c-.05-.09-.09-.17-.12-.24-.03-.06-.05-.11-.07-.15-.02-.03-.04-.07-.05-.1,0-.01-.02-.03-.02-.04,0-.02-.02-.04-.02-.04-.02,0-.03,0-.05,0l.19,1.08.36-.06s-.03-.06-.05-.09c-.05-.11-.11-.21-.15-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m125.67,104.28l.21,1.15c.07-.02.14-.04.21-.06-.12-.32-.25-.65-.38-.99-.01-.03-.03-.07-.04-.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 115.45,
    y: 87.84,
    width: 2.46,
    height: 2.46,
    transform: "translate(-13.89 21.99) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m114.66,88.18s-.03.04-.04.07c-.09.15-.17.31-.25.47-.01.03-.03.05-.04.08-.08.18-.15.37-.22.57-.01.04-.03.09-.04.13-.06.2-.12.4-.17.61,0,0,0,.01,0,.02-.05.21-.09.42-.12.63,0,.02,0,.05-.01.07l1.92-.34-.43-2.42-.6.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m118.88,89.29s-.05-.09-.07-.14c-.19-.39-.36-.74-.52-1.06-.04-.08-.07-.15-.11-.22-.04-.07-.07-.14-.1-.21-.02-.03-.03-.06-.04-.09l-.36.06.43,2.42,1.05-.19s-.03-.06-.04-.08c-.08-.17-.16-.34-.24-.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 116.32,
    y: 92.68,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.73 22.22) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m113.59,93.38s0,.04,0,.06c0,.24,0,.47.02.68,0,0,0,0,0,0,0,.22.02.43.03.63,0,.02,0,.05,0,.07.01.19.03.36.04.52,0,.03,0,.05,0,.08.01.15.03.29.04.41,0,0,0,.01,0,.02l.4-.07-.43-2.42-.11.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 113.9,
    y: 93.12,
    width: 2.46,
    height: 2.46,
    transform: "translate(-14.84 21.8) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m120.83,93.36c-.03-.06-.05-.11-.08-.17-.15-.31-.29-.61-.43-.9-.02-.04-.04-.08-.05-.11l-1.72.31.43,2.42,2.38-.43s-.03-.06-.04-.09c-.16-.35-.33-.69-.49-1.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 117.19,
    y: 97.53,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.57 22.45) rotate(-10.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m122.46,96.86s-.02-.04-.03-.06l-.59.11.43,2.42,1.2-.22s-.01-.03-.02-.05c-.33-.73-.66-1.47-1-2.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "114.19 98.27 114.69 100.69 115 100.63 114.57 98.2 114.19 98.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 114.77,
    y: 97.97,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.68 22.02) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 119.62,
    y: 97.1,
    width: 2.46,
    height: 2.46,
    transform: "translate(-15.45 22.87) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 118.06,
    y: 102.38,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.41 22.67) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "115.18 103.1 115.67 105.51 115.87 105.48 115.44 103.05 115.18 103.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "m125.01,102.65s-.03-.08-.05-.12c-.13-.32-.27-.64-.41-.97-.02-.04-.04-.09-.06-.13l-1.78.32.43,2.42,2.31-.41s-.03-.08-.05-.12c-.13-.32-.26-.65-.4-.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 115.64,
    y: 102.82,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.53 22.26) rotate(-10.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 120.49,
    y: 101.95,
    width: 2.46,
    height: 2.46,
    transform: "translate(-16.3 23.09) rotate(-10.16)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m86.81,82.34l-2.79,1.27s4.89,3.48,6.5,16.16l4.59-1.5s-3.59-12.22-8.29-15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "m106.9,81.31s3.24,8.14,3.38,15.17l4.25,3.75s-2.47-14.32-4.44-17.9l-3.19-1.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m92.18,78.21l-2.62,3.2c1.89,4.92,7.8,6.4,7.8,6.4l1.71-3.66c-6.19-.83-6.89-5.94-6.89-5.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m102.97,78.53s.56,2.5-1.08,4.67l3.29,2.66s-.33-1.98-.39-4.56l-1.82-2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m98.26,85.86s1.04.21,1.72.11l-.92-1.83-.8,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "m101.89,85.28s.77-.31,1.02-1.25l-1.02-.83v2.08Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "80.01 241.25 90.71 240.72 91.92 222.64 80.47 222.64 80.01 241.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "106.3 242.65 116.98 243.3 118.4 222.64 105.98 222.64 106.3 242.65"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "83.13 223.43 86.58 224.39 130.65 72.85 127.2 71.89 83.13 223.43"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 81.25,
    y: 207.76,
    width: 4.17,
    height: 46.46,
    transform: "translate(-162.16 236.74) rotate(-71.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m59.64,228.61s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29s3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m64.93,230.38s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29,1.31-.44,3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m70.22,232.15s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29,1.31-.44,3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m75.51,233.92s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29s3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m80.8,235.69s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29s3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m86.08,237.46s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29,1.31-.44,3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m91.37,239.23s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29,1.31-.44,3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m96.66,241s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29,1.31-.44,3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m101.95,242.77s-1.11,1.57-2.88,2.82c0,0-.44.73.87.29,1.31-.44,3.79-2.62,3.79-2.62l1.27-3.79-1.46-1.42-1.58,4.71Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 79.06,
    y: 222.01,
    width: 10.65,
    height: 5.27,
    transform: "translate(-155.42 233.4) rotate(-71.5)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "m122.43,102.65l-.96,1.88s-1.4.56-3.04-.02c-.83-.3.14-2.16.14-2.16l-2.83.46-3.46,3.29-1.94,5.05c6.24,2.22,11.58.84,11.81.29.17-.41,1.69-3.83,1.59-6.05-.02-.47-.84-2.6-1.29-2.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m258.51,242.61l-5.21-3.73-6.44-.25s-1.57,4.36-1.69,7.68h17.8s-.19-3.09-4.47-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m281.95,242.71l-8.46-3.96-6.01-.11s-2.37,4.63-2.05,7.67h20.87s-.19-2.98-4.35-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m282.59,92.01l-9.61.05,4.47,30.99s1.33,6.09,1.93,7.9c.16.47.38,1.03.64,1.66.29-.11.63-.17,1.01-.17,2.03,0,4.07.02,6.08.24l-2.58-9.79-1.94-30.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m282.59,90.22h.02s-.74-1.44-.74-1.44c-.84-1.32-2.46-3.14-5.18-3.73l-13.82-3.88c-.02-.09-1.15-.02-1.16.07l-13.05,5.52c-3.45,1.14-4.8,4.12-5.23,5.37l-1.8,10.06c.59.16,4.66,2.23,9.41,2.52l.53,6.51c3.11-2.74,7.44-4.55,10.94-6.41,4.86-2.59,10.81-2.57,16.29-2.73,0,0,0-.01,0-.02,2.39-.92,4.79-2.05,5.19-2.22l-1.38-9.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m280.29,148.03s0,0,.01,0c0-.13-.02-.28-.03-.45-.11-2.6-.21-4.78-.29-5.42h-.15c-.06-.59-.12-1.04-.17-1.27l-4.34-13.76.82-15.85c1.57-.97,2.63-2.81,2.63-4.91v-.39s-.09-1.23-.3-2.94c.11-.03-1.28-6.04-1.3-6.11,0,0-16.44.68-22.25.66.18,5.07-1.81,9.64-3.35,13.03-.22.48-.51.82-.84,1.06l.25,12.94-3.31,14.41c-.3,3.12-.58,8.91-.58,10.18,0,5.53,2.82,35.78,2.82,37.31,0,3.52-.95,12.49-1.44,17.35-.29,2.85-1.6,34.75-1.6,34.75l7.21.28,7.11-47.52,3.66-32.86,2.57,30.51s-.34,8.35-.95,13.83c-1.21,10.95-.22,37.12-.22,37.12l8.3-.75,3.58-45.67s2.72-32.17,2.5-37.2c-.1-2.31-.22-5.53-.33-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m251.57,110.63c-.22.48-.51.82-.84,1.06l.25,12.94-3.31,14.41c-.3,3.12-.58,8.91-.58,10.18,0,5.53,2.82,35.78,2.82,37.31,0,3.52-.95,12.49-1.44,17.35-.29,2.85-1.6,34.75-1.6,34.75l2.27.04c-.61-8.47,3.53-48.6,3.67-60.3,0-.5,0-1,0-1.5-.34-1.61-.63-3.23-.79-4.87-.53-5.76-.71-11.62-.75-17.4-.03-5.1.2-10.15,0-15.25-.19-4.82-.06-9.51,2.01-13.95.08-.18.18-.32.28-.47.07-5.26-.23-10.51-1.37-15.7-.21.49-.42.95-.63,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m265.36,158.18c-.33.22-.52.35-.52.35l2.57,30.51s-.34,8.35-.95,13.83c-1.21,10.95-.22,37.12-.22,37.12l4.29-.39c-2.4-11.93.06-24.95.13-36.9.08-15.06-1.38-29.97-5.3-44.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m243.41,92.13l-1.8,10.06c.44.12,2.87,1.33,6.08,2.04-.99-.97-1.81-10.77,1.14-13.29,2.82-2.41,6.78-5.87,9.52-8.28l-9.71,4.11c-3.45,1.14-4.8,4.12-5.23,5.37Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m262.93,50.15c-11.6-.29-16.43,6.09-16.15,13.87.41,11.01,5.88,13.99,13.65,13.71,7.78-.29,14.72-1.34,14.25-14.63-.32-8.9-3.98-12.75-11.76-12.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m269.45,63.27l-7.79.2c-2.75.07-4.97,2.27-5.08,5.02-.12,2.99-.15,6.42.31,7.41,2.01,4.41,5.98,7.79,10.69,3.81,2.77-2.34,4.2-5.89,4.07-9.51l-.19-5.05c-.04-1.07-.93-1.91-2-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m257.27,74.77l.48,10.03c.1,2.79,2.69,5.6,5.47,5.5,2.78-.1,4.71-3.08,4.61-5.87l-.48-10.03-10.08.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m260.57,79.41c3.47,3.36,7.07,1.16,7.07,1.16l-.03-.91c-3.08,1.93-7.04-.25-7.04-.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m242.4,124.2l-.04.65c2.66-.45,5.32-.71,8-.88l.71-19.22-8.22-2.45c-1.05,11.78-.44,21.9-.44,21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m275.13,84.4l-3.11-1.27s1.11,5.59,1.28,7.31c.21,2.15.66,8.51.66,8.51l3.46-.48s-.67-6.24-.96-8.35c-.18-1.33-1.33-5.73-1.33-5.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m309.98,133.51c-1-1.26.55-3.65-1.93-3.92-2.48-.27-5.97,7.34-5.97,7.34,0,0-2.78,2.56,0,3.95,2.78,1.39,5.62-.46,7.53-1.81,1.91-1.36,0-1.74.36-2.14.36-.4,1-2.15,0-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m309.98,133.51c-1-1.26.55-3.65-1.93-3.92-2.48-.27-5.97,7.34-5.97,7.34,0,0-2.78,2.56,0,3.95,2.78,1.39,5.62-.46,7.53-1.81,1.91-1.36,0-1.74.36-2.14.36-.4,1-2.15,0-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m295.05,135.34s-1.51-1.79-3.02-1.15c-1.51.64-.27,2.69.57,3.84.84,1.15-1.12,1.83,2.57,2.93,3.7,1.1,2.84,2.71,7.08.73,4.24-1.98-7.21-6.36-7.21-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m295.05,135.34s-1.3-1.54-2.7-1.24c.61,1.06,1,2.29,1.28,3.56,0,0,.12.48.16.68.03,0,.22.38.14.32.28.32.64.57.94.87.54.55.98,1.14,1.3,1.79,2.58,1.04,2.28,2.16,6.09.39,4.24-1.98-7.21-6.36-7.21-6.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m306.57,129c-1.73-1.77-4.16-3.32-6.52-2.96-1.77.26-3,1.7-4.08,3.14-1.48,1.97-2.47,4.26-2.14,6.61.57,4.07,4.16,6.2,8.36,5.57,4.2-.62,7.43-3.77,6.86-7.83-.25-1.78-1.14-3.14-2.49-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m304.1,125.86c-1.43-1.35-3.15.18-3.15.18,0,0,.9,1.83-.17,3.84-1.07,2.01-4.33,6.51-.6,11.56l.16-.09s-.16-2.11.28-3.88c.44-1.77-.29-2.09-.29-2.09.19-1.59.44-1.77,2.66-3.67,2.22-1.89.32-2.61.32-2.61.48-.5,2.22-1.89.79-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m300.95,126.05s-1.26-2.09-1.37.06c-.11,2.15,1.09,1.83.8,2.73,0,0-1.26.9-1.74,2.39-.48,1.49-1.67,7,1.54,10.22,0,0-3.12-4.73.26-9.21,3.38-4.48.51-6.19.51-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m305.61,136.41c-.08-.09-.17-.17-.26-.24-.09-.07-.19-.14-.3-.2-.1-.06-.21-.1-.32-.13-.11-.04-.23-.05-.34-.06.11.04.21.07.31.13.1.05.19.11.28.18.09.07.17.15.24.22.07.08.14.17.21.26.06.09.12.18.18.28.06.09.1.2.15.3.09.2.17.41.24.63.13.43.23.87.3,1.32.03.2.05.39.08.59.14-.1.26-.21.39-.31.03-.1.3-.22.29-.26-.11-.46-.48-1.05-.67-1.49-.19-.44-.44-.86-.76-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m307.75,133.76c-.14-.45-.32-.89-.57-1.28-.24-.4-.54-.76-.88-1.06-.17-.16-.35-.29-.53-.41-.18-.13-.38-.23-.58-.33.34.28.66.59.93.93.14.17.26.34.37.53.11.18.22.37.31.56.18.39.31.8.4,1.21.09.42.14.84.16,1.27.02.43,0,.86-.03,1.29-.04.43-.1.86-.18,1.29-.08.43-.18.85-.3,1.27,0,.01,0,.03-.01.04.01.06.02.12.04.18.32-.28.61-.59.87-.92.03-.14.07-.29.1-.43.09-.45.15-.91.18-1.38.03-.46.03-.93-.01-1.4-.04-.47-.12-.93-.26-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m296.42,130.88c-.16.15-.34.3-.52.51-.09.1-.18.2-.27.32-.09.11-.18.23-.26.37-.08.13-.17.26-.24.41-.04.07-.08.15-.11.22-.03.08-.07.15-.1.23-.14.31-.24.65-.33.99-.08.35-.15.71-.18,1.07-.04.36-.05.73-.05,1.08,0,.28.02.56.04.84-.02.24-.03.49-.03.72.05.11.1.22.16.33.12.23.25.46.4.67.16.24.34.47.54.68-.05-.16-.11-.33-.16-.51-.07-.25-.15-.52-.22-.82-.07-.29-.13-.6-.18-.92-.04-.27-.08-.55-.1-.84,0-.04,0-.08.01-.12.03-.25.08-.49.14-.72.06-.23.15-.45.24-.65.05-.1.1-.19.15-.28.06-.09.11-.17.17-.25.06-.07.12-.14.18-.21.06-.07.12-.12.18-.18.11-.11.23-.18.31-.26.19-.12.3-.19.3-.19,0,0-.11.06-.32.16-.09.07-.22.13-.34.23-.06.05-.13.1-.19.16-.06.06-.13.13-.2.2-.06.08-.13.16-.19.24-.06.09-.12.18-.18.28-.1.18-.2.38-.28.59,0-.07,0-.14,0-.21.01-.35.05-.69.11-1.03.07-.34.14-.67.26-.97.03-.08.05-.15.08-.23.03-.07.06-.15.1-.22.06-.15.13-.28.21-.41.07-.13.15-.25.23-.37.07-.12.16-.23.24-.33.16-.21.33-.37.48-.53.16-.14.3-.27.42-.36.25-.18.39-.28.39-.28,0,0-.15.09-.41.26-.13.09-.27.2-.44.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m307.15,129.64c.51,1.69.58,3.55.17,5.31-.78,3.34-4.07,6-7.5,6.47.76.08,1.55.07,2.38-.05,4.2-.62,7.43-3.77,6.86-7.83-.21-1.51-.89-2.71-1.91-3.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m277.8,117.28c-1.47-1.37-1.09-.48-1.09-.48,2.22,5,2.74,10.19,2.74,10.19,1.27,5.84,3.39,1.98,3.06-.81-.55-4.65-3.24-7.53-4.71-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m285.24,134.67l-2.44.15c-.21.01-.37.19-.36.4l-.15,1.83c.01.21.19.37.4.36l2.89-.17c.21-.01.37-.19.36-.4l-.3-1.81c-.01-.21-.19-.37-.4-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m285.24,134.67l-1.9.11c.44.28.82.64,1.08,1.08.27.45.4.94.4,1.42l.77-.05c.21-.01.37-.19.36-.4l-.3-1.81c-.01-.21-.19-.37-.4-.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m282.71,109.36c-2.29.14-3.13,6.03-3.19,8.33-.11,4.57.23,9.99.33,13.66.06,2.3,2.13,4.06,4.42,3.92,2.29-.14,4.06-2.13,3.92-4.42-.39-6.51-.97-9.95-1.31-13.6-.21-2.29-1.87-8.02-4.16-7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m286.77,118.76c-.34,1.6-.93,3.1-1.37,4.66-.39,1.41-.64,2.66-1.56,3.84-.51.65-1.76.78-2.34.14-1.06-1.16-1.29-2.64-1.9-4.06-.02-.04-.03-.08-.05-.13.08,2.97.23,5.87.29,8.12.06,2.3,2.13,4.06,4.42,3.92,2.29-.14,4.06-2.13,3.92-4.42-.37-6.13-.9-9.54-1.25-12.96-.05.29-.1.58-.16.88Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m281.09,119.06h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.69 17.19) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m284.81,124.98h.87c.22,0,.4.18.4.4v.05c0,.22-.18.4-.4.4h-.87c-.22,0-.4-.18-.4-.4v-.05c0-.22.18-.4.4-.4Z",
    transform: "translate(-7.04 17.42) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m285.41,121.81l-.77.05c-.22.01-.39.2-.37.42h0c.01.22.2.39.42.37l.77-.05c.22-.01.39-.2.37-.42h0c-.01-.22-.2-.39-.42-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m280.97,117.19h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.59 17.21) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m281.52,115.46h-.5c-.17,0-.31.15-.31.32,0,.17.14.31.31.31h.5c.17,0,.31-.15.31-.32h0c0-.17-.14-.31-.31-.31Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 282.12,
    y: 113.85,
    width: 0.53,
    height: 0.96,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(150.18 388.81) rotate(-86.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 281.18,
    y: 112.26,
    width: 0.53,
    height: 0.96,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(150.74 386.3) rotate(-86.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m283.51,111.42l-.26.02c-.13.01-.24.13-.23.26h0c.01.13.13.24.26.23l.26-.02c.13-.01.24-.13.23-.26h0c-.01-.13-.13-.24-.26-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m282.44,109.83l-.25-.03c-.09-.01-.16.05-.17.14-.01.09.05.16.14.17l.25.03c.09.01.16-.05.17-.14.01-.09-.05-.16-.14-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m281.26,129.96l-1.45.09s-.04.02-.04.05l.05.76s.02.04.05.04l1.45-.09s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m279.9,125.8h.81c.2,0,.36.16.36.36v.12c0,.2-.16.36-.36.36h-.81c-.2,0-.36-.16-.36-.36v-.12c0-.2.16-.36.36-.36Z",
    transform: "translate(-7.11 17.14) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m279.8,122.48h.81c.2,0,.36.16.36.36v.12c0,.2-.16.36-.36.36h-.81c-.2,0-.36-.16-.36-.36v-.12c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.91 17.13) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m283.68,124.44l-.74.04c-.22.01-.39.2-.38.42v.05c.02.22.21.39.43.38l.74-.04c.22-.01.39-.2.38-.42v-.05c-.02-.22-.21-.39-.43-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m288.2,130.25l-1.37.13s-.04.02-.04.05l.07.76s.02.04.05.04l1.37-.13s.04-.02.04-.05l-.07-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m288,128.15l-1.37.13s-.04.02-.04.05l.07.76s.02.04.05.04l1.37-.13s.04-.02.04-.05l-.07-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m284.01,114.07h-.5c-.17,0-.31.15-.31.32,0,.17.14.31.31.31h.5c.17,0,.31-.15.31-.32,0-.17-.14-.31-.31-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m280.5,113.58h-.27c-.11,0-.2.08-.2.19,0,.11.08.2.19.2h.27c.11,0,.2-.08.2-.19,0-.11-.08-.2-.19-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m281.17,110.65l-.21-.02c-.13-.02-.26.08-.27.22-.02.13.08.26.22.27l.21.02c.13.02.26-.08.27-.22.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m282.67,110.85l-.15-.02c-.13-.02-.26.08-.27.22-.02.13.08.26.22.27l.15.02c.13.02.26-.08.27-.22.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m283.64,109.61l-.13.02c-.11.02-.19.12-.17.24s.12.19.24.17l.13-.02c.11-.02.19-.12.17-.24-.02-.11-.12-.19-.24-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m284.65,112.18l-.41.02c-.14,0-.24.13-.24.27,0,.14.13.24.27.24l.41-.02c.14,0,.24-.13.24-.27,0-.14-.13-.24-.27-.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.4,131.58l-.45.03c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.45-.03c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.33,130.51l-.45.03c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.45-.03c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.27,129.48l-.45.03c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.45-.03c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.91,133.7l-1.21.07s-.04.02-.04.05l.05.76s.02.04.05.04l1.21-.07s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.49,132.68l-.45.03c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.45-.03c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.2,128.37l-.45.03c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.45-.03c.23-.01.41-.22.4-.45s-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.14,127.3l-.45.03c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.45-.03c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.08,126.31l-.45.03c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.45-.03c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.56,125.18h.5c.22,0,.4.18.4.4v.05c0,.22-.18.4-.4.4h-.5c-.22,0-.4-.18-.4-.4v-.05c0-.22.18-.4.4-.4Z",
    transform: "translate(-7.07 17.25) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 281.1,
    y: 124.19,
    width: 1.3,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-7 17.2) rotate(-3.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 281.03,
    y: 123.04,
    width: 1.3,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-6.91 17.15) rotate(-3.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.81,122.01l-.42.03c-.22.01-.39.2-.37.42h0c.01.22.2.39.42.37l.42-.03c.22-.01.39-.2.37-.42-.01-.22-.2-.39-.42-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.75,120.99l-.42.03c-.22.01-.39.2-.37.42.01.22.2.39.42.37l.42-.03c.22-.01.39-.2.37-.42h0c-.01-.22-.2-.39-.42-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.25,119.99h.49c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.49c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.74 17.17) rotate(-3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.03,118.12h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.63 17.18) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.94,130.25l-.82.05c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.82-.05c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.88,129.22l-.82.05c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.82-.05c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.22,133.5l-1.45.09s-.04.02-.04.05l.05.76s.02.04.05.04l1.45-.09s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.16,132.46l-1.45.09s-.04.02-.04.05l.05.76s.02.04.05.04l1.45-.09s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.81,128.11l-.82.05c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.82-.05c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.75,127.04l-.82.05c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.82-.05c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.69,126.06l-.82.05c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.82-.05c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 284.35,
    y: 124,
    width: 1.67,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-6.98 17.41) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 284.28,
    y: 122.84,
    width: 1.67,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-6.92 17.43) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.35,120.88l-.77.05c-.22.01-.39.2-.37.42s.2.39.42.37l.77-.05c.22-.01.39-.2.37-.42h0c-.01-.22-.2-.39-.42-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.51,119.88h.84c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.84c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.74 17.42) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.97,118.98l-.58.04c-.2.01-.35.18-.34.38.01.2.18.35.38.34l.58-.04c.2-.01.35-.18.34-.38-.01-.2-.18-.35-.38-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.48,117.81l-.58.04c-.2.01-.35.18-.34.38.01.2.18.35.38.34l.58-.04c.2-.01.35-.18.34-.38h0c-.01-.2-.18-.35-.38-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.54,116.33h-.5c-.17,0-.31.15-.31.32,0,.17.14.31.31.31h.5c.17,0,.31-.15.31-.32,0-.17-.14-.31-.31-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.95,114.6h.62c.14,0,.25.11.25.25v.11c0,.14-.11.25-.25.25h-.62c-.14,0-.25-.11-.25-.25v-.11c0-.14.11-.25.25-.25Z",
    transform: "translate(-1.23 3.06) rotate(-.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 281.09,
    y: 113.62,
    width: 0.53,
    height: 0.96,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(149.39 387.54) rotate(-86.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.38,112.94h.04c.14,0,.25.11.25.25v.47c0,.14-.11.25-.25.25h-.04c-.14,0-.25-.11-.25-.25v-.47c0-.14.11-.25.25-.25Z",
    transform: "translate(150.07 386.92) rotate(-86.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.19,114.68h.62c.14,0,.25.11.25.25v.11c0,.14-.11.25-.25.25h-.62c-.14,0-.25-.11-.25-.25v-.11c0-.14.11-.25.25-.25Z",
    transform: "translate(-1.22 3.04) rotate(-.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.71,113.4l-.47-.03c-.14,0-.25.1-.26.23v.04c-.01.14.09.25.23.26l.47.03c.14,0,.25-.09.26-.23v-.04c.01-.14-.09-.25-.23-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.82,111.82l-.26-.03c-.13-.02-.26.08-.27.22-.02.13.08.26.22.27l.26.03c.13.02.26-.08.27-.22h0c.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.89,111.2l-.4-.04c-.13-.02-.26.08-.27.22h0c-.02.13.08.26.22.27l.4.04c.13.02.26-.08.27-.22.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.96,110.57l-.21-.02c-.13-.02-.26.08-.27.22-.02.13.08.26.22.27l.21.02c.13.02.26-.08.27-.22.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.88,110.28l-.21-.02c-.13-.02-.26.08-.27.22-.02.13.08.26.22.27l.21.02c.13.02.26-.08.27-.22.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 283.17,
    y: 111.85,
    width: 0.53,
    height: 0.96,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(150.28 386.59) rotate(-85.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.64,110.8l-.4-.02c-.13,0-.25.1-.26.23h0c0,.13.1.25.23.26l.4.02c.13,0,.25-.1.26-.23h0c0-.13-.1-.25-.23-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.57,110.14h-.21c-.13.01-.24.12-.24.26,0,.13.12.24.25.24h.21c.13-.01.24-.12.24-.26h0c0-.13-.12-.24-.25-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.18,110.21l-.25-.03c-.09-.01-.16.05-.17.14s.05.16.14.17l.25.03c.09.01.16-.05.17-.14.01-.09-.05-.16-.14-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.48,109.37h-.3c-.1.02-.18.1-.18.21,0,.1.09.18.19.18h.3c.1-.02.18-.1.18-.21,0-.1-.09-.18-.19-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.21,109.33h-.3c-.1.02-.18.1-.18.21,0,.1.09.18.19.18h.3c.1-.02.18-.1.18-.21,0-.1-.09-.18-.19-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.32,131.03l-1.45.09s-.04.02-.04.05l.05.76s.02.04.05.04l1.45-.09s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.19,128.93l-1.45.09s-.04.02-.04.05l.05.76s.02.04.05.04l1.45-.09s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.23,132.18l-1.45.09s-.04.02-.04.05l.05.76s.02.04.05.04l1.45-.09s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.75,127.84l-.69.04c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.68,126.77l-.69.04c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.83,124.65h.81c.2,0,.36.16.36.36v.12c0,.2-.16.36-.36.36h-.81c-.2,0-.36-.16-.36-.36v-.12c0-.2.16-.36.36-.36Z",
    transform: "translate(-7.04 17.14) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.76,123.56h.81c.2,0,.36.16.36.36v.12c0,.2-.16.36-.36.36h-.81c-.2,0-.36-.16-.36-.36v-.12c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.97 17.13) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 279.38,
    y: 121.5,
    width: 1.44,
    height: 0.8,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(-6.85 17.13) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.72,120.48h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.77 17.09) rotate(-3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.66,119.46h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.71 17.08) rotate(-3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.68,118.56h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.66 17.1) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.71,117.72h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.61 17.1) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.7,116.28h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.54 17.13) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.23,117.06l-.44.03c-.15,0-.26.14-.26.29,0,.15.14.27.29.26l.44-.03c.15,0,.27-.14.26-.29,0-.15-.14-.27-.29-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.32,115.54h-.5c-.17,0-.31.15-.31.32,0,.17.14.31.31.31h.5c.17,0,.31-.15.31-.32,0-.17-.14-.31-.31-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.04,130.86l-.69.04c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.97,129.79l-.69.04c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.91,128.76l-.69.04c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.17,132l-.69.04c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.24,133.19l-.69.04c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.85,127.65l-.69.04c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.78,126.58l-.69.04c-.23.01-.41.22-.4.45h0c.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.72,125.6l-.69.04c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.69-.04c.23-.01.41-.22.4-.45h0c-.01-.23-.22-.41-.45-.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 282.5,
    y: 123.37,
    width: 1.54,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-6.95 17.32) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 282.53,
    y: 122.29,
    width: 1.54,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-6.89 17.31) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.5,121.29l-.65.04c-.22.01-.39.2-.37.42h0c.01.22.2.39.42.37l.65-.04c.22-.01.39-.2.37-.42-.01-.22-.2-.39-.42-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.82,120.29h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.77 17.31) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.76,119.27h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-6.69 17.27) rotate(-3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.22,118.37l-.58.04c-.2.01-.35.18-.34.38.01.2.18.35.38.34l.58-.04c.2-.01.35-.18.34-.38-.01-.2-.18-.35-.38-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.38,117.56h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.61 17.3) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m288.1,129.18l-1.37.13s-.04.02-.04.05l.07.76s.02.04.05.04l1.37-.13s.04-.02.04-.05l-.07-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m287.45,131.8l-1.22.07s0,0,0,0c.04-.07.06-.15.06-.24-.01-.23-.22-.41-.45-.4l-.69.04c-.23.01-.41.22-.4.45.01.23.22.41.45.4l.69-.04c.13,0,.24-.07.31-.17l.05.76s.02.04.05.04l1.22-.07s.04-.02.04-.05l-.05-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m287.9,127.05l-1.37.13s-.04.02-.04.05l.07.76s.02.04.05.04l1.37-.13s.04-.02.04-.05l-.07-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m287.8,125.98l-1.37.13s-.04.02-.04.05l.07.76s.02.04.05.04l1.37-.13s.04-.02.04-.05l-.07-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m287.71,125l-1.37.13s-.04.02-.04.05l.07.76s.02.04.05.04l1.37-.13s.04-.02.04-.05l-.07-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m287.6,123.85l-1.37.13s-.04.02-.04.05l.07.76s.02.04.05.04l1.37-.13s.04-.02.04-.05l-.07-.76s-.02-.04-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m287.14,122.79l-.66.06c-.22.02-.38.22-.36.44v.05c.03.22.22.38.44.36l.66-.06c.22-.02.38-.22.36-.44v-.05c-.03-.22-.22-.38-.44-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.51,121.74h.67c.22,0,.4.18.4.4v.05c0,.22-.18.4-.4.4h-.66c-.22,0-.4-.18-.4-.4v-.05c0-.22.18-.4.4-.4Z",
    transform: "translate(-10.13 27.25) rotate(-5.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.96,120.73l-.58.05c-.22.02-.38.22-.36.43h0c.02.22.21.38.43.36l.58-.05c.22-.02.38-.22.36-.43-.02-.22-.21-.38-.43-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.33,119.74h.65c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.65c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-9.97 27.3) rotate(-5.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.38,118.7h.59c.18,0,.32.14.32.32v.16c0,.18-.14.32-.32.32h-.59c-.18,0-.32-.14-.32-.32v-.16c0-.18.14-.32.32-.32Z",
    transform: "translate(-6.64 17.46) rotate(-3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.45,117.9h.48c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.48c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.61 17.49) rotate(-3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.44,117.24h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.58 17.48) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.88,115.84h.56c.17,0,.31.14.31.31v.03c0,.17-.14.31-.31.31h-.56c-.17,0-.31-.14-.31-.31v-.03c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.49 17.42) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 284.55,
    y: 115,
    width: 1.19,
    height: 0.65,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(-6.44 17.4) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.25,114.17l-.53.03c-.18.01-.32.17-.31.35.01.18.17.32.35.31l.53-.03c.18-.01.32-.17.31-.35-.01-.18-.17-.32-.35-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.18,113.42l-.48.03c-.16,0-.29.15-.28.31,0,.16.15.29.31.28l.48-.03c.16,0,.29-.15.28-.31,0-.16-.15-.29-.31-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.98,112.74l-.48.03c-.16,0-.29.15-.28.31,0,.16.15.29.31.28l.48-.03c.16,0,.29-.15.28-.31s-.15-.29-.31-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.37,116.12h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.52 17.29) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.9,116.9l-.44.03c-.15,0-.27.14-.26.29,0,.15.14.27.29.26l.44-.03c.15,0,.26-.14.26-.29,0-.15-.14-.27-.29-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.83,115.39h-.5c-.17,0-.31.15-.31.32s.14.31.31.31h.5c.17,0,.31-.15.31-.32h0c0-.17-.14-.31-.31-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.88,113.47l-.43-.03c-.15,0-.27.1-.28.25h0c0,.15.1.27.25.28l.43.03c.15,0,.27-.1.28-.25,0-.15-.1-.27-.25-.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 283.36,
    y: 112.51,
    width: 0.53,
    height: 0.96,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(152.63 388.77) rotate(-86.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m283.64,116.95h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-6.57 17.37) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 283.32,
    y: 115.51,
    width: 1.3,
    height: 0.72,
    rx: 0.31,
    ry: 0.31,
    transform: "translate(-6.47 17.33) rotate(-3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.45,116.58l-.46.03c-.15,0-.27.14-.26.3s.14.27.3.26l.46-.03c.15,0,.27-.14.26-.3,0-.15-.14-.27-.3-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.65,115.75l-.56.03c-.17.01-.3.16-.29.33v.03c.01.17.16.3.33.29l.56-.03c.17-.01.3-.16.29-.33v-.03c-.01-.17-.16-.3-.33-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.41,114.93l-.26.02c-.17.01-.3.16-.29.33v.03c.01.17.16.3.33.29l.26-.02c.17-.01.3-.16.29-.33v-.03c-.01-.17-.16-.3-.33-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.28,114.26l-.41.02c-.14,0-.24.13-.24.27,0,.14.13.24.27.24l.41-.02c.14,0,.24-.13.24-.27,0-.14-.13-.24-.27-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.07,113.72l-.32.02c-.11,0-.19.12-.18.25,0,.13.1.23.21.23l.32-.02c.11,0,.19-.12.18-.25,0-.13-.1-.23-.21-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.78,112.99l-.3.02c-.1,0-.18.11-.17.23,0,.12.09.21.2.21l.3-.02c.1,0,.18-.11.17-.23,0-.12-.1-.21-.2-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.44,110.45l-.34.02c-.12,0-.21.1-.22.21,0,.13.11.23.23.23l.34-.02c.12,0,.21-.1.22-.21,0-.13-.11-.23-.23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m286.67,116.5l-.46.03c-.15,0-.27.14-.26.3s.14.27.3.26l.45-.03c.15,0,.27-.14.26-.3,0-.15-.14-.27-.3-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.74,118.17l-.46.03c-.15,0-.27.14-.26.3,0,.15.14.27.3.26l.46-.03c.15,0,.27-.14.26-.3,0-.15-.14-.27-.3-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.16,116.29l-.44.03c-.15,0-.26.14-.26.29,0,.15.14.27.29.26l.44-.03c.15,0,.26-.14.26-.29,0-.15-.14-.27-.29-.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 283.28,
    y: 114.78,
    width: 1.12,
    height: 0.62,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(-1.2 3.01) rotate(-.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.95,114.8h.44c.14,0,.25.11.25.25v.11c0,.14-.11.25-.25.25h-.44c-.14,0-.25-.11-.25-.25v-.11c0-.14.11-.25.25-.25Z",
    transform: "translate(-1.22 3) rotate(-.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.95,114.09h.53c.14,0,.25.11.25.25v.11c0,.14-.11.25-.25.25h-.53c-.14,0-.25-.11-.25-.25v-.11c0-.14.11-.25.25-.25Z",
    transform: "translate(-1.21 3) rotate(-.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.67,113.04l-.35-.02c-.12,0-.22.08-.23.2,0,.12.08.22.2.23l.35.02c.12,0,.22-.08.23-.2,0-.12-.08-.22-.2-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.6,112.46h-.17c-.15-.01-.27.08-.28.2-.01.12.1.23.24.24h.17c.15.01.27-.08.28-.2.01-.12-.1-.23-.24-.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 280.48,
    y: 111.65,
    width: 0.53,
    height: 0.96,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(150.74 385.06) rotate(-86.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.92,111.25l-.18-.02c-.13-.02-.26.08-.27.22-.02.13.08.26.22.27l.18.02c.13.02.26-.08.27-.22s-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.44,110.16h-.13c-.11-.03-.22.05-.23.17-.01.11.07.22.18.23h.13c.11.03.22-.05.23-.17.01-.11-.07-.22-.18-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.75,109.77h-.13c-.11-.02-.22.05-.23.15-.01.1.07.18.18.19h.13c.11.02.22-.05.23-.15.01-.1-.07-.18-.18-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.46,112.42h.04c.14,0,.25.11.25.25v.47c0,.14-.11.25-.25.25h-.04c-.14,0-.25-.11-.25-.25v-.47c0-.14.11-.25.25-.25Z",
    transform: "translate(151.64 387.54) rotate(-86.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.59,112.04l-.18-.02c-.13-.02-.26.08-.27.22-.02.13.08.26.22.27l.18.02c.13.02.26-.08.27-.22.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.66,111.44l-.21-.02c-.13-.02-.26.08-.27.22h0c-.02.13.08.26.22.27l.21.02c.13.02.26-.08.27-.22h0c.02-.13-.08-.26-.22-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.99,109.74l-.13.02c-.11.02-.19.12-.17.24.02.11.12.19.24.17l.13-.02c.11-.02.19-.12.17-.24-.02-.11-.12-.19-.24-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.18,110l-.13.02c-.11.02-.19.12-.17.24s.12.19.24.17l.13-.02c.11-.02.19-.12.17-.24-.02-.11-.12-.19-.24-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.47,111.61l-.39.03c-.13.01-.23.13-.22.26.01.13.13.23.26.22l.39-.03c.13-.01.23-.13.22-.26-.01-.13-.13-.23-.26-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m284.44,111.08l-.33.02c-.11,0-.2.1-.19.22s.1.2.22.19l.33-.02c.11,0,.2-.1.19-.22,0-.11-.1-.2-.22-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.09,111.36l-.24.07c-.08.02-.13.11-.11.19.02.08.11.13.19.11l.24-.07c.08-.02.13-.11.11-.19-.02-.08-.11-.13-.19-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.23,111.8l-.26.07c-.09.02-.14.11-.11.2.02.09.11.14.2.11l.26-.07c.09-.02.14-.11.11-.2-.02-.09-.11-.14-.2-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m285.49,112.25l-.3.07c-.1.02-.17.12-.15.23.02.1.12.17.23.15l.3-.07c.1-.02.17-.12.15-.23-.02-.1-.12-.17-.23-.15Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m288.15,130.31c0-.12-.02-.24-.02-.35.05-.05.08-.12.07-.2l-.03-.33c0-.07-.04-.12-.09-.17,0-.12-.02-.25-.03-.37.03-.05.05-.1.05-.17l-.03-.33c0-.05-.03-.1-.06-.14-.01-.17-.03-.34-.04-.51.02-.04.03-.09.03-.13l-.03-.33s-.02-.08-.05-.12c-.01-.13-.02-.27-.03-.4,0-.03,0-.07,0-.1.01-.04.02-.08.02-.12l-.03-.33s-.02-.08-.04-.11c0-.09-.02-.17-.02-.26,0-.05,0-.09-.01-.14,0-.01,0-.03,0-.04.01-.04.02-.07.02-.11l-.03-.33s-.02-.08-.04-.11c0-.05,0-.1-.01-.14,0-.04,0-.09-.01-.13-.01-.11-.02-.21-.03-.32.02-.04.03-.08.02-.12l-.03-.33s-.02-.09-.05-.12c-.02-.17-.04-.34-.05-.5.02-.04.04-.09.03-.14l-.03-.33c0-.06-.03-.11-.07-.15,0-.07-.02-.14-.02-.21,0-.04,0-.08-.01-.12,0,0,0-.02,0-.03.09-.05.14-.15.13-.25l-.03-.33s-.01-.06-.02-.08c-1.1,1.74-3.29,9.42-3.8,9.65-1.38.61-3.86-7.14-4.14-7.62-.04-.07-.08-.13-.12-.2-.05.05-.08.11-.07.19l.02.33c0,.11.08.2.18.23,0,.1,0,.2,0,.29-.09.05-.15.14-.14.24l.02.33c0,.1.07.17.15.21,0,.13,0,.26.01.38-.07.05-.12.13-.11.22l.02.33c0,.09.05.16.12.2,0,.08,0,.17.01.25-.06.05-.1.13-.09.21l.02.33c0,.08.04.14.1.19,0,.12,0,.24.01.36-.05.05-.08.12-.07.19l.02.33c0,.07.03.13.08.17,0,.06,0,.12,0,.18,0,.09,0,.18.01.27-.03.05-.05.1-.05.16l.02.33c0,.05.03.1.05.14,0,.15.01.29.02.44-.02.04-.03.08-.03.12l.02.33s.01.07.03.1c0,.21.01.41.02.61,0,0,0,.01,0,.02,0,0,0,0,0,.01l.02.33s0,.04.01.05c.02.17.06.34.1.5-.14.01-.24.13-.23.27l.02.33c0,.14.13.25.28.24l.27-.02c.75,1.38,2.28,2.28,3.95,2.18,2.22-.13,3.93-2,3.92-4.2.07-.05.12-.14.11-.23l-.03-.33c0-.08-.05-.15-.12-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m281.26,129.35c-2.5-10.71-7.13-11.45-7.13-11.45-.91-.06,2.24,1.78,3.77,7.54.45,1.69.28,8.9,2.71,10.06,3.08,1.46,5.67-1.15,5.67-1.15,0,0-3.48,1.62-5.03-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m283.16,133.49c-.14.3-.32.58-.53.84-.56.67-1.26,1.04-2.03,1.16,0,0,.01,0,.02,0,3.08,1.46,5.67-1.15,5.67-1.15,0,0-1.61.75-3.13-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m284.22,135.1h0s-.07.02-.2.06c-.13.03-.32.08-.57.11-.49.06-1.24.08-1.97-.34-.74-.41-1.35-1.27-1.68-2.31-.17-.52-.28-1.07-.35-1.65-.09-.58-.15-1.18-.26-1.77-.09-.59-.2-1.18-.31-1.76-.11-.58-.24-1.14-.37-1.69-.13-.54-.27-1.07-.42-1.56-.15-.49-.29-.96-.44-1.38-.3-.84-.6-1.53-.84-2-.23-.47-.4-.72-.4-.72,0-.01-.02-.02-.04,0-.01,0-.02.02,0,.04,0,0,.15.25.37.73.22.47.49,1.16.76,2.01.14.42.27.89.41,1.38.13.49.26,1.02.38,1.56.12.54.24,1.11.33,1.68.1.58.19,1.16.27,1.75.09.59.14,1.18.22,1.76.07.59.18,1.17.36,1.72.17.55.42,1.05.72,1.49.31.44.69.79,1.1,1.03.41.24.84.36,1.22.4.38.04.71.01.98-.02.27-.04.47-.09.61-.13.14-.04.21-.06.21-.06.09-.03.14-.12.12-.21-.02-.09-.12-.15-.21-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m284.53,134.96h0s-.05,0-.14,0c-.09,0-.23,0-.4-.03-.34-.04-.81-.19-1.3-.52-.49-.33-.96-.86-1.35-1.5-.19-.32-.37-.67-.51-1.04-.15-.37-.25-.75-.35-1.15-.39-1.58-.76-3.17-1.03-4.37-.28-1.19-.47-1.99-.47-1.99,0,0,.15.8.38,2.01.24,1.2.55,2.8.9,4.4.09.4.18.81.34,1.19.15.38.33.74.53,1.08.4.67.89,1.23,1.42,1.59.52.37,1.05.51,1.42.55.18.02.33.02.43.02.1,0,.15,0,.15,0,.07,0,.12-.06.12-.12,0-.07-.06-.12-.12-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m289.25,118.45s-2.88,1.66-4.09,11.03c-.79,6.11-1.4,6.3-1.4,6.3,0,0,1.97.42,3.55-.7,2.54-1.8.75-8.51.85-10.26.33-5.62,1.99-6.54,1.1-6.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m288.03,125.87c-.53,2.24-.87,4.49-1.32,6.74-.25,1.26-.71,2.32-1.33,3.19.6-.08,1.29-.28,1.92-.73,2.32-1.64,1.02-7.39.86-9.7-.04.17-.09.33-.13.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m288.59,120.36s-.1.24-.26.67c-.16.43-.39,1.04-.62,1.8-.11.38-.23.79-.35,1.22-.11.44-.22.9-.31,1.39-.09.48-.16,1-.17,1.52-.01.52,0,1.04,0,1.56-.02.52-.04,1.04-.09,1.55-.05.51-.11,1.01-.22,1.48-.04.24-.1.47-.16.7-.06.22-.11.45-.19.65-.14.42-.31.8-.49,1.14-.18.34-.37.63-.57.87-.2.24-.39.43-.56.56-.17.14-.32.22-.42.27-.1.05-.15.06-.16.07-.01,0-.02.02-.03.02.1.01.23.03.39.04,0,0,0,0,.01,0,0,0,.07-.02.19-.07.06-.04.11-.07.17-.12.19-.14.4-.34.61-.59.21-.25.42-.56.61-.91.18-.36.36-.75.5-1.19.08-.21.13-.44.2-.67.06-.23.12-.47.16-.71.1-.49.16-.99.21-1.51.05-.52.07-1.04.09-1.57,0-.52,0-1.05,0-1.56,0-.51.06-1,.13-1.49.07-.48.17-.94.27-1.38.1-.44.21-.85.31-1.22.42-1.51.77-2.49.77-2.49,0,0,0-.01,0-.02,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m287.99,129c-.1-.96-.2-1.6-.2-1.6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.03.64.05,1.61.01.48.02,1.04.01,1.64,0,.6-.02,1.24-.11,1.86-.04.31-.13.58-.27.85-.14.26-.31.51-.5.72-.38.43-.81.78-1.2,1.04-.39.26-.73.45-.98.56-.08.04-.14.06-.2.08-.04.03-.28.05-.32.07.25.01.75.02,1.09-.03.19-.1.4-.22.62-.36.41-.28.87-.63,1.28-1.12.2-.24.39-.51.54-.81.14-.29.26-.65.28-.97.04-.33.04-.65.05-.97,0-.32,0-.63-.02-.94-.02-.61-.07-1.17-.12-1.65Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m292.55,140.7s2.61,1.44,4.33-1.08c1.93-2.83,3.45-4.88,5.89-6.69,0,0-6.98-.66-10.22,7.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m311.74,116.15c-.14-.06-.3-.12-.46-.17-4.45-1.44-5.36-.06-5.96.86-.09.14-.17.27-.26.36-.58-.02-3.68.08-5.03,3.8-.05.1-1.31,2.49-1.63,7.56-.16,2.52-1.45,4.91-2.82,7.34,2.03-2.14,4.27-2.7,7.31-2.82,2.21-.09,3.58-1.43,5.61-3.69.95-1.05,1.35-1.95,1.2-2.68-.06-.3-.21-.51-.35-.66.97-.26,3.47-1.07,4.19-2.71.32-.74.24-1.55-.24-2.4.21-.56,1.19-3.56-1.55-4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "m309.6,126.39c-.49.18-.97.33-1.43.46-1.21.34-2.48.57-3.61,1.15-1.06.54-2.02,1.25-2.95,1.97-1.68,1.29-4.31,2.52-4.96,4.68-.13.44-.45.68-.8.76-.09.16-.18.32-.27.48,2.03-2.14,4.27-2.7,7.31-2.82,2.21-.09,3.58-1.43,5.61-3.69.95-1.05,1.35-1.95,1.2-2.68-.02-.11-.06-.21-.11-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "m306.56,121.15c1.03-1.2,2.94-3.43,2.36-5.3-.31-1.02-1.32-1.77-3.01-2.25-.08-.69-.55-3.82-2.46-4.58-1.19-.47-2.67.09-4.41,1.66-.08.07-.08.19-.01.26.02.03.05.04.09.05,0,0-8.24,29.16-7.83,29.12,1.49-.14,1.66-1.52,2.69-2.37,1.72-1.42,4.27-1.29,4.84-2.88.16-.45-.84,0-.15-.71.16-.17,2.59-.57,3.18-1.42.89-1.28-3.11-.09-.94-1.63,8.41-5.94,6.83-8.34,6.53-9.02-.2-.45-.75-.45-1.11-.45-.06,0-.12,0-.18,0,0,0,0,0,0,0,.1-.13.24-.3.41-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m306.65,121.66c-.34.45-.69.86-1.04,1.22-.79.85-1.81,1.69-2.93,2.41-.13.2-.26.4-.39.6-.36.52-.96.59-1.43.41-1.4.65-2.87,1.05-4.25,1.02-.56-.01-.95-.37-1.07-.8-.03,0-.06,0-.08,0-.23.02-.46.04-.7.06-1.9,6.93-3.67,13.54-3.48,13.52,1.49-.14,1.66-1.52,2.69-2.37,1.72-1.42,4.27-1.29,4.84-2.88.16-.45-.84,0-.15-.71.16-.17,2.59-.57,3.18-1.42.89-1.28-3.11-.09-.94-1.63,8.41-5.94,6.83-8.34,6.53-9.02-.15-.32-.47-.41-.77-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m303.45,109.03c-1.19-.47-2.67.09-4.41,1.66-.08.07-.08.19-.01.26.02.03.05.04.09.05,0,0-1.84,6.51-3.74,13.37.94-.06,1.91-.14,2.76-.54.36-.17.72-.14,1.02.01.07-.03.13-.06.2-.1,1.17-.63,2.06-1.87,2.7-3.01,1.38-2.47,2.48-5.15,3.78-7.68-.2-1.14-.79-3.41-2.38-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m306.32,121.65s-.06,0-.09,0c-.6.65-1.28,1.19-2.18,1.51-1.06.38-2.07.53-3.04,1.12-.96.59-1.89,1.27-2.74,2.01-1.06.92-1.97,2.06-2.87,3.14-.43.52-.85,1.04-1.23,1.6-.19.28-.33.58-.51.87-.2.33.01.49-.17.24.52.7,0,1.42-.67,1.58-1,3.73-1.67,6.41-1.54,6.4,1.49-.14,1.66-1.52,2.69-2.37,1.72-1.42,4.27-1.29,4.84-2.88.16-.45-.84,0-.15-.71.16-.17,2.59-.57,3.18-1.42.89-1.28-3.11-.09-.94-1.63,8.41-5.94,6.83-8.34,6.53-9.02-.2-.45-.75-.45-1.11-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m301.01,114.69c.28-1.06.69-2.66-3.36-5-.15-.08-.29-.16-.44-.22-2.74-1.22-4.31,1.52-4.59,2.05-.96.21-1.61.69-1.94,1.43-.73,1.63.34,4.03.79,4.92-.2,0-.46.03-.73.18-.64.37-1.04,1.28-1.19,2.69-.33,3.15,1.87,6.11,2.31,6.67-2.32,4.95-2.99,8.83-1.99,11.53.68,1.82,3.48-7.6,7.05-11.26,3.55-3.63,4.48-6.17,4.51-6.25,1.87-3.52-.14-5.89-.54-6.31.02-.13.05-.27.1-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m301.68,116.57c-.16.53-.38.98-.67,1.38-.98,1.76-2.28,3.14-4.2,4.19-.78.43-1.57.83-2.3,1.32-.19.26-.38.53-.55.81-.77,1.26-1.27,2.67-2.11,3.88-.2.29-.41.54-.64.76-1.78,4.24-2.23,7.62-1.33,10.03.68,1.82,3.48-7.6,7.05-11.26,3.55-3.63,4.48-6.17,4.51-6.25,1.16-2.19.82-3.93.31-5.04-.02.06-.05.12-.07.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m296.55,115.65c0-.1-.08-.17-.17-.18-.09,0-.18.06-.2.15-.59,3.48-5.12,13.54-5.17,13.64-.64,1.22-3.65,9.31.1,10.98h0c.24.11.51.18.8.22.55.08.22.5,1.55.55.81.03-.73-2.46-.79-4.23-.07-2.14-.1-5,.97-8.29,2.11-6.49,2.91-12.8,2.9-12.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m293.14,119.4c.51,3.29-.74,6.71-.74,6.71l1.41-2.99c.17-2.37-.37-3.45-.6-3.8-.02.03-.04.05-.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m294.74,133.82c-1.98,2.2-2.97,3.7-3.36,5.63,0,0,.25,1.69,1.95,1.42,0,0,1.52-5.49,4.27-8.72,2.75-3.23,5.3-4.72,6.33-5.76,0,0-1,.47-2.54,1.47-.69.45-4.19,3.24-6.65,5.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m295.08,133.45c.79-.27,2.93-2.81,2.93-2.81-.26-.4,1.64-3.52,1.64-3.52-1.68,1.61-4.57,6.33-4.57,6.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m292.12,114.31c-.2.39.2.39.4,1.12.19.74-.31,2.8-.31,2.8l.55.04c.92-.88.94-3.47.57-3.92-.38-.46-1.2-.03-1.2-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m290.27,116.98c-.07.01-.01.05-.08.05-.29,1.17.62,1.45.62,1.45l.08.04c.14-.2.31-.39.48-.57-.53-.32-.95-.73-1.09-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m293.44,118.65l-.08.02c.04.24.05.49.05.74.92-.17,1.24-.52,1.46-.68,0-.01-.01-.03-.02-.04-1.11.16-1.4-.05-1.4-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m288.35,117.01c-2.66.1-1.61,5.46-2.42,6.98-.81,1.52-2.56,6.34.8,5.16,1.05-.37,1.81-.4,2.36-.28.07-2.42.32-4.82,1.2-7.1.11-.28.23-.51.41-.72l.03-1.45s.28-2.7-2.38-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m285.93,123.99c-.55,1.04-1.54,3.61-1.05,4.77.17-.03.35-.07.52-.12.04-.01.08-.02.12-.04.1-.05.21-.09.31-.15.03-.01.1-.05.17-.08.01-.01.03-.02.04-.04.05-.04.1-.08.15-.13.11-.1.21-.2.32-.31.05-.07.1-.14.15-.22.17-.27.32-.55.46-.84.11-.25.22-.49.34-.74.27-.61.43-1.26.55-1.92.21-1.39.31-2.8.56-4.19.18-.99.5-1.93.99-2.78-.31-.14-.71-.23-1.22-.21-2.66.1-1.61,5.46-2.42,6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m292.91,120.23l-.83,1.18c.02.27-.02.53-.1.82-.65,2.36-1.86,4.44-3.25,6.43.52.22,1.11.7,1.73,1.62,2,2.94,3.46-1.98,3.71-3.68.25-1.7,4.28-5.39,2.2-7.05-2.08-1.66-3.46.68-3.46.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "296.26 119.75 296.26 119.75 296.26 119.75 296.26 119.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "296.26 119.75 296.26 119.75 296.26 119.75 296.26 119.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "296.26 119.75 296.26 119.75 296.26 119.75 296.26 119.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m296.28,119.98s0-.11-.01-.14c0-.04,0-.08,0-.08,0,0,0,0,0,0,0,0,0,0,0,0-.01-.1-.02-.2-.03-.31-1.17-.85-2.11-.43-2.68.06,0,0,.02,0,.03,0,.89.23,1.48,1.33,1.16,2.2-.2.54-1.45,2.34-2.26,5.23-1.4,5.04.36,2.79.42,2.68.42-1.07.47-2.24.93-3.3.55-1.25,1.43-2.3,2.04-3.52.16-.36.29-.73.41-1.1.03-.33.04-.66.04-.99,0-.17,0-.34-.02-.51,0-.07-.01-.15-.02-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m293.13,118.11s-.27-.27-.71-.38c-.43-.16-.8-.09-.8-.09-.87.04-1.89.54-2.42,2.44-1.04,3.74-.59,5.45-1.27,6.73-.65,1.22-.79,3.01.69,3.23,1.35.65,2.25-.91,2.4-2.28.16-1.44,1.49-2.6,2.74-6.27.64-1.87.08-2.86-.62-3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m289.04,128.6s-.02,0-.03,0c.05,0,.12,0,.23-.01-.06,0-.11,0-.17,0-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m292.42,117.73c-.43-.16-.8-.09-.8-.09-.87.04-1.89.54-2.42,2.44-1.04,3.74-.59,5.45-1.27,6.73-.26.49-.18,2.26,1.06,1.81,0,0,.02,0,.02,0-.11,0-.06,0,.03,0,.01,0,.02,0,.04,0,.05,0,.11-.01.15-.02.05-.01.1-.02.15-.04.05-.03.1-.06.15-.08.05-.04.1-.08.14-.13.14-.21.27-.41.39-.63.15-.36.28-.73.42-1.09.25-.65.54-1.28.86-1.89.51-.98,1.22-1.84,1.73-2.82.18-.43.31-.87.41-1.32.09-.68.11-1.36.09-2.05-.13-.16-.27-.29-.42-.41,0,0-.27-.27-.71-.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m297.78,124.3l.28-.07c-.08-.32.45-5.47,4.33-6.78l-.09-.27c-3.89,1.32-4.66,6.52-4.52,7.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m301.71,123.3c-.07,0-.14-.01-.22-.02-.98-.43-2.1-.56-3.22-.3-.32.07-.63.18-.93.31,0,0,0,0,0,0-2.44-.31-5.1,1.58-5.41,4.02s1.42,4.67,3.86,4.98c1.55.2,2.96.87,3.86.72,2.94.12,5.53-2.7,5.8-4.87.3-2.37-1.38-4.54-3.76-4.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m291.94,127.31c-.26,2.04.91,3.92,2.72,4.67-.68-.88-1.08-1.97-1.05-3.23.06-2.13,1.21-4.04,2.76-5.47-2.13.21-4.17,1.91-4.43,4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m300.04,122.78c-.19-.4-.53-.98-.86-1.4-.02-.1-.32-.47-.53-.6-.83,1.14-1.13,2.2-1.13,2.2l-.34.13-2.22-.2,1.06.65,1.29.07.57-.26-.44.71s.18,1.13.1,1.52c.2-.4.52-1.6.52-1.6l.97-.83s.02,0,.03.01c.26.78.48,1.29.48,1.29.77.72.53.31.11-1.11.51.16,1.05.3,1.13.27.17-.07,1.85-.73,1.85-.73l-1.89.14-.73-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m297.19,123.12l-2.22-.2,1.06.65,1.29.07.57-.26-.44.71s.18,1.13.1,1.52c.2-.4.52-1.6.52-1.6l.23-.2c0-.86,0-1.69.15-2.57.01-.09.04-.17.06-.26-.72,1.06-.99,2.01-.99,2.01l-.34.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m297.59,139s-.3.25-.72.65c-.11.1-.22.21-.34.32-.12.12-.24.24-.36.37-.12.13-.25.27-.37.41-.06.07-.12.15-.18.22-.06.08-.11.15-.17.23-.05.08-.1.16-.15.25-.04.09-.08.17-.12.25-.08.17-.16.33-.25.48-.09.15-.18.3-.27.43-.09.14-.18.26-.26.38-.34.46-.59.75-.59.75,0,0,.26-.28.61-.74.09-.11.18-.24.27-.37.1-.13.19-.28.28-.43.09-.15.19-.31.27-.48.04-.08.08-.17.12-.25.04-.08.1-.16.15-.24.06-.08.11-.15.17-.23.06-.07.12-.15.18-.22.12-.14.25-.28.38-.4.13-.13.25-.25.37-.36.12-.11.23-.22.34-.32.43-.39.73-.63.73-.63,0,0,0,0,0,0,.03-.02.03-.06,0-.08-.03-.02-.07-.03-.09,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m297,139.41s-.05.05-.12.15c-.07.09-.17.23-.28.39-.11.17-.24.36-.36.58-.07.1-.13.22-.21.32-.04.05-.08.11-.11.16-.04.05-.08.1-.12.16-.04.05-.08.1-.13.15-.04.05-.09.1-.13.15-.05.05-.09.09-.14.14-.05.04-.09.09-.14.13-.05.04-.09.08-.14.12-.05.04-.09.08-.14.11-.09.07-.18.14-.26.2-.34.24-.59.36-.59.36,0,0,.26-.11.6-.34.08-.06.18-.12.27-.19.05-.03.1-.07.14-.11.05-.04.1-.08.14-.12.05-.04.1-.08.15-.13.05-.05.09-.09.14-.14.05-.05.09-.1.14-.14.05-.05.09-.1.14-.15.04-.05.09-.1.13-.15.04-.05.08-.11.12-.16.08-.11.15-.21.22-.32.13-.21.26-.4.38-.56.12-.16.22-.29.29-.38.07-.09.12-.14.12-.14,0,0,0,0,0,0,.02-.03.02-.06-.01-.08-.03-.02-.07-.02-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m307.13,121.97c-.35-.11-2.19.76-2.96,3.61-1.46,5.37-5.76,11.65-7.33,14-.13.31.12.15.18.12,1.79-1.06,7.66-6.79,10.25-11.04,2.45-4.01,2.69-5.83-.14-6.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m304.16,125.58c-1.22,4.48-4.42,9.6-6.35,12.54.55-.5,1.11-1,1.66-1.51.07-.06.13-.12.2-.18.11-.11.22-.22.33-.34.29-.3.57-.61.85-.92,1.04-1.18,1.96-2.44,2.77-3.76.65-1.27,1.1-2.63,1.59-3.97.6-1.67,1.32-3.3,2.37-4.76.1-.15.22-.27.35-.39-.23-.11-.5-.22-.8-.31-.35-.11-2.19.76-2.96,3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m307.91,122.12c-.47-.19-.91-.23-.98-.07-.07.15.26.44.74.63.47.19.91.23.98.07.07-.15-.26-.44-.74-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m310.57,112.32s-.04-.08-.08-.08c-.05,0-.08.03-.08.07h0s0,.05,0,.12c0,.04,0,.09,0,.14,0,.06,0,.12,0,.19,0,.14-.02.31-.05.51-.01.1-.03.2-.04.31-.02.11-.04.23-.06.35-.02.12-.05.24-.07.37-.03.13-.06.26-.09.4-.06.27-.13.56-.21.86-.08.3-.16.6-.25.91-.09.31-.18.62-.28.93-.39,1.25-.84,2.48-1.18,3.39-.17.46-.32.84-.43,1.1-.11.26-.17.42-.17.42h0s0,0,0,0c-.04.11.03.23.15.27.12.04.25-.01.29-.12,0,0,.06-.15.16-.42.1-.27.24-.66.4-1.12.32-.93.73-2.18,1.09-3.44.09-.32.18-.63.26-.94.08-.31.16-.62.23-.92.07-.3.13-.59.19-.87.03-.14.05-.27.08-.41.02-.13.04-.26.06-.38.02-.12.03-.24.05-.35.01-.11.02-.22.03-.32.02-.2.03-.38.03-.52,0-.07,0-.14,0-.19,0-.06,0-.11,0-.14,0-.08,0-.12,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m313.56,111.49s-.09.01-.1.05h0s-.01.05-.03.13c0,.04-.02.09-.04.15-.02.06-.04.13-.06.21-.02.08-.05.16-.08.25-.03.09-.07.19-.11.3-.08.21-.18.45-.29.7-.11.26-.24.53-.39.82-.07.14-.15.29-.22.44-.08.15-.16.3-.24.46-.17.31-.34.63-.52.95-.18.32-.37.64-.56.97-.77,1.29-1.58,2.56-2.2,3.5-.62.94-1.05,1.56-1.05,1.56,0,0,0,0,0,0-.06.1-.03.23.08.29.11.06.25.04.31-.06,0,0,.41-.63,1.01-1.59.6-.96,1.38-2.25,2.11-3.56.18-.33.37-.66.54-.98.17-.33.34-.65.5-.96.08-.16.16-.31.23-.46.08-.15.15-.3.21-.45.14-.29.26-.57.37-.83.11-.26.2-.5.28-.72.04-.11.07-.21.1-.3.03-.09.06-.18.08-.26.02-.08.04-.15.06-.21.01-.06.02-.12.03-.16.02-.09.03-.13.03-.13,0-.04-.02-.08-.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m308.91,113.94c.14.14.26.24.26.24,0-.08-.12-.16-.26-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m309.49,114.07s-.28-.5-.91-.72c-.43-.15.01.3.33.6.15.08.26.16.26.24,0,0-.12-.1-.26-.24-.46-.24-1.31-.37-.57.2,1.47,1.13,1.38,2.54,1.38,2.54,0,0,.71-2.81-.41-3.7-.58-.47.17,1.09.17,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m309.91,111.83c.08.1.14.16.14.16,0-.06-.05-.11-.14-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m310.4,111.91s-.22-.55-.84-.85c-.48-.23.08.44.36.77.09.05.15.11.14.16,0,0-.06-.07-.14-.16-.44-.26-1.72-.41-.72.02,1.2.51,1.23,2.03,1.23,2.03,0,0,.48-2.55-.05-3.1-.53-.55.02,1.14.02,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m311.51,114.03c-.1,0-.17.03-.19.08,0,0,.08-.03.19-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m311.51,114.03c-.11.05-.19.08-.19.08.02-.05.09-.08.19-.08.38-.17,1.17-.55.64-.55-.68,0-1.11.41-1.11.41,0,0,1.15-1.36.48-1.03-1.09.54-1.6,2.93-1.6,2.93,0,0,.52-1.56,2.24-1.44,1.08.07-.15-.36-.65-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m312.13,116.76s.08-.01.21-.04c-.1-.01-.18,0-.21.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m312.34,116.72c-.12.02-.21.04-.21.04.03-.04.11-.05.21-.04.42-.08,1.29-.28.77-.39-.68-.14-1.2.16-1.2.16,0,0,1.48-1.06.73-.88-1.21.29-2.32,2.48-2.32,2.48,0,0,.9-1.38,2.57-.91,1.05.3-.06-.38-.56-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m312.89,111.16c-.74-.39-1.23.09-1.23.09-.49.14,2.1-1.65.47-.87-1.63.78-1.72,2.75-1.72,2.75.82-1.33,2.09-1.08,2.09-1.08-.27-.38-.93-.38-.93-.38.58-.67,2.06-.12,1.32-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m315.78,110.82c-.71-.43-1.23.02-1.23.02-.5.11,2.21-1.52.53-.84-1.68.68-1.9,2.64-1.9,2.64.91-1.27,2.16-.95,2.16-.95-.24-.39-.91-.43-.91-.43.62-.64,2.07,0,1.35-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m313,111.35s-.03-.68-.84-.88c-.81-.2.66.37.62,1.25,0,0-.49-.44-.95-.33,0,0,1.42.74.61,2.84,0,0,1.47-2.18.81-3.83-.66-1.65.01,1.38-.25.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m312.22,115.79c-.7-.45-1.24-.01-1.24-.01-.5.1,2.26-1.46.56-.82-1.71.64-1.99,2.58-1.99,2.58.95-1.25,2.19-.9,2.19-.9-.23-.4-.89-.45-.89-.45.64-.62,2.07.05,1.37-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m314.96,113.34c-.68-.48-1.24-.07-1.24-.07-.51.07,2.35-1.35.6-.79-1.75.56-2.13,2.48-2.13,2.48,1.02-1.2,2.25-.79,2.25-.79-.21-.41-.87-.49-.87-.49.68-.59,2.07.14,1.39-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m305.31,126.03s-.04.12.02.17c.03.03.55.43,1.33.74.41.17.9.31,1.42.36.05-.08.09-.15.13-.23-1.51-.1-2.71-1.04-2.72-1.05-.06-.04-.14-.04-.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m305.24,127.45s-.02.08.02.11c.03.02.45.33,1.07.58.32.13.69.24,1.08.29.03-.05.06-.1.09-.15-1.15-.12-2.13-.83-2.14-.84-.04-.03-.09-.02-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m302.6,133.07c-.47-.08-1.01-.37-1.34-.57-.03.05-.05.09-.08.14.21.13.51.29.82.42.19.08.38.14.57.17.05,0,.09-.02.1-.06,0-.04-.03-.09-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m301.43,134.31c-.39-.07-.71-.14-1.01-.36-.03.05-.05.09-.08.14.12.08.24.15.37.2.22.09.45.14.7.18.05,0,.09-.02.1-.06,0-.04-.03-.08-.07-.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m311,125.13c-.3-.18-2.19.19-3.56,2.63-2.58,4.6-7.99,9.39-9.98,11.2-.2.26.08.17.14.15,1.89-.56,8.62-4.48,11.99-7.79,3.18-3.13,3.83-4.74,1.42-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m307.43,127.76c-2.16,3.84-6.28,7.82-8.75,10.08.63-.33,1.25-.67,1.88-1.01.08-.04.15-.08.22-.12.13-.08.26-.15.38-.23.34-.21.67-.43,1-.65,1.23-.84,2.37-1.79,3.42-2.83.9-1.02,1.62-2.17,2.38-3.29.94-1.4,1.98-2.74,3.28-3.84.13-.11.27-.2.41-.28-.19-.16-.41-.31-.66-.47-.3-.18-2.19.19-3.56,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m311.68,125.45c-.39-.29-.79-.42-.89-.29-.1.13.14.46.53.75.39.29.79.42.89.29.1-.13-.14-.46-.53-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m316.34,116.95s-.08,0-.09.05h0s0,.04-.03.11c0,.04-.02.08-.03.13-.01.05-.03.11-.05.17-.04.13-.1.28-.16.46-.04.09-.07.18-.11.28-.04.1-.09.2-.13.3-.05.11-.1.21-.15.33-.06.11-.11.23-.17.35-.12.24-.25.49-.39.74-.14.25-.29.52-.44.78-.15.26-.31.53-.48.79-.65,1.06-1.34,2.09-1.87,2.85-.26.38-.49.7-.65.92-.16.22-.25.34-.25.34h0s0,0,0,0c-.06.09-.03.22.07.29.1.07.23.05.29-.04,0,0,.09-.13.24-.35.15-.23.37-.55.62-.94.51-.78,1.18-1.84,1.8-2.91.16-.27.31-.54.46-.81.15-.27.29-.54.42-.8.13-.26.26-.51.37-.76.06-.12.11-.24.16-.36.05-.12.1-.23.15-.34.04-.11.09-.21.13-.31.04-.1.07-.2.11-.29.06-.18.12-.34.15-.47.02-.07.04-.13.05-.18.01-.05.02-.1.03-.13.02-.07.02-.11.02-.11,0-.04-.02-.08-.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m319.24,116.99h0s-.02.04-.06.12c-.02.04-.04.08-.07.13-.03.05-.06.11-.1.18-.04.07-.09.14-.14.22-.05.08-.11.16-.17.25-.12.18-.27.37-.43.58-.16.21-.35.43-.55.66-.1.12-.2.23-.31.35-.11.12-.22.24-.33.36-.22.25-.46.5-.7.75-.24.25-.49.51-.74.76-1,1.01-2.04,1.99-2.83,2.72-.79.73-1.32,1.2-1.32,1.2,0,0,0,0,0,0-.08.07-.08.2,0,.29.09.08.22.09.3.02,0,0,.53-.49,1.3-1.23.77-.75,1.79-1.75,2.77-2.79.24-.26.49-.52.72-.78.24-.26.47-.52.69-.77.11-.13.22-.25.32-.37.1-.12.2-.24.3-.36.19-.24.37-.47.53-.68.16-.21.3-.41.42-.6.06-.09.12-.18.17-.26.05-.08.1-.15.13-.22.04-.07.07-.13.1-.18.03-.06.05-.1.07-.14.04-.08.06-.12.06-.12.02-.03,0-.08-.04-.1-.04-.02-.08,0-.1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m314.68,118.43c.01-.07-.07-.18-.19-.28.1.16.19.28.19.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m315,118.39s-.15-.53-.67-.87c-.36-.24-.06.28.17.62.12.1.2.21.19.28,0,0-.09-.12-.19-.28-.37-.33-1.12-.64-.57.05,1.09,1.38.68,2.66.68,2.66,0,0,1.3-2.42.48-3.5-.42-.56-.09,1.04-.09,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m316,116.62c.02-.05-.02-.11-.09-.18.05.11.09.18.09.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m316.33,116.62s-.08-.56-.58-.98c-.38-.33-.03.43.15.79.07.07.11.13.09.18,0,0-.04-.07-.09-.18-.35-.34-1.48-.77-.67-.15.98.75.67,2.15.67,2.15,0,0,1.03-2.23.67-2.87-.36-.63-.24,1.06-.24,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "m316.67,118.87s.08-.01.19-.03c-.09-.02-.16,0-.19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m316.87,118.83c-.11.02-.19.03-.19.03.03-.04.1-.05.19-.03.39-.07,1.2-.24.71-.35-.63-.15-1.12.12-1.12.12,0,0,1.38-.99.68-.83-1.13.25-2.15,2.33-2.15,2.33,0,0,.83-1.31,2.4-.81.98.32-.05-.37-.52-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "m316.81,121.48s.08,0,.2.01c-.09-.04-.16-.05-.2-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m317.8,121.31c-.59-.28-1.14-.13-1.14-.13,0,0,1.61-.64.88-.64-1.18-.01-2.7,1.74-2.7,1.74,0,0,1.15-1.07,2.58-.24.9.52.04-.36-.41-.54-.12,0-.2-.01-.2-.01.04-.03.11-.02.2.01.41.02,1.25.04.8-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m317.64,116.3c-.48.01,2.32-1.03.64-.69s-2.22,2.13-2.22,2.13c1.06-1.03,2.17-.51,2.17-.51-.16-.41-.77-.57-.77-.57.69-.49,1.92.37,1.33-.16-.59-.53-1.15-.2-1.15-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m320.4,116.6c-.48-.01,2.39-.89.68-.65-1.71.24-2.36,1.99-2.36,1.99,1.13-.96,2.21-.38,2.21-.38-.13-.42-.73-.61-.73-.61.72-.44,1.91.47,1.35-.09-.56-.56-1.14-.27-1.14-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m318.86,116.7s.13-.63-.57-1,.52.49.28,1.29c0,0-.35-.51-.8-.52,0,0,1.14,1.01-.09,2.75,0,0,1.86-1.66,1.63-3.33-.23-1.67-.31,1.27-.45.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m315.97,120.32c-.49-.03,2.42-.82.7-.63s-2.43,1.92-2.43,1.92c1.16-.93,2.23-.32,2.23-.32-.12-.42-.72-.62-.72-.62.73-.42,1.9.52,1.35-.05-.54-.57-1.14-.3-1.14-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m319.81,118.05c-1.74.11-2.54,1.79-2.54,1.79,1.21-.87,2.25-.21,2.25-.21-.1-.42-.69-.66-.69-.66.76-.38,1.87.61,1.36.02-.51-.6-1.12-.35-1.12-.35-.49-.05,2.47-.7.74-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m308.55,128.48c-.04-.05-.12-.07-.17-.03-.05.03-.06.11-.02.16.02.03.4.52,1.05.99.34.25.75.49,1.23.66.06-.06.12-.12.17-.18-1.36-.45-2.26-1.59-2.26-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m308.1,129.76s-.08-.04-.11-.02c-.03.02-.04.07,0,.11.02.03.34.41.85.78.26.19.58.38.93.52.04-.04.08-.08.12-.12-1.03-.37-1.77-1.26-1.77-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m304.26,134.29c-.42-.19-.84-.58-1.1-.84-.03.04-.07.07-.1.11.17.17.4.39.66.58.16.11.32.22.48.29.04.02.09,0,.1-.03.02-.04,0-.08-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "m302.9,135.17c-.34-.16-.62-.3-.84-.57-.04.04-.07.07-.11.11.09.11.19.19.29.27.18.13.38.23.6.33.04.02.09,0,.1-.03.02-.04,0-.08-.05-.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m269.83,120.04c-1.74-1.01-1.17-.22-1.17-.22,3.27,4.38,4.93,9.33,4.93,9.33,2.53,5.41,3.75,1.18,2.81-1.47-1.57-4.41-4.83-6.63-6.57-7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m281.41,135.6c-.06-.2-.27-.32-.47-.26l-2.34.68c-.2.06-.32.27-.26.47l.26,1.82c.06.2.27.32.47.26l2.78-.81c.2-.06.32-.27.26-.47l-.69-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m281.41,135.6c-.06-.2-.27-.32-.47-.26l-1.83.53c.49.18.94.44,1.29.81.36.38.59.83.7,1.29l.74-.22c.2-.06.32-.27.26-.47l-.69-1.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m278.67,117.99c-.72-2.18-3.6-7.41-5.81-6.76s-1.72,6.57-1.27,8.83c.9,4.48,2.44,9.69,3.35,13.25.57,2.23,2.97,3.49,5.18,2.84,2.21-.64,3.48-2.97,2.84-5.18-1.82-6.26-3.15-9.49-4.29-12.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m278.87,118.59c.02.3.03.59.03.89.02,1.63-.22,3.23-.3,4.85-.07,1.47-.03,2.74-.67,4.1-.35.75-1.55,1.15-2.25.66-1.29-.9-1.85-2.29-2.75-3.54-.03-.04-.05-.07-.08-.11.74,2.87,1.53,5.67,2.09,7.85.57,2.23,2.97,3.49,5.18,2.84,2.21-.64,3.48-2.97,2.84-5.18-1.72-5.89-2.99-9.1-4.09-12.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m273.5,120.96h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-23.02 81.53) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m278.46,125.89h.87c.22,0,.4.18.4.4v.05c0,.22-.18.4-.4.4h-.87c-.22,0-.4-.18-.4-.4v-.05c0-.22.18-.4.4-.4Z",
    transform: "translate(-24.21 83.13) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m278.75,123.03c-.06-.21-.28-.33-.49-.27l-.74.21c-.21.06-.33.28-.27.49.06.21.28.33.49.27l.74-.21c.21-.06.33-.28.27-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m272.97,119.16h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.54 81.35) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m273.06,117.44l-.49.12c-.17.04-.27.21-.23.37.04.17.21.27.37.23l.49-.12c.16-.04.27-.21.23-.37-.04-.17-.21-.27-.37-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m273.84,115.84l-.46.07c-.13.02-.23.15-.2.28v.04c.03.13.15.23.29.2l.46-.07c.13-.02.23-.15.2-.28v-.04c-.03-.13-.15-.23-.29-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m272.14,114.53h.47c.14,0,.25.11.25.25v.04c0,.14-.11.25-.25.25h-.47c-.14,0-.25-.11-.25-.25v-.04c0-.14.11-.25.25-.25Z",
    transform: "translate(-14.75 44.6) rotate(-9.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m274.1,113.06l-.25.08c-.13.04-.2.18-.16.31h0c.04.13.18.2.31.16l.25-.08c.13-.04.2-.18.16-.31-.04-.13-.18-.2-.31-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m272.71,111.74l-.25.03c-.09,0-.15.09-.14.17,0,.09.09.15.17.14l.25-.03c.09,0,.15-.09.14-.17s-.09-.15-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m276.01,131.63l-1.4.41s-.04.03-.03.05l.21.73s.03.04.05.03l1.4-.41s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m273.85,127.78h.81c.2,0,.36.16.36.36v.12c0,.2-.16.36-.36.36h-.81c-.2,0-.36-.16-.36-.36v-.12c0-.2.16-.36.36-.36Z",
    transform: "translate(-24.92 81.89) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 272.65,
    y: 124.56,
    width: 1.54,
    height: 0.85,
    rx: 0.36,
    ry: 0.36,
    transform: "translate(-24.06 81.57) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 276.14,
    y: 125.8,
    width: 1.54,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-24.27 82.63) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m282.84,130.38l-1.31.43s-.03.03-.03.05l.24.73s.03.03.05.03l1.31-.43s.03-.03.03-.05l-.24-.73s-.03-.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m282.19,128.38l-1.31.43s-.03.03-.03.05l.24.73s.03.03.05.03l1.31-.43s.03-.03.03-.05l-.24-.73s-.03-.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m275.18,115.53l-.49.12c-.17.04-.27.21-.23.37s.21.27.37.23l.49-.12c.17-.04.27-.21.23-.37-.04-.17-.21-.27-.37-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m271.64,115.83l-.26.05c-.11.02-.18.13-.16.23.02.11.13.18.23.16l.26-.05c.11-.02.18-.13.16-.23-.02-.11-.13-.18-.23-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m271.64,112.82l-.21.02c-.13.01-.23.14-.22.27.01.13.14.23.27.22l.21-.02c.13-.01.23-.14.22-.27-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m273.15,112.68l-.15.02c-.13.01-.23.14-.22.27.02.13.14.23.27.22l.15-.02c.13-.01.23-.14.22-.27-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m273.82,111.26l-.12.05c-.11.04-.16.16-.12.27.04.11.16.16.27.12l.12-.05c.11-.04.16-.16.12-.27-.04-.11-.16-.16-.27-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m275.38,113.54l-.39.11c-.13.04-.21.18-.17.31.04.13.18.21.31.17l.39-.11c.13-.04.21-.18.17-.31s-.18-.21-.31-.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.48,132.96l-.43.13c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.43-.13c.22-.07.35-.3.29-.53s-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.18,131.93l-.43.13c-.22.07-.35.3-.29.53h0c.07.22.3.35.53.29l.43-.13c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.42,131.23c-.07-.22-.3-.35-.53-.29l-.43.13c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.43-.13c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.45,134.91l-1.16.34s-.04.03-.03.05l.21.73s.03.04.05.03l1.16-.34s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.82,134.01l-.43.13c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.43-.13c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.11,130.16c-.07-.22-.3-.35-.53-.29l-.43.13c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.43-.13c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.28,128.84l-.43.13c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.43-.13c.22-.07.35-.3.29-.53s-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.01,127.89l-.43.13c-.22.07-.35.3-.29.53s.3.35.53.29l.43-.13c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.2,127.05c-.06-.21-.28-.33-.5-.27l-.48.14c-.21.06-.33.28-.27.5v.05c.07.21.3.33.51.27l.48-.14c.21-.06.33-.28.27-.5v-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 274.66,
    y: 125.88,
    width: 1.3,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-24.35 82.12) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 274.34,
    y: 124.78,
    width: 1.3,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-24.05 81.97) rotate(-16.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.28,124.03c-.06-.21-.28-.33-.49-.27l-.4.12c-.21.06-.33.28-.27.49h0c.06.21.28.33.49.27l.4-.12c.21-.06.33-.28.27-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.99,123.05c-.06-.21-.28-.33-.49-.27l-.4.12c-.21.06-.33.28-.27.49s.28.33.49.27l.4-.12c.21-.06.33-.28.27-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.88,121.85h.49c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.49c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-23.26 81.65) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.24,120.06h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.78 81.44) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.65,130.88l-.79.23c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.79-.23c.22-.07.35-.3.29-.53s-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.36,129.89l-.79.23c-.22.07-.35.3-.29.53h0c.07.22.3.35.53.29l.79-.23c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.64,133.98l-1.4.41s-.04.03-.03.05l.21.73s.03.04.05.03l1.4-.41s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.34,132.98l-1.4.41s-.04.03-.03.05l.21.73s.03.04.05.03l1.4-.41s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.05,128.82l-.79.23c-.22.07-.35.3-.29.53h0c.07.22.3.35.53.29l.79-.23c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.75,127.79l-.79.23c-.22.07-.35.3-.29.53h0c.07.22.3.35.53.29l.79-.23c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280,127.13c-.07-.22-.3-.35-.53-.29l-.79.23c-.22.07-.35.3-.29.53s.3.35.53.29l.79-.23c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 277.78,
    y: 124.94,
    width: 1.67,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-23.95 83) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 277.46,
    y: 123.83,
    width: 1.67,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-23.66 82.88) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.49,122.14c-.06-.21-.28-.33-.49-.27l-.74.21c-.21.06-.33.28-.27.49h0c.06.21.28.33.49.27l.74-.21c.21-.06.33-.28.27-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.03,120.98h.84c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.84c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-22.89 82.53) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.64,120.35c-.06-.19-.25-.3-.44-.24l-.56.16c-.19.06-.3.25-.24.44s.25.3.44.24l.56-.16c.19-.06.3-.25.24-.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.47,119.07l-.56.16c-.19.06-.3.25-.24.44.06.19.25.3.44.24l.56-.16c.19-.06.3-.25.24-.44-.06-.19-.25-.3-.44-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.26,118.28l-.49.12c-.17.04-.27.21-.23.37.04.17.21.27.37.23l.49-.12c.17-.04.27-.21.23-.37-.04-.17-.21-.27-.37-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.37,116.65h.62c.14,0,.25.11.25.25v.11c0,.14-.11.25-.25.25h-.62c-.14,0-.25-.11-.25-.25v-.11c0-.14.11-.25.25-.25Z",
    transform: "translate(-19.7 66.5) rotate(-13.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 272.11,
    y: 115.88,
    width: 0.96,
    height: 0.53,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(-14.96 44.65) rotate(-9.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.25,115.21h.47c.14,0,.25.11.25.25v.04c0,.14-.11.25-.25.25h-.47c-.14,0-.25-.11-.25-.25v-.04c0-.14.11-.25.25-.25Z",
    transform: "translate(-14.83 44.53) rotate(-9.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.6,116.45h.62c.14,0,.25.11.25.25v.11c0,.14-.11.25-.25.25h-.62c-.14,0-.25-.11-.25-.25v-.11c0-.14.11-.25.25-.25Z",
    transform: "translate(-19.61 66.69) rotate(-13.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.33,115.2h.47c.14,0,.25.11.25.25v.04c0,.14-.11.25-.25.25h-.47c-.14,0-.25-.11-.25-.25v-.04c0-.14.11-.25.25-.25Z",
    transform: "translate(-14.84 44.8) rotate(-9.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.54,113.82l-.26.03c-.13.01-.23.14-.22.27h0c.02.13.14.23.27.22l.26-.03c.13-.01.23-.14.22-.27h0c-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.47,113.2l-.4.04c-.13.02-.23.14-.22.27.01.13.14.23.27.22l.4-.04c.13-.01.23-.14.22-.27-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.4,112.57l-.21.02c-.13.01-.23.14-.22.27s.14.23.27.22l.21-.02c.13-.01.23-.14.22-.27-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.23,112.08l-.21.02c-.13.01-.23.14-.22.27h0c.01.13.14.23.27.22l.21-.02c.13-.01.23-.14.22-.27-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.42,113.66l-.46.07c-.13.02-.23.15-.21.28v.04c.03.13.15.23.29.21l.46-.07c.13-.02.23-.15.21-.28v-.04c-.03-.13-.15-.23-.29-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.09,112.42l-.39.07c-.13.02-.22.15-.2.28.02.13.15.22.28.2l.39-.07c.13-.02.22-.15.2-.28h0c-.02-.13-.15-.22-.28-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.88,111.8l-.21.05c-.13.03-.21.17-.18.3.03.13.17.21.3.18l.21-.05c.13-.03.21-.17.18-.3-.03-.13-.17-.21-.3-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.54,112.17l-.25.03c-.09,0-.15.09-.14.17,0,.09.09.15.17.14l.25-.03c.09,0,.15-.09.14-.17,0-.09-.09-.15-.17-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.64,111.29l-.29.08c-.1.03-.16.13-.13.23.03.1.13.16.23.13l.29-.08c.1-.03.16-.13.13-.23-.03-.1-.13-.16-.23-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.35,111.08l-.29.08c-.1.03-.16.13-.13.23.03.1.13.16.23.13l.29-.08c.1-.03.16-.13.13-.23-.03-.1-.13-.16-.23-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.31,132.66l-1.4.41s-.04.03-.03.05l.21.73s.03.04.05.03l1.4-.41s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.72,130.64l-1.4.41s-.04.03-.03.05l.21.73s.03.04.05.03l1.4-.41s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.47,133.8l-1.4.41s-.04.03-.03.05l.21.73s.03.04.05.03l1.4-.41s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.57,129.97c-.07-.22-.3-.35-.53-.29l-.66.19c-.22.07-.35.3-.29.53s.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.27,128.94c-.07-.22-.3-.35-.53-.29l-.66.19c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.53,126.67h.81c.2,0,.36.16.36.36v.12c0,.2-.16.36-.36.36h-.81c-.2,0-.36-.16-.36-.36v-.12c0-.2.16-.36.36-.36Z",
    transform: "translate(-24.63 81.8) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.22,125.62h.81c.2,0,.36.16.36.36v.12c0,.2-.16.36-.36.36h-.81c-.2,0-.36-.16-.36-.36v-.12c0-.2.16-.36.36-.36Z",
    transform: "translate(-24.35 81.67) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.74,123.62h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-23.8 81.44) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.49,122.64h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-23.54 81.32) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.21,121.66h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-23.28 81.24) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.02,120.78h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-23.03 81.12) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.86,119.96h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.8 81.04) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.53,118.56h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.42 80.9) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.15,119.28l-.43.12c-.14.04-.23.19-.19.34.04.14.19.23.34.19l.43-.12c.14-.04.23-.19.19-.34-.04-.14-.19-.23-.34-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.28,118c-.04-.17-.21-.27-.37-.23l-.49.12c-.17.04-.27.21-.23.37.04.17.21.27.37.23l.49-.12c.17-.04.27-.21.23-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.92,131.9l-.66.19c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.15,131.16c-.07-.22-.3-.35-.53-.29l-.66.19c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.86,130.17c-.07-.22-.3-.35-.53-.29l-.66.19c-.22.07-.35.3-.29.53s.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.3,132.98l-.66.19c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.64,134.13l-.66.19c-.22.07-.35.3-.29.53s.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.02,128.81l-.66.19c-.22.07-.35.3-.29.53h0c.07.22.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53-.07-.22-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.25,128.07c-.07-.22-.3-.35-.53-.29l-.66.19c-.22.07-.35.3-.29.53h0c.07.22.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.45,126.83l-.66.19c-.22.07-.35.3-.29.53h0c.07.22.3.35.53.29l.66-.19c.22-.07.35-.3.29-.53s-.3-.35-.53-.29Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 275.84,
    y: 124.75,
    width: 1.54,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-23.99 82.49) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.03,123.69h.74c.22,0,.4.18.4.4v.05c0,.22-.18.4-.4.4h-.74c-.22,0-.4-.18-.4-.4v-.05c0-.22.18-.4.4-.4Z",
    transform: "translate(-23.69 82.33) rotate(-16.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.77,122.95c-.06-.21-.28-.33-.49-.27l-.62.18c-.21.06-.33.28-.27.49.06.21.28.33.49.27l.62-.18c.21-.06.33-.28.27-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.47,121.77h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-23.18 82.16) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.19,120.79h.72c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.72c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-22.91 82.01) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.36,119.89l-.56.16c-.19.06-.3.25-.24.44.06.19.25.3.44.24l.56-.16c.19-.06.3-.25.24-.44-.05-.19-.25-.3-.44-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.43,119.21h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.49 81.74) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.51,129.36l-1.31.43s-.03.03-.03.05l.24.73s.03.03.05.03l1.31-.43s.03-.03.03-.05l-.24-.73s-.03-.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m282.45,132.06l-1.18.34s0,0,0,0c.02-.08.03-.16,0-.24-.07-.22-.3-.35-.53-.29l-.66.19c-.22.07-.35.3-.29.53.07.22.3.35.53.29l.66-.19c.12-.04.22-.12.27-.23l.21.73s.03.04.05.03l1.18-.34s.04-.03.03-.05l-.21-.73s-.03-.04-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.84,127.32l-1.31.43s-.03.03-.03.05l.24.73s.03.03.05.03l1.31-.43s.03-.03.03-.05l-.24-.73s-.03-.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.51,126.3l-1.31.43s-.03.03-.03.05l.24.73s.03.03.05.03l1.31-.43s.03-.03.03-.05l-.24-.73s-.03-.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m281.2,125.36l-1.31.43s-.03.03-.03.05l.24.73s.03.03.05.03l1.31-.43s.03-.03.03-.05l-.24-.73s-.03-.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.84,124.27l-1.31.43s-.03.03-.03.05l.24.73s.03.03.05.03l1.31-.43s.03-.03.03-.05l-.24-.73s-.03-.03-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m280.66,123.59c-.07-.21-.3-.32-.5-.26l-.63.21c-.21.07-.32.3-.26.51l.02.05c.07.21.3.32.5.26l.63-.21c.21-.07.32-.3.26-.5l-.02-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 279,
    y: 122.37,
    width: 1.46,
    height: 0.85,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(-24.33 93.24) rotate(-18.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m279.53,121.37l-.55.18c-.21.07-.32.29-.25.5.07.21.29.32.5.25l.55-.18c.21-.07.32-.29.25-.5-.07-.21-.29-.32-.5-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.77,120.46h.65c.2,0,.36.16.36.36v.07c0,.2-.16.36-.36.36h-.65c-.2,0-.36-.16-.36-.36v-.07c0-.2.16-.36.36-.36Z",
    transform: "translate(-23.77 93.06) rotate(-18.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.59,119.44h.59c.18,0,.32.14.32.32v.16c0,.18-.14.32-.32.32h-.59c-.18,0-.32-.14-.32-.32v-.16c0-.18.14-.32.32-.32Z",
    transform: "translate(-22.4 82.91) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.48,118.66h.48c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.48c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.18 82.8) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.34,118.22h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.1 82.52) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.48,116.99h.57c.17,0,.31.14.31.31v.03c0,.17-.14.31-.31.31h-.56c-.17,0-.31-.14-.31-.31v-.03c0-.17.14-.31.31-.31Z",
    transform: "translate(-21.78 82.19) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.22,116.18h.68c.14,0,.25.11.25.25v.15c0,.14-.11.25-.25.25h-.68c-.14,0-.25-.11-.25-.25v-.15c0-.14.11-.25.25-.25Z",
    transform: "translate(-21.56 82.1) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.4,115.35l-.51.15c-.17.05-.27.23-.22.41.05.17.23.27.41.22l.51-.15c.17-.05.27-.23.22-.41-.05-.17-.23-.27-.41-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.17,114.64l-.46.13c-.16.05-.25.21-.2.36.05.16.21.25.36.2l.46-.13c.16-.05.25-.21.2-.36-.05-.16-.21-.25-.36-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.83,114.02l-.46.13c-.16.05-.25.21-.2.36.05.16.21.25.36.2l.46-.13c.16-.05.25-.21.2-.36-.05-.16-.21-.25-.36-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.1,117.81h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.12 81.63) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.72,118.53l-.43.12c-.14.04-.23.19-.19.34.04.14.19.23.34.19l.43-.12c.14-.04.23-.19.19-.34-.04-.14-.19-.23-.34-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.31,117.07l-.49.12c-.17.04-.27.21-.23.37.04.17.21.27.37.23l.49-.12c.16-.04.27-.21.23-.37-.04-.17-.21-.27-.37-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.92,114.97l-.43.07c-.14.02-.24.16-.22.3h0c.02.14.16.24.3.22l.43-.07c.14-.02.24-.16.22-.3-.02-.14-.16-.24-.3-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.33,114.3h.47c.14,0,.25.11.25.25v.04c0,.14-.11.25-.25.25h-.47c-.14,0-.25-.11-.25-.25v-.04c0-.14.11-.25.25-.25Z",
    transform: "translate(-14.68 44.94) rotate(-9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.52,118.33h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-22.2 81.98) rotate(-16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.2,116.93h.67c.17,0,.31.14.31.31v.09c0,.17-.14.31-.31.31h-.67c-.17,0-.31-.14-.31-.31v-.09c0-.17.14-.31.31-.31Z",
    transform: "translate(-21.83 81.9) rotate(-16.27)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.13,117.65l-.44.13c-.15.04-.23.2-.19.35.04.15.2.23.35.19l.44-.13c.15-.04.23-.2.19-.35-.04-.15-.2-.23-.35-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.5,116.79c-.05-.16-.22-.26-.38-.21l-.54.16c-.16.05-.26.22-.21.38v.03c.06.16.23.26.39.21l.54-.16c.16-.05.26-.22.21-.39v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.54,115.86h.26c.17,0,.31.14.31.31v.03c0,.17-.14.31-.31.31h-.26c-.17,0-.31-.14-.31-.31v-.03c0-.17.14-.31.31-.31Z",
    transform: "translate(-21.43 82.47) rotate(-16.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.43,115.21l-.39.11c-.13.04-.21.18-.17.31.04.13.18.21.31.17l.39-.11c.13-.04.21-.18.17-.31-.04-.13-.18-.21-.31-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.11,114.73l-.31.09c-.11.03-.16.16-.12.29.04.13.15.21.26.17l.31-.09c.11-.03.16-.16.12-.29-.04-.13-.15-.21-.26-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.66,114.08l-.28.08c-.1.03-.15.15-.11.26.03.12.14.19.24.16l.28-.08c.1-.03.15-.15.11-.26-.03-.12-.14-.19-.24-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.79,111.91l-.33.1c-.11.03-.19.14-.17.26.02.13.15.21.28.17l.33-.1c.11-.03.19-.14.17-.26-.02-.13-.15-.21-.28-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m278.31,117.31l-.44.13c-.15.04-.23.2-.19.35.04.15.2.23.35.19l.44-.13c.15-.04.23-.2.19-.35-.04-.15-.2-.23-.35-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m277.77,119.14l-.44.13c-.15.04-.23.2-.19.35.04.15.2.23.35.19l.44-.13c.15-.04.23-.2.19-.35-.04-.15-.2-.23-.35-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.81,117.66l-.43.12c-.14.04-.23.19-.19.34.04.14.19.23.34.19l.43-.12c.14-.04.23-.19.19-.34-.04-.14-.19-.23-.34-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.93,116.25h.62c.14,0,.25.11.25.25v.11c0,.14-.11.25-.25.25h-.62c-.14,0-.25-.11-.25-.25v-.11c0-.14.11-.25.25-.25Z",
    transform: "translate(-19.53 67.04) rotate(-13.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 271.19,
    y: 117.09,
    width: 0.95,
    height: 0.62,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(-19.82 66.22) rotate(-13.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 271.03,
    y: 116.38,
    width: 1.03,
    height: 0.62,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(-19.67 66.22) rotate(-13.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.69,115.26l-.34.05c-.12.02-.19.13-.18.24.02.12.13.19.24.18l.34-.05c.12-.02.19-.13.18-.24-.02-.12-.13-.19-.24-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.49,114.71l-.16.03c-.14.03-.25.15-.23.27.02.12.15.2.29.18l.16-.03c.14-.03.25-.15.23-.27-.02-.12-.15-.2-.29-.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 271.08,
    y: 114.1,
    width: 0.96,
    height: 0.53,
    rx: 0.25,
    ry: 0.25,
    transform: "translate(-14.69 44.47) rotate(-9.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.53,113.47l-.18.02c-.13.01-.23.14-.22.27s.14.23.27.22l.18-.02c.13-.01.23-.14.22-.27-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m271.8,112.28h-.13c-.11.03-.2.13-.18.24.01.11.12.2.23.18h.13c.11-.03.2-.13.18-.24-.01-.11-.12-.2-.23-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m272.02,111.83l-.13.02c-.11.02-.2.11-.19.21,0,.1.11.17.22.15l.13-.02c.11-.02.2-.11.19-.21,0-.1-.11-.17-.22-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.19,114.46h.47c.14,0,.25.11.25.25v.04c0,.14-.11.25-.25.25h-.47c-.14,0-.25-.11-.25-.25v-.04c0-.14.11-.25.25-.25Z",
    transform: "translate(-14.71 44.72) rotate(-9.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.34,113.86l-.18.02c-.13.01-.23.14-.22.27.01.13.14.23.27.22l.18-.02c.13-.01.23-.14.22-.27-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.27,113.26l-.21.02c-.13.01-.23.14-.22.27.01.13.14.23.27.22l.21-.02c.13-.01.23-.14.22-.27h0c-.01-.13-.14-.23-.27-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m273.23,111.53l-.12.05c-.11.04-.16.16-.12.27.04.11.16.16.27.12l.12-.05c.11-.04.16-.16.12-.27-.04-.11-.16-.16-.27-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.44,111.52l-.12.05c-.11.04-.16.16-.12.27.04.11.16.16.27.12l.12-.05c.11-.04.16-.16.12-.27-.04-.11-.16-.16-.27-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.08,113.02l-.37.12c-.13.04-.2.18-.16.3.04.13.18.2.3.16l.37-.12c.13-.04.2-.18.16-.3-.04-.13-.18-.2-.3-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m274.93,112.51l-.32.09c-.11.03-.17.15-.14.25.03.11.15.17.25.14l.32-.09c.11-.03.17-.15.14-.25-.03-.11-.15-.17-.25-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.63,112.64l-.22.12c-.07.04-.1.13-.06.21.04.07.13.1.21.06l.22-.12c.07-.04.1-.13.06-.21-.04-.07-.13-.1-.21-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m275.86,113.05l-.23.13c-.08.04-.11.14-.07.22.04.08.14.11.22.07l.23-.13c.08-.04.11-.14.07-.22-.04-.08-.14-.11-.22-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m276.22,113.42l-.28.13c-.09.04-.14.16-.09.25s.16.14.25.09l.28-.13c.09-.04.14-.16.09-.25-.04-.09-.16-.14-.25-.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m283.07,130.92l-.1-.31c-.03-.08-.08-.13-.15-.16-.03-.11-.07-.23-.1-.34.04-.06.05-.14.02-.21l-.1-.31c-.02-.06-.07-.11-.12-.14-.04-.12-.07-.24-.11-.35.02-.05.03-.11,0-.17l-.1-.31c-.02-.05-.05-.09-.09-.12-.05-.16-.1-.33-.15-.49.01-.04.01-.09,0-.14l-.1-.31s-.04-.08-.07-.1c-.04-.13-.08-.26-.12-.38-.01-.03-.02-.07-.03-.1,0-.04,0-.08,0-.12l-.1-.31s-.03-.07-.06-.1c-.03-.08-.05-.16-.08-.25-.01-.04-.03-.09-.04-.13,0-.01,0-.03-.01-.04,0-.04,0-.08,0-.11l-.1-.31s-.04-.07-.06-.1c-.02-.05-.03-.09-.05-.14-.01-.04-.03-.08-.04-.12-.03-.1-.07-.2-.1-.3,0-.04,0-.08,0-.12l-.1-.31s-.04-.08-.08-.11c-.06-.16-.11-.32-.16-.48.01-.05.02-.1,0-.14l-.1-.31c-.02-.05-.06-.1-.1-.13-.02-.07-.05-.13-.07-.2-.01-.04-.03-.07-.04-.11,0,0,0-.02,0-.03.07-.07.11-.17.07-.27l-.1-.31s-.02-.05-.04-.08c-.68,1.94-1.12,9.92-1.57,10.25-1.21.9-5.35-6.11-5.73-6.52-.05-.06-.11-.11-.16-.17-.04.06-.05.13-.03.2l.09.32c.03.1.12.17.22.19.02.09.05.19.07.28-.07.06-.11.17-.08.27l.09.32c.03.09.1.16.19.18.03.12.07.25.1.37-.06.06-.09.15-.06.24l.09.32c.02.08.09.14.16.17.02.08.04.16.07.24-.05.06-.07.14-.04.22l.09.32c.02.07.08.13.14.16.03.12.06.23.09.35-.04.06-.05.13-.03.2l.09.32c.02.06.06.11.12.15.02.06.03.12.05.18.02.09.05.17.07.26-.02.05-.03.11-.01.17l.09.32c.01.05.05.09.08.12.04.14.08.29.11.43,0,.04-.01.08,0,.13l.09.32s.03.06.05.09c.05.2.1.4.15.59,0,0,0,.01,0,.02,0,0,0,0,0,.01l.09.32s.02.03.03.05c.06.16.13.31.21.46-.13.04-.21.18-.17.32l.09.32c.04.14.19.22.32.18l.26-.08c1.03,1.18,2.73,1.71,4.33,1.25,2.13-.62,3.39-2.82,2.89-4.96.06-.07.09-.16.06-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m275.88,131.04c-4.81-9.89-9.49-9.59-9.49-9.59-.9.14,2.57,1.24,5.35,6.52.81,1.55,2.25,8.62,4.87,9.21,3.32.74,5.27-2.38,5.27-2.38,0,0-3.04,2.35-6.01-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m278.65,134.65c-.07.32-.18.63-.34.94-.39.78-1,1.3-1.72,1.58,0,0,.01,0,.02,0,3.32.74,5.27-2.38,5.27-2.38,0,0-1.41,1.08-3.24-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m280.04,135.98h0s-.06.04-.18.1c-.12.06-.3.15-.53.24-.46.17-1.19.35-2,.11-.81-.23-1.6-.94-2.15-1.88-.28-.47-.51-.98-.71-1.53-.21-.55-.41-1.11-.64-1.66-.22-.55-.45-1.11-.7-1.64-.24-.54-.49-1.06-.74-1.56-.25-.5-.5-.98-.75-1.43-.25-.45-.5-.87-.74-1.24-.48-.76-.93-1.36-1.26-1.76-.33-.41-.55-.61-.55-.61-.01-.01-.03-.01-.04,0-.01.01-.01.03,0,.04,0,0,.21.21.52.63.31.41.73,1.03,1.19,1.79.23.38.46.8.71,1.25.24.45.48.93.72,1.44.23.5.47,1.03.7,1.57.23.54.45,1.09.66,1.65.22.55.4,1.12.6,1.67.2.56.44,1.11.73,1.6.29.49.64.94,1.04,1.29.4.36.85.62,1.3.76.45.14.9.16,1.28.11.38-.05.7-.15.95-.24.25-.1.44-.19.57-.26.13-.07.19-.11.19-.11.08-.05.11-.15.07-.23-.04-.08-.15-.12-.23-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "m280.31,135.78h0s-.05.01-.14.04c-.09.02-.22.05-.39.06-.34.04-.84,0-1.38-.22-.55-.22-1.13-.62-1.65-1.17-.26-.27-.51-.57-.73-.9-.23-.32-.41-.68-.6-1.04-.74-1.45-1.44-2.93-1.97-4.03-.54-1.1-.9-1.83-.9-1.83,0,0,.32.75.81,1.87.5,1.12,1.16,2.61,1.85,4.09.17.37.36.75.59,1.08.23.34.48.65.75.93.54.57,1.14,1,1.73,1.24.59.24,1.14.27,1.51.22.19-.02.33-.05.42-.08.1-.03.15-.04.15-.04.06-.02.1-.08.09-.15-.02-.07-.08-.11-.15-.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m294.22,135.12c-1-1.26.55-3.65-1.93-3.92-2.48-.27-5.97,7.34-5.97,7.34,0,0-2.78,2.56,0,3.95,2.78,1.39,5.62-.45,7.53-1.81,1.91-1.36,0-1.74.36-2.14.36-.4,1-2.15,0-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m294.22,135.12c-1-1.26.55-3.65-1.93-3.92-2.48-.27-5.97,7.34-5.97,7.34,0,0-2.78,2.56,0,3.95,2.78,1.39,5.62-.45,7.53-1.81,1.91-1.36,0-1.74.36-2.14.36-.4,1-2.15,0-3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "m279.29,136.94s-1.51-1.79-3.02-1.15c-1.51.64-.27,2.69.57,3.84.84,1.15-1.12,1.83,2.57,2.93,3.7,1.1,2.84,2.71,7.08.73,4.24-1.98-7.21-6.36-7.21-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m279.29,136.94s-1.3-1.54-2.7-1.24c.61,1.06,1,2.29,1.28,3.56,0,0,.12.48.16.68.03,0,.22.38.14.32.28.32.64.57.94.87.54.55.98,1.14,1.3,1.79,2.58,1.04,2.28,2.16,6.09.39,4.24-1.98-7.21-6.36-7.21-6.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m290.81,130.61c-1.73-1.77-4.16-3.32-6.52-2.96-1.77.26-3,1.7-4.08,3.14-1.48,1.97-2.47,4.26-2.14,6.61.57,4.07,4.16,6.2,8.36,5.57,4.2-.62,7.43-3.77,6.86-7.83-.25-1.78-1.14-3.14-2.49-4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m288.34,127.47c-1.43-1.35-3.15.18-3.15.18,0,0,.9,1.83-.17,3.84s-4.33,6.51-.6,11.56l.16-.09s-.16-2.11.28-3.88c.44-1.77-.29-2.09-.29-2.09.19-1.59.44-1.77,2.66-3.67,2.22-1.89.32-2.61.32-2.61.48-.5,2.22-1.89.79-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m285.19,127.65s-1.26-2.09-1.37.06c-.11,2.15,1.09,1.83.8,2.73,0,0-1.26.9-1.74,2.39-.48,1.49-1.67,7,1.54,10.22,0,0-3.12-4.73.26-9.21,3.38-4.48.51-6.19.51-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m289.85,138.01c-.08-.09-.17-.17-.26-.24-.09-.07-.19-.14-.3-.2-.1-.06-.21-.1-.32-.13-.11-.04-.23-.05-.34-.06.11.04.21.08.31.13.1.05.19.11.28.18.09.07.17.15.24.22.07.08.14.17.21.26.06.09.12.18.18.28.06.09.1.2.15.3.09.2.17.41.24.63.13.43.23.87.3,1.32.03.2.05.39.07.59.14-.1.26-.21.39-.31.03-.1.3-.22.29-.26-.11-.46-.48-1.05-.67-1.49-.19-.44-.44-.86-.76-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m291.99,135.37c-.14-.45-.32-.89-.57-1.28-.24-.4-.54-.76-.88-1.06-.17-.16-.35-.29-.53-.41-.18-.13-.38-.23-.58-.33.34.28.66.59.93.93.14.17.26.34.37.53.11.18.22.37.31.56.18.39.31.8.4,1.21.09.42.14.84.16,1.27.02.43,0,.86-.03,1.29-.04.43-.1.86-.18,1.29-.08.43-.18.85-.3,1.27,0,.01,0,.03-.01.04.01.06.02.12.04.18.32-.28.61-.59.87-.92.03-.14.07-.29.1-.43.09-.45.15-.91.18-1.38.03-.46.03-.93-.01-1.4-.04-.47-.12-.93-.26-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m280.65,132.49c-.16.15-.34.3-.52.51-.09.1-.18.2-.27.32-.09.11-.18.23-.26.37-.08.13-.17.26-.24.41-.04.07-.08.15-.11.22-.03.08-.07.15-.1.23-.14.31-.24.65-.33.99-.08.35-.15.71-.18,1.07-.04.36-.05.73-.05,1.08,0,.28.02.56.04.84-.02.24-.03.49-.03.72.05.11.1.22.16.33.12.24.25.46.4.67.16.24.34.47.54.68-.05-.16-.11-.33-.16-.51-.07-.25-.15-.52-.22-.81-.07-.29-.13-.6-.18-.92-.04-.27-.08-.55-.1-.84,0-.04,0-.08.01-.12.03-.25.08-.49.14-.72.06-.23.15-.45.24-.65.05-.1.1-.19.15-.28.06-.09.11-.17.17-.25.06-.07.12-.14.18-.21.06-.07.12-.12.18-.18.11-.11.23-.18.31-.26.19-.12.3-.19.3-.19,0,0-.12.06-.32.16-.09.07-.22.13-.34.23-.06.05-.13.1-.19.16-.06.06-.13.13-.2.2-.06.08-.13.16-.19.24-.06.09-.12.18-.18.28-.1.18-.2.38-.28.59,0-.07,0-.14,0-.21.01-.35.05-.69.11-1.03.07-.34.14-.67.26-.97.03-.08.05-.15.08-.23.03-.07.06-.15.1-.22.06-.15.13-.28.21-.41.07-.13.15-.25.23-.37.07-.12.16-.23.24-.33.16-.21.33-.37.48-.53.16-.14.3-.27.42-.36.25-.18.39-.28.39-.28,0,0-.15.09-.41.26-.13.09-.27.2-.44.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m291.39,131.24c.51,1.69.58,3.55.17,5.31-.78,3.34-4.07,6-7.5,6.47.76.08,1.55.07,2.38-.05,4.2-.62,7.43-3.77,6.86-7.83-.21-1.51-.89-2.71-1.91-3.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "m272.53,119.68c-.14-.11-.34-.08-.44.06-.1.14-.08.34.06.44,1.32,1,1.07,2.9,1.06,2.92-.02.17.1.33.27.36.04,0,.08,0,.11,0,.12-.03.22-.13.24-.26.01-.09.3-2.29-1.31-3.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m275.52,120.91c-.63.14-1.14.6-1.5,1.26-.09.12-.5.91-.5.91,0,0-.63-.38-.97-.57-.61-.44-1.27-.63-1.9-.48-1.66.38-3.24,1.83-2.61,4.56.62,2.73,4.11,5.4,5.77,5.02.41-.09.71-.3.93-.59h.01c.48-.4,1-.23,1.03-.22.32.16.68.21,1.07.12,1.66-.38,3.64-4.3,3.01-7.03-.63-2.73-2.68-3.35-4.34-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m272.1,123.11s-1.16-.63-2.37.44c-1.21,1.07-1.18,3.6.48,5.18,1.66,1.58-.38-1.82,1.96-4.12.93-.91-.07-1.5-.07-1.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m346.31,85.06s0-.04.01-.06c-.02,0-.04,0-.06-.01.02.02.03.05.05.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m276.18,127.39s-3.77-.63-5.14,3.4c-1.37,4.03-3.43,4.69-3.64,6.73-.21,2.04,4.09,5.64,7.08,3.06,2.99-2.59,8.33-10.2,1.71-13.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m276.18,127.39s-3.77-.63-5.14,3.4c-.82,2.42-1.89,3.62-2.66,4.64.43-.17.89-.26,1.3-.45,2.73-1.24,4.29.05,6.99-2.25.94-.8,1.47-1.94,2.28-2.82-.45-.99-1.33-1.86-2.77-2.52Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m274.61,128.66c-.19-.11-.4-.12-.46-.01-.06.11.04.28.23.39.19.11.4.12.46.01.06-.11-.04-.28-.23-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m275.88,128.64c-.16-.09-.33-.11-.38-.03-.05.08.05.22.21.31s.33.11.38.03c.05-.08-.05-.22-.21-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m276.41,130.04c-.16-.09-.33-.11-.38-.03s.05.22.21.31.33.11.38.03c.05-.08-.05-.22-.21-.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m270.79,138.13c-.19-.11-.4-.12-.46-.01-.06.11.04.28.23.39.19.11.4.12.46.01.06-.11-.04-.28-.23-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m272.07,138.11c-.16-.09-.33-.11-.38-.03-.05.08.05.22.21.31.16.09.33.11.38.03.05-.08-.05-.22-.21-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m272.6,139.51c-.16-.09-.33-.11-.38-.03-.05.08.05.22.21.31.16.09.33.11.38.03.05-.08-.05-.22-.21-.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m274.37,130.06c-.13-.06-.26-.05-.3.02-.03.07.04.18.17.24.13.06.26.05.3-.02.03-.07-.04-.18-.17-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m273.51,130.21c-.11-.05-.22-.05-.24,0-.03.05.04.14.15.19.11.05.22.05.24,0,.03-.05-.04-.14-.15-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m273.1,129.34c-.11-.05-.22-.05-.24,0-.03.05.04.14.15.19.11.05.22.05.24,0,.03-.05-.04-.14-.15-.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m271.03,138.98c-.13-.06-.26-.05-.3.02-.03.07.04.18.17.24.13.06.26.05.3-.02.03-.07-.04-.18-.17-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m270.18,139.13c-.11-.05-.22-.05-.24,0-.03.05.04.14.15.19.11.05.22.05.24,0,.03-.05-.04-.14-.15-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m269.76,138.26c-.11-.05-.22-.05-.24,0-.03.05.04.14.15.19.11.05.22.05.24,0,.03-.05-.04-.14-.15-.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m278.04,133.93c-.04-.07-.09-.16-.15-.25-.06-.08-.13-.17-.21-.27-.08-.09-.17-.18-.27-.26-.1-.08-.21-.17-.32-.24-.12-.07-.23-.16-.35-.22-.23-.15-.48-.28-.71-.39-.23-.12-.45-.21-.64-.29-.38-.15-.64-.24-.64-.24v.02s.24.11.6.29c.36.19.83.46,1.27.77.22.16.42.33.61.5.09.08.18.16.27.24.08.08.16.15.23.22.07.07.13.14.18.2.06.06.1.12.14.16.07.09.12.15.12.15h.02s-.02-.08-.06-.19c-.02-.06-.04-.13-.09-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m277.65,134.85c-.02-.06-.05-.13-.08-.2s-.08-.14-.12-.22c-.04-.08-.11-.15-.16-.23-.13-.15-.29-.28-.44-.41-.32-.26-.66-.47-.93-.61-.27-.14-.45-.21-.45-.21v.02s.16.1.41.27c.12.09.26.19.4.31.14.11.29.25.43.38.07.07.14.14.2.21.06.08.12.14.18.21.06.07.12.13.17.2.05.07.1.12.15.18.04.06.08.11.12.16.04.05.06.09.09.13.05.07.08.11.08.11h.02s0-.06-.02-.15c0-.04-.02-.1-.04-.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m271.95,136.34c-.05-.05-.12-.09-.19-.15-.07-.05-.15-.11-.23-.15-.09-.05-.18-.1-.28-.14-.1-.04-.21-.08-.32-.11-.11-.03-.22-.06-.33-.09-.11-.02-.22-.05-.34-.07-.11-.02-.22-.03-.33-.04-.21-.02-.41-.02-.59,0-.34.02-.56.08-.56.08v.03s.23-.03.56-.01c.08,0,.17.01.27.02.09.02.19.02.3.04.1.02.21.04.31.07.11.02.21.06.32.09.1.04.21.08.31.12.1.04.2.09.29.13.09.04.18.09.27.12.09.03.17.08.24.11.08.04.15.06.21.09.06.03.12.05.16.07.09.04.15.06.15.06l.02-.02s-.04-.04-.11-.11c-.04-.04-.08-.08-.13-.13Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m278.06,127.29s-3.56,1.4-2.66,5.56c.9,4.16-.53,5.79.34,7.65.87,1.86,6.41,2.73,7.64-1.02,1.23-3.76,1.89-13.03-5.33-12.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "m278.06,127.29s-3.56,1.4-2.66,5.56c.54,2.49.24,4.08.11,5.35.28-.37.63-.68.89-1.05,1.71-2.47,3.7-2.16,4.83-5.53.39-1.17.26-2.42.5-3.6-.9-.62-2.1-.91-3.67-.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m277.37,129.19c-.22,0-.4.1-.4.23s.18.22.4.22c.22,0,.4-.1.4-.23,0-.12-.18-.22-.4-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m278.45,128.51c-.19,0-.34.08-.34.17,0,.09.15.17.34.16.19,0,.34-.08.34-.17,0-.09-.15-.17-.34-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m279.62,129.44c-.19,0-.34.08-.34.17,0,.09.15.17.34.16.19,0,.34-.08.34-.17,0-.09-.15-.17-.34-.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m278.98,139.27c-.22,0-.4.1-.4.23,0,.12.18.22.4.22.22,0,.4-.1.4-.23,0-.12-.18-.22-.4-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m280.06,138.59c-.19,0-.34.08-.34.17s.15.17.34.16c.19,0,.34-.08.34-.17,0-.09-.15-.17-.34-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m281.23,139.52c-.19,0-.34.08-.34.17s.15.17.34.16c.19,0,.34-.08.34-.17,0-.09-.15-.17-.34-.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m277.88,130.51c-.14.01-.25.09-.24.17,0,.08.13.13.27.12.14-.01.25-.09.24-.17,0-.08-.13-.13-.27-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m277.02,131.21c0,.06.11.1.23.09.12-.01.21-.07.21-.13,0-.06-.11-.1-.23-.09-.12.01-.21.07-.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m276.22,130.68c0,.06.11.1.23.09.12-.01.21-.07.21-.13,0-.06-.11-.1-.23-.09s-.21.07-.21.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m279.62,139.88c-.14.01-.25.09-.24.17,0,.08.13.13.27.12.14-.01.25-.09.24-.17,0-.08-.13-.13-.27-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m278.76,140.57c0,.06.11.1.23.09.12-.01.21-.07.21-.13,0-.06-.11-.1-.23-.09s-.21.07-.21.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m277.95,140.04c0,.06.11.1.23.09.12-.01.21-.07.21-.13,0-.06-.11-.1-.23-.09-.12.01-.21.07-.21.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m283.02,131.94c-.07-.04-.16-.09-.26-.14-.1-.04-.2-.08-.32-.12-.12-.03-.24-.06-.37-.09-.13-.01-.26-.04-.4-.04-.14,0-.28-.02-.41-.01-.28,0-.55,0-.81.03-.26.02-.49.05-.7.08-.41.06-.67.13-.67.13v.03s.27-.04.68-.06c.41-.02.95-.04,1.49,0,.27.02.53.07.78.11.12.02.24.05.35.06.11.03.21.05.31.07.1.03.18.05.26.08.08.02.14.05.2.07.11.04.18.06.18.06v-.02s-.04-.05-.13-.12c-.05-.04-.11-.09-.18-.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m283.16,132.93s-.11-.08-.17-.13c-.06-.05-.14-.08-.22-.13-.08-.05-.17-.07-.26-.11-.18-.06-.39-.09-.59-.12-.4-.06-.81-.07-1.11-.04-.3.02-.5.05-.5.05v.03s.2,0,.5.02c.15.01.32.03.5.05.18.02.38.06.57.11.09.03.19.05.28.08.09.04.18.06.26.09.08.03.17.05.24.08.08.03.15.05.22.08.07.03.13.05.18.07.06.02.1.05.14.06.08.04.13.05.13.05l.02-.02s-.03-.04-.09-.11c-.03-.03-.07-.08-.11-.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m279.04,137.14c-.07-.02-.15-.02-.23-.03-.09,0-.18-.02-.28-.01-.1,0-.2,0-.31.02-.11.02-.22.04-.33.07-.11.03-.22.06-.33.1-.11.04-.22.07-.32.12-.11.04-.21.09-.3.13-.19.09-.37.2-.51.29-.28.19-.44.36-.44.36l.02.02s.17-.14.47-.3c.07-.04.16-.08.24-.12.09-.04.18-.08.28-.11.1-.04.2-.07.3-.1.1-.04.21-.06.32-.08.11-.02.22-.04.32-.06.11-.01.21-.02.32-.04.1-.01.2-.02.29-.04.09-.02.18-.02.27-.03.08,0,.16-.02.23-.03.07,0,.13-.01.18-.02.1-.01.16-.02.16-.02v-.03s-.05-.02-.15-.04c-.05-.01-.11-.03-.18-.04Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m295.86,133.43s-.02-.04-.03-.06c-.05-.14-.11-.28-.18-.42-.01-.02-.02-.05-.03-.07-.08-.16-.17-.32-.26-.48-.01-.02-.02-.04-.04-.06-.09-.14-.18-.28-.27-.42-.02-.03-.04-.06-.06-.09-.22-.31-.47-.62-.73-.93-.02-.03-.05-.06-.07-.08-.12-.14-.25-.28-.38-.42,0,0-.02-.02-.02-.03-.14-.15-.29-.31-.44-.46-.02-.02-.03-.03-.05-.05-.14-.14-.28-.28-.42-.42-.01-.01-.03-.03-.04-.04-.34-.34-.69-.67-1.04-1-.07-.07-.14-.14-.21-.2-.06-.06-.13-.12-.19-.19-.13-.13-.26-.25-.39-.38-.04-.04-.08-.08-.12-.12-.1-.1-.2-.2-.3-.3-.04-.04-.07-.07-.11-.11-.13-.13-.25-.26-.36-.39-.02-.03-.05-.05-.07-.08-.1-.11-.19-.21-.28-.32-.03-.04-.06-.07-.09-.11-.11-.13-.21-.26-.3-.39-2.99-4.18-5.49-4.43-5.49-4.43-.19.06-.36.13-.52.21-.05.03-.1.06-.15.08-.11.06-.21.13-.31.2-.05.04-.1.08-.15.12-.09.08-.18.16-.26.24-.04.04-.08.08-.12.13-.09.11-.17.22-.25.34-.02.03-.04.06-.06.09-.09.16-.18.32-.25.5,0,.02-.02.04-.02.06-.06.16-.12.32-.17.48-.01.05-.03.1-.04.16-.04.15-.07.29-.1.45-.01.06-.02.12-.03.17-.02.16-.04.33-.06.5,0,.03,0,.06-.01.1,0,0,0,0,0,0-.31,4.33,2.52,10.93,5.32,13.38,2.77,2.44,7.11,1.25,8.69-1.33.85-1.38.88-2.65.45-3.84,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m287.76,120.48l-2.27,1.1h-.44s-1.51-1.46-1.91-1.83c-.13-.9-.08-1.18-.17-1.57-.52-2.38-.7-1.67-1.27-1.29s-.53.43.03.64c.56.21.34-.36.93,1.98.21.83-.17.39-.15,1.08-.2.6-.36,1.38-.42,1.89l-.72.61-1.98.61s-.03.07,0,.07c.57,0,1.99-.02,2.17-.02.11,0,.66-.39,1.19-.79.1,1.73-.01,2.27.58,1.15,0,0,.04-.65.02-1.61.01-.01.02-.02.04-.03l1.45.47s.67.91,1.09,1.36c.03.03.08,0,.06-.04-.16-.44-.21-1.18-.41-1.5-.13-.21-.79-.57-.79-.57l.76.03s1.14-.41,1.45-.65c.22-.17.63-.73.83-1.01.03-.04-.02-.1-.07-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m287.76,120.48l-2.27,1.1h-.44s-1.51-1.46-1.91-1.83c-.13-.9-.08-1.18-.17-1.57-.48-2.16-.66-1.77-1.12-1.4.58.88.94,1.93.99,3.08,0,.04,0,.08,0,.12.38.64.7,1.28.95,2.05.71.25,1.36.61,1.93,1.12-.04-.16-.09-.3-.15-.4-.13-.21-.79-.57-.79-.57l.76.03s1.14-.41,1.45-.65c.22-.17.63-.73.83-1.01.03-.04-.02-.1-.07-.08Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m293.98,131.21c-.15,0-.27.15-.26.32,0,.17.14.3.29.29.15,0,.27-.15.26-.32,0-.17-.14-.3-.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m294.49,131.92c-.1,0-.17.1-.16.2,0,.11.09.19.19.18.1,0,.17-.1.16-.2s-.09-.19-.19-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m294.74,132.59c-.1,0-.17.1-.16.2,0,.11.09.19.19.19.1,0,.17-.1.16-.2,0-.11-.09-.19-.19-.18Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 265.94,
    y: 126.96,
    width: 3.76,
    height: 16.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 279.94,
    y: 126.96,
    width: 5.29,
    height: 16.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 309.87,
    y: 126.96,
    width: 3.76,
    height: 16.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 264.48,
    y: 138.73,
    width: 50.61,
    height: 5.57
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 264.48,
    y: 128.94,
    width: 50.61,
    height: 5.57
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m274.73,130.8c-.06-.37.78-1.81.78-1.81l2.55.02-5.41-3.09-6.52,1.89h0c-4-1.16-12.78-3.65-15.78-3.84-3.11-.2-8,.88-8,.88,0,0,.32,4.43,1.42,5.28.88.69,16.39,2.63,22.41,3.37l7.69,3.43s4.14-.88,4.9-1.01c.76-.13,1.14-1.43,1.14-1.43l-2.64-.02s-2.43-3.06-2.54-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m274.73,130.8c-.06-.37.78-1.81.78-1.81l2.55.02-5.41-3.09-6.52,1.89h0c-2.48-.72-6.81-1.95-10.45-2.83-.78,2.28-1.17,5.47-1.35,7.84,4.4.6,9.1.34,11.84.67l7.69,3.43s4.14-.88,4.9-1.01c.76-.13,1.14-1.43,1.14-1.43l-2.64-.02s-2.43-3.06-2.54-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m252.53,85.14l-3.41,1.2s1.53.73,2.79,4.7c1.91,6.05,2.3,13.18,2.3,13.18l3.19-5.54-3.34-11.08s-.33-1.47-1.52-2.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 18.11,
    y: 122.95,
    width: 31.55,
    height: 23.61,
    rx: 6.31,
    ry: 6.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m23.12,132.1c-.17-1.69-.92-3.9.02-5.46.08-.13.13-.26.19-.39,1.74-1.67,4.06-2.79,6.4-3.29h13.63c3.48,0,6.31,2.82,6.31,6.31v11c0,3.48-2.82,6.31-6.31,6.31h-18.93c-.93,0-1.81-.21-2.6-.57,1.23-2.22,1.57-4.83,1.62-7.47.04-2.13-.1-4.31-.32-6.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m26.7,200.32c.48-4.78,1.42-13.63,1.42-17.1,0-1.51-1.25-29.57-1.25-35.02,0-4.15,1.7-12.32,2.35-14.35h26.41s-11.59,16.16-11.59,16.16l-4.8,38-7.58,49.76,5.06,3.62c4.21.61,4.4,3.65,4.4,3.65h-17.54c.12-3.27,1.66-7.57,1.66-7.57,0,0,1.17-34.36,1.46-37.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m26.7,200.32c.48-4.78,1.42-13.63,1.42-17.1,0-1.51-1.25-29.57-1.25-35.02,0-4.15,1.7-12.32,2.35-14.35h26.41s-11.59,16.16-11.59,16.16l-2.61,20.65c-.87-.22-1.83-.09-2.54.5-.37.11-.74.31-1.09.61-1.97,1.7-2.83,4.04-3.48,6.5-.91,3.43-2.14,6.77-2.88,10.25-1.71,8-2.18,16.34-3.01,24.46-.44,4.26-1.11,8.86-1.25,13.4-.45,3.86-.18,7.65,1.26,11.38.03.07.06.13.08.2.82,2.89,1.85,5.38,3.77,7.08h-8.7c.12-3.27,1.66-7.57,1.66-7.57,0,0,1.17-34.36,1.46-37.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m32.2,242c2.77-.09,4.52-.6,4.52-.6,4.21.61,4.4,3.65,4.4,3.65h-17.54c-.11-.94.18-2.42.29-3.27.17.03,4.77.34,8.33.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m55.63,133.86c.18,1.33,1.72,13.2,1.93,17.74.22,4.96-1.63,38.56-1.63,38.56l-4.26,47.53,8.14,3.82c4.1.61,4.29,3.54,4.29,3.54h-20.57c-.27-2.57,1.4-6.28,1.89-7.29-.38-5.07-2.04-28.82-.98-38.43.6-5.4.93-13.63.93-13.63l-3.94-44.96,14.2-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m55.63,133.86c.18,1.33,1.72,13.2,1.93,17.74.1,2.19-.21,10-.58,18.02-.64-.21-1.38-.12-2.13.43-6.98,5.09-4.42,14.19-5.21,21.6-1.13,10.66-4.42,20.79-4.19,31.63.1,4.69.39,9.53.99,14.18.38,2.98,1.56,5.53,3.66,7.59h-6.56c-.27-2.57,1.4-6.28,1.89-7.29-.38-5.07-2.04-28.82-.98-38.43.6-5.4.93-13.63.93-13.63l-3.94-44.96,14.2-6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m29.22,133.86h26.41c.18,1.33,1.72,13.2,1.93,17.74.09,2.08,1.13,9.33.79,16.89-4.14.47-11.54.76-15.13.51l-.48-8.23-1,8.23c-6.58,0-11.13.1-15.81-1.1-.31-7.71.94-17.03.94-19.69,0-4.15,1.7-12.32,2.35-14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m46.71,169.05c-.33-.01-3.21-.03-3.5-.05l-.5-8.02c.23-1.71,4,7.96,4,8.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.22,133.86h26.41c.09.69.55,4.23,1,8.11-8.21-.05-19.7-1.02-25.13,6.55-1.7,2.37-2.29,5.33-3.17,8.07-.89,2.77-1.89,5.37-2.45,8.2.05-6.94.99-14.28.99-16.59,0-4.15,1.7-12.32,2.35-14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m56.33,242.45c1.35,0,2.45-.39,3.3-1.03l.18.09c4.1.61,4.29,3.54,4.29,3.54h-20.57c-.11-.94.09-2.58.23-3.42.34.06,12.56.82,12.56.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m61.46,124.75l4.34,22.03c.34.84.66,1.7.77,2.2.25,1.16.22,4.07.29,4.73,0,.1,0,.2-.04.3h.05s-.73,5.26-.73,5.26l-1.19,2.18c-.79-.33-.57-1.31-.57-1.31l.29-1.19-1.72,3.17c-.9-.3-.61-1.3-.61-1.3l.05-.16-.47.87c-.79-.33-.57-1.31-.57-1.31l.6-2.42v-.37s-1.72,1.98-1.72,1.98c-.72-.48-.31-1.39-.31-1.39l1.04-2.26.28-1.58c-.08-.75-.39-3.37-.66-4.4-.24-.94.34-3.18.61-4.14-1.7-3.85-4.51-10.39-5.28-13.29-.48-1.81-1.41-7.89-1.41-7.89l-2.48-30.76,9.46.55v30.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m61.46,104.34c-1.29.89-2.19,2.36-2.19,4.42,0,4.36-2.14,8.39-2.24,12.77-.11,4.86,1.7,9.93,3.21,14.49,2.27,6.84,6.77,15.85,2.09,22.63-.55.79-.84,1.58-.95,2.33-.13-.37-.04-.75-.04-.75l.6-2.42v-.37s-1.72,1.98-1.72,1.98c-.72-.48-.31-1.39-.31-1.39l1.04-2.26.28-1.58c-.08-.75-.39-3.37-.66-4.4-.24-.94.34-3.18.61-4.14-1.7-3.85-4.51-10.39-5.28-13.29-.48-1.81-1.41-7.89-1.41-7.89l-2.48-30.76,9.46.55v10.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m20.53,101.71l2.4-9.78c.5-1.21,2.01-4.05,5.47-4.96l13.18-4.62c.01-.09,1.13-.09,1.14,0l13.35,4.67c2.65.75,4.12,2.65,4.87,3.99l.64,1.46h-.02s.76,9.53.76,9.53c-.41.14-2.84,1.1-5.25,1.86.21,1.68.3,2.9.3,2.9v.38c0,2.07-1.05,3.88-2.59,4.83l.14,15.35,1.65,14.21h-29.33s3.42-14.21,3.42-14.21l-1.05-22.57c-4.66-.58-8.53-2.87-9.1-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m29.64,105.05c.58.06,1.08.16,1.29.34,1.08.88.86,4.4,1.01,5.94.54,5.37,1.05,10.74.78,16.15-.21,4.21-1.15,8.38-.32,12.58.1.51.23,1.01.37,1.49h-5.52s3.42-14.21,3.42-14.21l-1.03-22.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m28.4,86.98l2.57-.9c-.11.41-.15.83-.1,1.25-4.67,3.37-4.71,8.69-6.2,14.03-.21.75-.04,1.62.39,2.31-2.43-.85-4.17-1.84-4.53-1.96l2.4-9.78c.5-1.21,2.01-4.05,5.47-4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m42.73,82.36l12.52,4.38c-.45,3.56-12.97,6.96-18.97,3.74-1.24-.67-5.72-2.91-6.2-4.09l11.5-4.03c.01-.09,1.13-.09,1.14,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m42.75,55.05c4.74,0,11.01,3.44,10.81,11.01-.31,11.28-6.45,13.25-12.86,11.64-3.52-.89-8.5-5.69-7.9-12.82.38-4.55.1-9.82,9.95-9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m42.64,64.88l7.68.29c1.05.04,1.88.92,1.85,1.98l-.13,4.98c-.09,3.57-1.73,6.97-4.59,9.1-4.88,3.62-8.57.05-10.28-4.41-.38-1-.15-4.38.16-7.31.28-2.7,2.6-4.72,5.31-4.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m47.57,75.98l-.14,9.89c-.07,2.75-2.15,5.56-4.9,5.49-2.74-.07-5.11-3-5.04-5.74l.14-9.89,9.93.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m47.49,81.17l-.02.89s-3.68,1.95-6.89-1.58c0,0,3.76,2.39,6.91.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m66.32,153.2s-.18,3.53-.88,4.12c-.71.59-1.07-.53-1.07-.53,0,0,.36-2.29-.32-4.35-.68-2.06,0-4.24,0-4.24l2.27,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m50.19,165.69c2.1-.06,8.22-.62,8.22-.62l-.07,3.41c-8.06,1.04-15.13.51-15.13.51l-.41-3.46s5.59.21,7.39.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m42.21,165.07l-.48,3.92c-14.29,1.1-16.19-1.31-16.19-1.31v-3.69c5.13,2.23,16.66,1.08,16.66,1.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m50.19,84.52l5.06,1.76s-.2,13.55-3.08,20.24c-6.61,15.41-22.43,24.43-22.43,24.43l.58-6.34c21.68-15.26,19.87-40.1,19.87-40.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 39.8,
    y: 126.17,
    width: 35.19,
    height: 1.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m56.48,105.7h30.76c.41,0,.71.39.6.78l-5.2,20c-.18.7-.81,1.19-1.53,1.19h-30.04s4.8-21.48,4.8-21.48c.06-.28.32-.49.61-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m57.38,106.2h29.88c.4,0,.69.38.59.76l-5.05,19.54c-.18.68-.79,1.16-1.49,1.16h-29.18s4.66-20.98,4.66-20.98c.06-.28.31-.48.59-.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "m29.67,104.82l-1.4,14.29,13.43,6.53,4.39-.92,5.65.25-.31,1.2c-.51-.02-1.47-.03-1.92.06-1.19.23-.77,1.11-.77,1.11,0,0,2.41.26,4.72.32,1.05.03,4.54,0,4.54,0l-3.79,2.93-5.51,1.23s-19.94-5.44-25.92-7.16c-1.65-.48-2.76-2.01-2.69-3.73.16-4.08.54-11.81,1.65-19.04l7.94,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m29.67,104.82l-.23,2.32c-.53.2-.99.61-1.31,1.32-2.37,5.32-5.7,13.14-.75,17.52-1.88-.52-3.49-.98-4.61-1.3-1.65-.48-2.76-2.01-2.69-3.73.16-4.08.54-11.81,1.65-19.04l7.94,2.92Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m39.78,54.05c2.45,1.41,3.03,4.99,1.29,8-1.73,3-5.12,4.29-7.57,2.88-2.45-1.41-3.03-4.99-1.29-8,1.73-3,5.12-4.29,7.57-2.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m102.39,71.61l-6.64,1.24s2.31,2.4,4.39,1.92c2.08-.48,2.25-3.16,2.25-3.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m267.78,75.46s-3.25,1.13-5.87.82c0,0,1.23,1.71,3.39,1.43,2.15-.29,2.48-2.24,2.48-2.24Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvmcImage);
export default __webpack_public_path__ + "static/media/evmcImage.7cca0f5c28a0a24d313f39e4d2361570.svg";
export { ForwardRef as ReactComponent };